<template>
  <section class="embed-grant-chart-1">
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 595.3 594">
      <g
        @mouseover="Education_Career_Readiness = true"
        @mouseout="Education_Career_Readiness = false"
      >
        <path
          :class="['fill', { inactive: !this.Education_Career_Readiness }]"
          d="M190.4,297.9l-157.3-.2c.3,144.1,117.1,261,261.3,261.2l.2-157.3c-57.4,0-103.9-46.4-104.3-103.7Z"
        />
        <path
          class="animate--sparkle"
          d="M186.8,446.5c-.6-1-.6-2.2,0-3.1.2-.3.1-.7-.1-.9s-.6-.3-.9-.1c-1,.6-2.2.6-3.1,0-.3-.2-.7-.1-.9.1s-.3.6-.1.9c.6,1,.6,2.2,0,3.1-.2.3-.1.7.1.9s.6.3.9.1c1-.6,2.2-.6,3.1,0h0c.3.2.7.1.9-.1s.3-.6.1-.9ZM184.2,446.1s0,0,0,0c-.7,0-1.2-.5-1.2-1.2,0,0,0,0,0,0,0-.7.5-1.2,1.2-1.2,0,0,0,0,0,0,.7,0,1.2.5,1.2,1.2,0,0,0,0,0,0,0,.7-.5,1.2-1.2,1.2Z"
        />
        <path
          d="M188.1,456.8l-.7-.7c-.4-.4-.4-1,0-1.4l.7-.7c.3-.3.3-.7,0-.9s-.7-.3-.9,0l-.7.7c-.4.4-1,.4-1.4,0l-.7-.7c-.3-.3-.7-.3-.9,0s-.3.7,0,.9l.7.7c.4.4.4,1,0,1.4l-.7.7c-.3.3-.3.7,0,.9s.7.3.9,0l.7-.7c.4-.4,1-.4,1.4,0l.7.7c.3.3.7.3.9,0s.3-.7,0-.9Z"
        />
        <path
          d="M132.7,394.3c.2-.2.3-.6.1-.9-.6-1-.6-2.2,0-3.1.2-.3.1-.7-.1-.9s-.6-.3-.9-.1c-1,.6-2.2.6-3.1,0-.3-.2-.7-.1-.9.1s-.3.6-.1.9h0c.6,1,.6,2.2,0,3.1-.2.3-.1.7.1.9s.6.3.9.1c1-.6,2.2-.6,3.1,0,.3.2.7.1.9-.1ZM130.2,393s0,0,0,0c-.7,0-1.2-.5-1.2-1.2,0,0,0,0,0,0,0-.7.5-1.2,1.2-1.2,0,0,0,0,0,0,.7,0,1.2.5,1.2,1.2,0,0,0,0,0,0,0,.7-.5,1.2-1.2,1.2Z"
        />
        <path
          style="animation-delay: 1s"
          class="animate--sparkle"
          d="M122,391.5l-.7-.7c-.4-.4-.4-1,0-1.4l.7-.7c.3-.3.3-.7,0-.9s-.7-.3-.9,0l-.7.7c-.4.4-1,.4-1.4,0l-.7-.7c-.3-.3-.7-.3-.9,0s-.3.7,0,.9l.7.7c.4.4.4,1,0,1.4l-.7.7c-.3.3-.3.7,0,.9s.7.3.9,0l.7-.7c.4-.4,1-.4,1.4,0l.7.7c.3.3.7.3.9,0s.3-.7,0-.9Z"
        />
        <path
          d="M134,477.7l-36.4-36.4c-.3-.3-.7-.3-.9,0s-.3.7,0,.9l36.4,36.4c.3.3.7.3.9,0s.3-.7,0-.9Z"
        />
        <path
          d="M166.9,408.3c.2.2.7.2.9,0l14.6-14.6c.2-.2.2-.7,0-.9s-.7-.2-.9,0l-14.6,14.6c-.2.2-.2.7,0,.9Z"
        />
        <path
          d="M176,424c.1.1.3.2.5.2l11.4-.3c.4,0,.6-.3.6-.7,0-.4-.3-.6-.7-.6l-11.4.3c-.4,0-.6.3-.6.7,0,.2,0,.3.2.4Z"
        />
        <path
          d="M172.3,415.3c0,0,0,.1.1.2.2.2.5.2.7.1l13.3-6.1c.3-.1.5-.5.3-.8-.1-.3-.5-.5-.8-.3l-13.3,6.1c-.3.1-.5.5-.3.8Z"
        />
        <path
          d="M151.2,398.9c0,.2,0,.3.2.5s.3.2.4.2c.4,0,.6-.3.7-.6l.3-11.4c0-.4-.3-.6-.6-.7-.4,0-.6.3-.7.6l-.3,11.4Z"
        />
        <path
          d="M159.7,402.2c-.1.2,0,.5.1.7s.1,0,.2.1c.3.1.7,0,.8-.3l6.1-13.3c.1-.3,0-.7-.3-.8-.3-.1-.7,0-.8.3l-6.1,13.3Z"
        />
        <path
          d="M174.3,449.7l-2-2,2.1-2.1c.2-.2.2-.6,0-.8l-2.1-2.1,3.1-3.1c.1-.1.2-.3.2-.4,0-.2-.1-.3-.2-.4-2.5-1.7-5.2-4.3-7.7-6.7-.8-.8-1.6-1.5-2.4-2.3,1.1-2.1,1.6-4.4,1.6-6.8h0c0-3.9-1.5-7.6-4.3-10.3h0c-4.6-4.6-11.5-5.5-17-2.7-.7-.7-1.4-1.5-2.1-2.2-2.4-2.6-5-5.2-6.7-7.7,0-.1-.2-.2-.4-.2-.2,0-.3,0-.4.2l-3,3-2.1-2c-.2-.2-.6-.2-.8,0l-2.1,2.1-2-2c-.2-.2-.6-.2-.8,0l-28.2,28.2c-.2.2-.2.6,0,.8l21.9,21.9c.1.1.3.2.4.2h0s4.3,0,4.3,0v4.3c0,.2,0,.3.1.4l21.9,21.9c.2.2.6.2.8,0h0s28.2-28.2,28.2-28.2c.2-.2.2-.6,0-.8ZM146.3,468c.2.2.5.1.7,0l24.4-24.4,1.7,1.7-27.4,27.4-20.4-20.4c5.5.8,9.6,4.9,13.8,9.2,2.3,2.3,4.6,4.7,7.2,6.5ZM130.2,402.2l1.7,1.7-24.4,24.4c-.2.2-.2.5,0,.7,1.8,2.6,4.2,4.9,6.5,7.2,4,4,7.8,7.7,9,12.7v1.1c.1,0-20.2-20.3-20.2-20.3l27.4-27.4ZM119.1,451l-21.3-21.3,27.4-27.4,1.6,1.6-25.4,25.4c-.2.2-.2.6,0,.8l20.9,20.9h-3.3ZM133.4,442.7l.3.3c.3.3.7.4,1.2.3l1.6-.5s0,0,0,0l1.1,1.1,3.4-3.4-2.7-2.7.7-.7-.8-.8-.7.7-3-3-3.4,3.4,1.1,1.1s0,0,0,0l-.5,1.6c-.1.4,0,.9.3,1.2l.6.6-8.4,8.4c-.1-1-.3-2-.6-2.9l-.3-.7c-1.4-3.7-4.3-6.9-7.2-9.8s-1-.9-1.4-1.4h0c-2.2-2.1-4.4-4.3-6.1-6.7l24.9-24.9h0s2.5-2.5,2.5-2.5c1.8,2.4,4.1,4.9,6.4,7.3.6.7,1.2,1.3,1.9,2-.9.5-1.7,1.2-2.5,1.9-2.8,2.7-4.3,6.3-4.4,10.2,0,2.5-.6,5-1.7,7.4l-.6,1.3c-.3.7-.2,1.6.4,2.2l2.7,2.7,10.6-10.7.8-5.3,1.3.2-.7,4.9,4.9-.7.2,1.3-5.7.9h0c0,0-10.4,10.3-10.4,10.3l.9.9h0c0,0,1.5,1.6,1.5,1.6.6.6,1.4.7,2.2.4l1.3-.6c2.4-1,4.9-1.6,7.5-1.7,3.8-.1,7.3-1.6,9.9-4.3s1.5-1.7,2.1-2.6c.7.7,1.5,1.4,2.2,2.1h0c2.4,2.3,4.9,4.7,7.3,6.4l-27.4,27.4c-2.4-1.7-4.5-3.9-6.7-6.1-4.3-4.4-8.7-8.9-14.9-9.6l8.4-8.4ZM145.6,477.5l-21.3-21.3v-3.3s20.9,20.9,20.9,20.9c.2.2.6.2.8,0l25.4-25.4,1.6,1.6-27.4,27.4Z"
        />
        <path
          d="M190.4,297.9l-157.3-.2c.3,144.1,117.1,261,261.3,261.2l.2-157.3c-57.4,0-103.9-46.4-104.3-103.7Z"
          class="inactive"
        />
      </g>
      <g
        @mouseover="Sport_Physical_Activity = true"
        @mouseout="Sport_Physical_Activity = false"
      >
        <path
          :class="['fill', { inactive: !this.Sport_Physical_Activity }]"
          d="M295.1,401.6l.2,157.3c144.1-.7,260.6-117.8,260.4-262.1l-157.3.2c0,57.4-46.1,104-103.4,104.5Z"
        />
        <path
          class="animate--sparkle"
          d="M443.2,387.8c-1,.6-2.2.6-3.1,0-.3-.2-.7-.1-.9.1s-.3.6-.1.9c.6,1,.6,2.2,0,3.1-.2.3-.1.7.1.9s.6.3.9.1c1-.6,2.2-.6,3.1,0,.3.2.7.1.9-.1s.3-.6.1-.9c-.6-1-.6-2.2,0-3.1h0c.2-.3.1-.7-.1-.9s-.6-.3-.9-.1ZM442.8,390.4s0,0,0,0c0,.7-.5,1.2-1.2,1.2,0,0,0,0,0,0-.7,0-1.2-.5-1.2-1.2,0,0,0,0,0,0,0-.7.5-1.2,1.2-1.2,0,0,0,0,0,0,.7,0,1.2.5,1.2,1.2Z"
        />
        <path
          d="M419.9,441.2c1.2-1.2,1.2-3,.1-4.1s-2.9-1-4.1.1-1.2,3-.1,4.1,2.9,1,4.1-.1ZM416.8,438.1c.7-.7,1.7-.7,2.4,0s.6,1.7,0,2.4-1.7.7-2.4,0-.6-1.7,0-2.4Z"
        />
        <path
          style="animation-delay: 1s"
          class="animate--sparkle"
          d="M415.9,432.9l.7-.7c.4-.4,1-.4,1.4,0l.7.7c.3.3.7.3.9,0s.3-.7,0-.9l-.7-.7c-.4-.4-.4-1,0-1.4l.7-.7c.3-.3.3-.7,0-.9s-.7-.3-.9,0l-.7.7c-.4.4-1,.4-1.4,0l-.7-.7c-.3-.3-.7-.3-.9,0s-.3.7,0,.9l.7.7c.4.4.4,1,0,1.4l-.7.7c-.3.3-.3.7,0,.9s.7.3.9,0Z"
        />
        <path
          d="M433.9,392.4c.5-.5.5-1.4,0-1.9s-1.4-.5-1.9,0-.5,1.4,0,1.9,1.4.5,1.9,0Z"
        />
        <path
          d="M451.5,398.1l-3.4,3.4.7,10h-1.7c0-.1-3.3-3.4-3.3-3.4-.5-.5-1.1-.7-1.7-.7h0s-1.9,0-1.9,0c-.7,0-1.3-.6-1.3-1.3v-1.7c0-.7-.3-1.4-.9-1.9l-6.3-5.1c-.9-.7-2.2-.9-3.3-.4-2,1-3.8,2.1-5.6,3.5l-2.3-2.3c.1,0,.2-.2.4-.2,0,0,0,0,.1,0,.2-.2.2-.5,0-.7-.2-.3-.5-.3-.8-.2-.3.2-1.1.7-1.1.8-1.5,1.1-2.7,2.3-3.8,3.8,0,0-.6.8-.8,1.1-.2.3,0,.6.2.8.3.2.6,0,.8-.2,0-.1.2-.2.2-.4l2.3,2.3c-1.4,1.7-2.6,3.6-3.5,5.5-.5,1.1-.4,2.4.4,3.3l5.1,6.3c.5.6,1.1.9,1.9.9,0,0,0,0,0,0h1.7c.7,0,1.3.6,1.3,1.3v1.9c0,.6.2,1.2.7,1.7l18.2,18.2c-4.5.5-7.8.6-7.8.7-1.5,0-3.1-.2-4.6-.2-1.7,0-1.5,1.7-1.5,2.9,0,1.4,0,2.8.2,4.2.2,1.3.7,2.2,2.2,2.2-.2,1.3-.4,2.7-.6,4-.2,1.2-.4,2.6-.9,3.7-1,2.2-3.7,2.1-5.8,1.8-2.2-.3-4.4-1-5.9,1.1-.3.5-.6,1-.7,1.6-.2.5-.4,1.2-.2,1.8.2.5.7,1,1.1,1.5.4.6.9,1.2,1.4,1.8,2,2.3,4.2,4.3,6.3,6.4l.5,1.5c.2,1.2.5,2.3,1,3.3.2.6.5,1.1.8,1.6.3.6.5,1,1.2,1.2,2.1.4,4.3-.1,6.2-1.1,0-.5-.3-1-.3-1.5.5.1.9.6,1.3.8,1-.7,1.9-1.4,2.8-2.2,0-.5-.3-.9-.4-1.5.5,0,.9.4,1.3.6,1-1,1.9-1.9,2.9-2.9-.2-.4-.3-.9-.5-1.3.5,0,.9.3,1.4.4.5-.1,1-.9,1.3-1.2.4-.4.8-.8,1.3-1.3.4-.4.9-.8,1.2-1.3h0s8.8-8.7,8.8-8.7c.4-.4.9-.9,1.3-1.3.4-.4.9-.9,1.3-1.3.4-.4,1-.9,1.3-1.4.3-.5.4-1,.6-1.5.2-.5.3-1.2.7-1.5.4.2.6.5.9.8.3,0,1.2-1.1,1.4-1.3.5-.5,1.1-1,1.6-1.6.4-.5.4-1.2.6-1.7,0-.4.2-1.5.7-1.6.4.2.6.6,1,.9.5-.6.9-1.2,1.3-1.8.4-.5.8-1.1,1-1.7.2-.6.1-1.3.2-2,0-.4,0-1.5.4-1.8.4.1.7.5,1.2.7.6-1.3,1.2-2.6,1.6-4,.2-.6,0-1.2,0-1.9,0-.8-.1-1.5-.2-2.3.5.2.9.3,1.4.5.3-2.1.4-4.4-.6-6.3-.4-.8-1-1.6-1.8-2.2-.4-.3-.8-.6-1.2-.8-.4-.2-1-.6-1.5-.5-.3.2-.3.5-.6.7-.6-.1-1.5-.4-2.1-.2-.7.2-.9,1-1.3,1.6-.1.2-.2.4-.3.6l-1.8-1.8c.4-.3.7-.6,1-.9,4.1-4.1,4.1-10.7,0-14.8-3.2-3.2-8.1-3.9-12-2l-1.9-1.9-.8-11.8ZM452,411.3l1.1,1.1c-.6.4-1.2.9-1.8,1.4s-.6.7-.9,1c-.3.4-.6.9-.6.9,0,0,0,0,0,.1l-1.2-1.2,3.5-3.5ZM416.5,401.9c.9-1.2,1.9-2.2,3.1-3.1l2.4,2.4c-1.1,1-2.2,2-3.1,3.1l-2.4-2.4ZM415.9,413.3c-.5-.6-.6-1.4-.2-2.1,1.4-2.9,3.2-5.5,5.5-7.7s4.9-4.1,7.7-5.5c.7-.3,1.5-.2,2.1.2l3.5,2.9-15.7,15.7-2.8-3.5ZM421.8,420.1c-.3,0-.6-.2-.8-.5l-1.6-1.9,15.9-15.9,1.9,1.6c.2.2.4.5.5.8l-15.9,15.9ZM426.2,424.4v-1.9c0-1.3-1.1-2.4-2.4-2.4h-.4s14.4-14.4,14.4-14.4v.4c0,1.3,1.1,2.4,2.4,2.4h1.9c.3,0,.7.1.9.4l2.4,2.4-6.6-.4-3.4,3.4,12,.8,1.9,1.9c-1.7,3.8-1,8.5,2.1,11.7s8.8,4,12.9,1.5l2.1,2.1c-.6,1-1.3,1.9-1.9,2.8-2,2.7-4.1,5.1-7.2,6.7-3.8,1.2-8.1,2-11.8,2.4l-18.9-18.9c-.2-.2-.4-.6-.4-.9ZM473.4,437.3c.3-.8.5-1.6.9-2.4,0,1,0,2-.3,3-1.4,6.2-4.7,11.3-9,15.8-2.6,2.8-5.4,5.4-8.1,8.2-.6.6-1.2,1-1.9,1.3-3.8,1.8-6.9,4.3-8.3,8.5-.2.4-.4.8-.8,1.1-1.3,1.3-2.7,2.7-4,4-1.5,1.5-2.9,3-4.6,4.2-1.6,1.2-3.4,2.1-5.4,2.3-.7.1-1.5.1-2.2,0-.3,0-.6-.2-.5-.6.1,0,.3-.1.4-.1,2.4-.8,4.4-2.3,6-4.3,1-1.3,1.7-2.8,2.4-4.3,1.3-2.9,3.2-5.4,5.8-7.3,2.7-1.9,5.5-3.7,8.2-5.5,2.4-1.6,4.9-3.2,7.1-5,2.8-2.3,5.4-4.9,7.7-7.8,2.7-3.4,5-7.1,6.6-11.2ZM465.4,414.6c3.7,3.7,3.7,9.6,0,13.3-3.7,3.7-9.6,3.7-13.3,0s-3.7-9.6,0-13.3c3.7-3.7,9.6-3.7,13.3,0Z"
        />
        <path
          d="M454.5,417.2l1.8,3.6-2.9,2.9c0,0,0,.3,0,.4,0,0,.1,0,.2,0l4.1-.6,1.9,3.7c0,.1.2.2.3.1,0,0,.1-.1.1-.2l.6-4.1,4.1-.6c.1,0,.2-.2.2-.3,0,0,0-.2-.1-.2l-3.7-1.9.6-4.1c0-.1,0-.3-.2-.3,0,0-.2,0-.2,0l-2.9,2.9-3.6-1.8c-.1,0-.2,0-.3,0,0,0,0,.2,0,.3Z"
        />
        <path
          d="M295.1,401.6l.2,157.3c144.1-.7,260.6-117.8,260.4-262.1l-157.3.2c0,57.4-46.1,104-103.4,104.5Z"
          class="inactive"
        />
      </g>
      <g @mouseover="Healthy_Diet = true" @mouseout="Healthy_Diet = false">
        <path
          :class="['fill', { inactive: !this.Healthy_Diet }]"
          d="M398.7,297.5h157.3c-.5-144.1-117.4-260.8-261.7-260.8v157.3c57.4,0,103.9,46.3,104.4,103.5Z"
        />
        <path
          d="M418.5,122.2c-1.2-1.2-3-1.2-4.1-.1s-1,2.9.1,4.1,3,1.2,4.1.1,1-2.9-.1-4.1ZM415.4,125.3c-.7-.7-.7-1.7,0-2.4s1.7-.6,2.4,0,.7,1.7,0,2.4-1.7.6-2.4,0Z"
        />
        <path
          class="animate--sparkle"
          d="M463.4,187.4c-1.2-1.2-3-1.2-4.1-.1s-1,2.9.1,4.1,3,1.2,4.1.1,1-2.9-.1-4.1ZM460.2,190.5c-.7-.7-.7-1.7,0-2.4s1.7-.6,2.4,0,.7,1.7,0,2.4-1.7.6-2.4,0Z"
        />
        <path
          d="M453,145c.2.2.7.2.9,0l14.6-14.6c.2-.2.2-.7,0-.9s-.7-.2-.9,0l-14.6,14.6c-.2.2-.2.7,0,.9Z"
        />
        <path
          d="M462,160.7c.1.1.3.2.5.2l11.4-.3c.4,0,.6-.3.6-.7,0-.4-.3-.6-.7-.6l-11.4.3c-.4,0-.6.3-.6.7,0,.2,0,.3.2.4Z"
        />
        <path
          d="M458.4,152.1c0,0,0,.1.1.2.2.2.5.2.7.1l13.3-6.1c.3-.1.5-.5.3-.8-.1-.3-.5-.5-.8-.3l-13.3,6.1c-.3.1-.5.5-.3.8Z"
        />
        <path
          d="M437.3,135.6c0,.2,0,.3.2.5s.3.2.4.2c.4,0,.6-.3.7-.6l.3-11.4c0-.4-.3-.6-.6-.7-.4,0-.6.3-.7.6l-.3,11.4Z"
        />
        <path
          d="M445.7,138.9c-.1.2,0,.5.1.7s.1,0,.2.1c.3.1.7,0,.8-.3l6.1-13.3c.1-.3,0-.7-.3-.8-.3-.1-.7,0-.8.3l-6.1,13.3Z"
        />
        <path
          d="M473.1,188.4l-.7-.7c-.4-.4-.4-1,0-1.4l.7-.7c.3-.3.3-.7,0-.9s-.7-.3-.9,0l-.7.7c-.4.4-1,.4-1.4,0l-.7-.7c-.3-.3-.7-.3-.9,0s-.3.7,0,.9l.7.7c.4.4.4,1,0,1.4l-.7.7c-.3.3-.3.7,0,.9s.7.3.9,0l.7-.7c.4-.4,1-.4,1.4,0l.7.7c.3.3.7.3.9,0s.3-.7,0-.9Z"
        />
        <path
          style="animation-delay: 1s"
          class="animate--sparkle"
          d="M409.2,125.9l-.7-.7c-.4-.4-.4-1,0-1.4l.7-.7c.3-.3.3-.7,0-.9s-.7-.3-.9,0l-.7.7c-.4.4-1,.4-1.4,0l-.7-.7c-.3-.3-.7-.3-.9,0s-.3.7,0,.9l.7.7c.4.4.4,1,0,1.4l-.7.7c-.3.3-.3.7,0,.9s.7.3.9,0l.7-.7c.4-.4,1-.4,1.4,0l.7.7c.3.3.7.3.9,0s.3-.7,0-.9Z"
        />
        <path
          d="M433.2,214.6l-10.9-10.9c5.2,1.5,10.3,1.5,15.2.2,5.5-1.5,10.8-4.7,15.8-9.7s.3-.8,0-1.1l-8.7-8.7,10.6-1.3c2-.2,3.8-1.1,5.2-2.5s2.1-2.9,2.5-4.7v-.3c0,0,6.7,1.9,6.7,1.9.3,0,.6,0,.8-.3.2-.3.2-.6,0-.9l-2.5-4.5.7-5.1c0-.2,0-.5-.2-.7s0,0-.2-.1c-.3-.2-.6-.1-.9,0l-5.5,4.1-.2-.3c-.4-.6-.8-1.2-1.3-1.7s-.9-.8-1.5-1.2c-2.1-1.3-4.5-1.7-6.9-1.1l-4.3,1.1-2.9.6c.9-2.6.9-5.4.1-8,.1.1.3.2.5.3.4.2.9.4,1.4.4,0,0,.1,0,.2,0,.2,0,.4,0,.7,0,0,0,0,0,.1,0,.2,0,.4,0,.6-.2.1,0,.2,0,.4-.1t0,0s0,0,0,0c0,0,.1,0,.2,0,.3,0,.5-.2.7-.4,0,0,0,0,0,0t0,0c0-.3-.2-.6-.3-.8,0,0,0-.1,0-.2t0,0c-.1-.3-.3-.6-.5-.9,0,0,0,0,0,0-.1-.2-.3-.4-.4-.5h0s0,0-.1-.1c-.4-.3-.8-.5-1.3-.7-1-.3-2-.2-3,.4-.1,0-.2.1-.3.2-.5-.9-1.2-1.8-2-2.5-2-2-4.5-3.2-7-3.6,2-1.5,3.1-4.1,2.8-6.5-.2-1.3-.8-2.6-1.8-3.6s-1.9-1.4-3-1.7h-.4c0,0,0-.3,0-.3,0,0,0-.2,0-.2,0-.6-.2-1.2-.4-1.8l-1.3-2.4c-.2-.3-.5-.6-.7-.8-1.2-1.2-2.7-2-4.3-2.3,0,0-.2,0-.2,0-.9-.2-2.2,0-2.2,0-2.4.3-4.6,1.7-5.9,3.7v.2c-.1,0-.3,0-.3,0-1.6-.5-3.4-.4-4.9.3-1.7.8-3.2,2.2-4.2,4-1,1.8-1.2,3.7-.7,5.3.3.8.7,1.5,1.3,2.1s1,.8,1.6,1.2c1.3.7,2.9,1,4.4.8h.2s0,.1,0,.1c1.6,2.9,1.7,4.7,1.5,6.6v.6c0,0-11-10.9-11-10.9-.3-.3-.8-.3-1.1,0-6.3,6.3-9.8,13.2-10.5,20.7-.3,3.4,0,6.8.9,10.2l-12.2-12.2c-.2-.2-.7-.2-.9,0s-.2.7,0,.9l14.4,14.4c0,0,.2.2.2.3l23,23s0,0,.1,0l13.3,13.3c.2.2.7.2.9,0s.2-.7,0-.9ZM444,169.2l4.2-.8.6,3.2,1.6-.3-.6-3.3,2.6-.7c2-.5,4-.2,5.7.9.4.3.9.6,1.2,1,1,1,1.7,2.3,2,3.8.4,2.3-.3,4.8-2,6.4s-2.6,1.9-4.3,2.1l-9.5,1.1-.5-2.9-1.6.3.5,2.8h-.7c-1.9-1.8-4.5-4.4-7.2-7.1,2-.6,4.1-1.7,5.7-3.3s1.8-2.1,2.4-3.3ZM440.5,155.3c4.4,4.4,4.4,11.6,0,16s-3.8,2.7-5.9,3.1c-6.5-6.5-13.2-13.2-13.2-13.2.4-2.2,1.4-4.2,3.1-5.9,4.4-4.4,11.6-4.4,16,0ZM416.2,148.4l-.2-.4h.4c1.2-.2,2.4-.1,3.5.2h.2s0,.2,0,.2c.4,1.2.5,2.5.4,3.8h1.6c0-.8,0-1.7-.1-2.6v-.6c0,0,.4.3.4.3.3.2.5.3.8.5l.4.2c.6.4,1.3.8,2,1.1h.3c0,.1-.1.4-.1.4-.2.4-.4.7-.6,1.1-.6.4-1.2.9-1.8,1.5-1.6,1.6-2.7,3.6-3.3,5.7l-2.7-2.7v-.5c.5-2.3.8-4.5-1.1-8.2ZM420.5,201.5l-24-24h0c-2.2-6.2-4-18.4,7.7-30.8l.2-.2,47.2,47.2-.2.2c-9.4,9-19.8,11.5-30.9,7.6h0Z"
        />
        <path
          d="M421.6,211.6l-36.4-36.4c-.3-.3-.7-.3-.9,0s-.3.7,0,.9l36.4,36.4c.3.3.7.3.9,0s.3-.7,0-.9Z"
        />
        <path
          d="M398.7,297.5h157.3c-.5-144.1-117.4-260.8-261.7-260.8v157.3c57.4,0,103.9,46.3,104.4,103.5Z"
          class="inactive"
        />
      </g>
      <g @mouseover="Land_Nature = true" @mouseout="Land_Nature = false">
        <path
          :class="['fill', { inactive: !this.Land_Nature }]"
          d="M294.8,193.2V35.9c-144.2.5-260.8,117.5-260.8,261.7h157.3c0-57.4,46.3-104,103.5-104.4Z"
        />
        <path
          style="animation-delay: 1s"
          class="animate--sparkle"
          d="M170.2,136.1c-.3-.2-.7-.1-.9.1s-.3.6-.1.9c.6,1,.6,2.2,0,3.1-.2.3-.1.7.1.9s.6.3.9.1c1-.6,2.2-.6,3.1,0,.3.2.7.1.9-.1s.3-.6.1-.9c-.6-1-.6-2.2,0-3.1h0c.2-.3.1-.7-.1-.9s-.6-.3-.9-.1c-1,.6-2.2.6-3.1,0ZM172.9,138.7s0,0,0,0c0,.7-.5,1.2-1.2,1.2,0,0,0,0,0,0-.7,0-1.2-.5-1.2-1.2,0,0,0,0,0,0,0-.7.5-1.2,1.2-1.2,0,0,0,0,0,0,.7,0,1.2.5,1.2,1.2Z"
        />
        <path
          class="animate--sparkle"
          d="M133.3,137.5c1-.6,2.2-.6,3.1,0,.3.2.7.1.9-.1s.3-.6.1-.9c-.6-1-.6-2.2,0-3.1h0c.2-.3.1-.7-.1-.9s-.6-.3-.9-.1c-1,.6-2.2.6-3.1,0-.3-.2-.7-.1-.9.1s-.3.6-.1.9c.6,1,.6,2.2,0,3.1-.2.3-.1.7.1.9s.6.3.9.1ZM133.7,135s0,0,0,0c0-.7.5-1.2,1.2-1.2,0,0,0,0,0,0,.7,0,1.2.5,1.2,1.2,0,0,0,0,0,0,0,.7-.5,1.2-1.2,1.2,0,0,0,0,0,0-.7,0-1.2-.5-1.2-1.2Z"
        />
        <path
          d="M127.1,134.7c.5-.5.5-1.4,0-1.9s-1.4-.5-1.9,0-.5,1.4,0,1.9,1.4.5,1.9,0Z"
        />
        <path
          d="M172.8,132.9c.5.5,1.4.5,1.9,0s.5-1.4,0-1.9-1.4-.5-1.9,0-.5,1.4,0,1.9Z"
        />
        <path
          d="M163.7,136.1c5.2-5.2,5.2-13.8,0-19s-13.8-5.2-19,0-5.2,13.8,0,19,13.8,5.2,19,0ZM145.6,118c4.7-4.7,12.4-4.7,17.1,0s4.7,12.4,0,17.1-12.4,4.7-17.1,0-4.7-12.4,0-17.1Z"
        />
        <path
          d="M134.7,208.6c.4,0,.6-.5.5-.8,0,0-1.6-6.7,1.4-14.7l.4-1c1-2.4,2.2-4.6,3.8-6.7l.8-.9c3.2-3.9,7.4-7.3,12.5-10,4.5-2.4,9-3.9,13.3-5.4,7.5-2.6,14.6-5,20.9-11.3s4.9-5.7,7.2-9.8c.2-.3,0-.7-.3-.9-.3-.2-.7,0-.9.3-5.5,10-12.1,14.4-19.3,17.5l-2-1.9c0-.2,0-.5.2-.8.5-2.4.2-4.4-1.1-6-.6-.7-1.3-1.3-2.2-1.7-.1,0-.2-.1-.3-.2-.4-.2-.8-.3-1.3-.4,0,0-.2,0-.2,0-.4,0-.9-.1-1.3,0-.3,0-.5,0-.8,0t0,0s0,0,0,0c-.1,0-.3,0-.4,0-.6,0-1.2.1-1.7.2,0,0,0,0-.1,0t0,0c-.1.6-.2,1.3-.3,1.9,0,.2,0,.3,0,.4t0,0c0,.8,0,1.5,0,2.1,0,0,0,.2,0,.2,0,.5.2.9.3,1.3h0c0,.1,0,.2.2.4.4.8,1,1.5,1.7,2.1,1.6,1.3,3.6,1.7,6,1.2.3,0,.6-.2.8-.2,0,0,1.6,1.6,1.6,1.6-2.3.9-4.5,1.7-6.8,2.5-.4.1-.9.3-1.3.4l-3.6-3.5c0-.4.2-.8.4-1.2.8-3.6.2-6.6-1.7-9-.9-1.1-2-2-3.3-2.6-.2,0-.3-.2-.5-.2-.6-.2-1.3-.4-1.9-.6-.1,0-.3,0-.4,0-.6-.1-1.3-.2-2-.2-.4,0-.8,0-1.2,0h0s0,0,0,0t0,0c-.2,0-.5,0-.7,0-.9,0-1.8.2-2.6.4,0,0-.1,0-.2,0t0,0c-.2.9-.4,1.9-.4,2.8,0,.2,0,.4,0,.6,0,0,0,0,0,0h0s0,0,0,0c0,1.1,0,2.2.1,3.2,0,0,0,0,0,0-.5-1-1-1.9-1.7-2.7-1.3-1.5-2.8-2.7-4.5-3.5-.2-.1-.5-.2-.7-.3-.8-.3-1.7-.6-2.6-.8-.2,0-.4,0-.5-.1-.9-.2-1.8-.2-2.8-.2-.6,0-1.1,0-1.6,0h0c0,0,0,0,0,0t0,0c-.3,0-.7,0-1,0-1.2,0-2.5.3-3.6.6,0,0-.2,0-.2,0q0,0,0,0c-.3,1.3-.5,2.6-.6,3.9,0,.3,0,.6,0,.9,0,0,0,0,0,.1h0s0,0,0,0c0,1.6,0,3.1.2,4.5,0,.2,0,.3.1.5.1.9.4,1.8.7,2.6h0c0,.3.2.5.3.7.8,1.7,1.9,3.2,3.4,4.4,0,0-.2,0-.2,0-.6-.2-1.3-.4-1.9-.6-.1,0-.3,0-.4,0-.6-.1-1.3-.2-2-.2-.4,0-.8,0-1.2,0h0s0,0,0,0t0,0c-.2,0-.5,0-.7,0-.9,0-1.8.2-2.6.4,0,0-.1,0-.2,0t0,0c-.2.9-.4,1.9-.4,2.8,0,.2,0,.4,0,.6,0,0,0,0,0,0h0s0,0,0,0c0,1.1,0,2.2.1,3.2,0,.1,0,.2,0,.4,0,.7.3,1.3.5,1.9h0c0,.2.1.4.2.5.6,1.3,1.4,2.4,2.6,3.3,2.4,2,5.4,2.6,9,1.7.4-.1.8-.2,1.2-.4,0,0,0,0,.2,0,0,0,0,0,0,0l2.7,2.9c-1.3,1.8-2.3,3.8-3.1,5.8l-.4,1c-.2.5-.3,1-.5,1.4l-1.9-1.7c0-.2.2-.5.2-.8.5-2.4.2-4.4-1.1-6-.6-.7-1.3-1.3-2.2-1.7-.1,0-.2-.1-.3-.2-.4-.2-.8-.3-1.3-.4,0,0-.2,0-.2,0-.4,0-.9-.1-1.3,0-.3,0-.5,0-.8,0t0,0s0,0,0,0c-.1,0-.3,0-.4,0-.6,0-1.2.1-1.7.2,0,0,0,0-.1,0t0,0c-.1.6-.2,1.3-.3,1.9,0,.2,0,.3,0,.4t0,0c0,.8,0,1.5,0,2.1,0,0,0,.2,0,.2,0,.5.2.9.3,1.3h0c0,.1,0,.2.2.4.4.8,1,1.5,1.7,2.1,1.6,1.3,3.6,1.7,6,1.2.3,0,.6-.2.8-.2,0,0,0,0,0,0t0,0l2,2.2c-1.9,7.2-.7,12.7-.6,12.9,0,.4.5.6.8.5ZM148.2,168c.6-2.5.7-4.7.3-6.8.6,1.2,1.4,2.2,2.4,3.1,2.4,2,5.4,2.6,9,1.7.4-.1.8-.2,1.2-.4,0,0,0,0,.2,0,0,0,0,0,0,0l2.9,3.1c-3.5,1.2-7.1,2.6-10.8,4.6-.4.2-.8.4-1.1.6l-4.6-4.2c.1-.6.3-1.1.5-1.7ZM137.3,180.7c.8-3.6.2-6.6-1.7-9-.3-.3-.6-.6-.9-.9,2.8,1.4,6.1,1.6,9.9.8.5-.2,1.1-.3,1.7-.5,0,0,.1,0,.2,0,0,0,0,0,.1,0l3.8,4c-3.8,2.4-7.1,5.3-9.8,8.5l-.8.9-2.8-2.6c0-.4.2-.8.4-1.2Z"
        />
        <path
          d="M200.8,153.7c-7.5,13.6-17.1,16.9-27.3,20.5-4.4,1.5-9,3.1-13.5,5.5-5.2,2.8-9.5,6.3-12.9,10.3l-.8,1c-1.7,2.2-3,4.6-4,7.1l-.4,1c-3.1,8.4-1.5,15.2-1.4,15.5,0,.4.5.6.8.5.4,0,.6-.5.5-.8,0,0-1.6-6.7,1.4-14.7l.4-1c1-2.4,2.2-4.6,3.8-6.7l.8-.9c3.3-3.9,7.4-7.3,12.5-10,4.5-2.4,9-3.9,13.3-5.4,7.5-2.6,14.6-5,20.9-11.3s4.9-5.7,7.2-9.8c.2-.3,0-.7-.3-.9s-.7,0-.9.3Z"
        />
        <path
          d="M207.1,160c-7.5,13.6-17.1,16.9-27.3,20.5-4.4,1.5-9,3.1-13.5,5.5-5.2,2.8-9.5,6.3-12.9,10.3l-.8,1c-1.7,2.2-3,4.5-4,7.1l-.4,1c-3.1,8.4-1.5,15.2-1.4,15.5,0,.4.5.6.8.5.4,0,.6-.5.5-.8,0,0-1.6-6.7,1.4-14.7l.4-1c1-2.4,2.2-4.6,3.8-6.7l.8-.9c3.2-3.9,7.4-7.3,12.5-10,4.5-2.4,9-3.9,13.3-5.4,7.5-2.6,14.6-5,20.9-11.3s4.9-5.7,7.2-9.8c.2-.3,0-.7-.3-.9-.3-.2-.7,0-.9.3Z"
        />
        <path
          d="M294.8,193.2V35.9c-144.2.5-260.8,117.5-260.8,261.7h157.3c0-57.4,46.3-104,103.5-104.4Z"
          class="inactive"
        />
      </g>
      <circle class="stroke fill no-pointer" cx="294.8" cy="299" r="134.2" />
      <circle class="stroke" cx="294.8" cy="297.6" r="261.7" />
      <circle class="white" cx="294.8" cy="296" r="104.4" />
      <line class="stroke" x1="294.8" y1="559.3" x2="294.8" y2="400.4" />
      <line class="stroke" x1="294.8" y1="191.6" x2="294.8" y2="35.9" />
      <line class="stroke" x1="191.3" y1="296.8" x2="33.1" y2="296.8" />
      <line class="stroke" x1="556.5" y1="296.8" x2="398.3" y2="296.8" />
      <g :class="basePicto">
        <path
          d="M242.6,277.9c0-6.3,4.3-11.1,10.5-11.1s10.5,4.8,10.5,11.1-4.3,11.1-10.5,11.1-10.5-4.8-10.5-11.1ZM260.6,277.9c0-4.7-2.9-8.3-7.5-8.3s-7.5,3.6-7.5,8.3,2.9,8.3,7.5,8.3,7.5-3.6,7.5-8.3Z"
        />
        <path
          d="M280.1,273.4v15h-2.8v-2.8c-.9,2.1-2.5,3.2-4.7,3.2-3.3,0-5.4-2.1-5.4-5.8v-9.6h2.8v8.8c0,2.8,1.2,4.2,3.5,4.2s3.8-1.9,3.8-5.2v-7.8h2.8Z"
        />
        <path
          d="M293,273.9v2.6c-.7-.5-1.5-.7-2.4-.7-1.8,0-3.2,1.7-3.2,4.6v8h-2.8v-15h2.8v3c.7-2.1,2-3.2,3.6-3.2s1.4.2,2,.7Z"
        />
        <path
          d="M312.1,288.4l-6.4-7.4v7.4h-2.8v-21.6h2.8v12.8l5.8-6.2h3.8l-7,6.7,7.5,8.2h-3.6Z"
        />
        <path
          d="M330,281.4h-10.9c.2,3.2,2.2,4.9,5.5,4.9s3.7-.7,4.9-1.7v2.6c-1.1.9-3.1,1.6-5.2,1.6-4.8,0-8-3.1-8-8s2.6-7.9,7.3-7.9,6.4,2.3,6.4,6.4v2ZM319.2,279.4h8.1c0-2.5-1.6-3.9-3.8-3.9s-3.9,1.6-4.3,3.9Z"
        />
        <path
          d="M346.3,273.4l-9.4,20.7h-3l3.5-7.2-5.7-13.5h2.9l4.2,10.4,4.5-10.4h2.9Z"
        />
        <path
          d="M254.9,305.8h-4.1v12.7h-2.8v-12.7h-3.7v-2.3h3.7v-3.8l2.8-.9v4.7h4.1v2.3Z"
        />
        <path
          d="M270.6,309v9.4h-2.8v-8.8c0-3-1-4.2-3.4-4.2s-4.1,1.8-4.1,4.9v8.1h-2.8v-21.6h2.8v9c.9-1.9,2.6-2.9,5-2.9s5.2,2.2,5.2,6.1Z"
        />
        <path
          d="M287.8,311.4h-10.9c.2,3.2,2.2,4.9,5.5,4.9s3.7-.7,4.9-1.7v2.6c-1.1.9-3.1,1.6-5.2,1.6-4.8,0-8-3.1-8-8s2.6-7.9,7.3-7.9,6.4,2.3,6.4,6.4v2ZM277,309.4h8.1c0-2.5-1.6-3.9-3.8-3.9s-3.9,1.6-4.3,3.9Z"
        />
        <path
          d="M311.9,308.6v9.8h-2.8v-9.4c0-2.4-1-3.6-2.9-3.6s-3.2,1.4-3.2,3.3v9.7h-2.7v-9.7c0-2.2-1.1-3.3-2.9-3.3s-3.2,1.6-3.2,3.9v9.1h-2.8v-15h2.8v2.5c.8-1.9,2.2-3,4.2-3s3.4,1.1,4.2,2.9c.8-1.8,2.3-2.9,4.4-2.9,3.1,0,4.9,2.2,4.9,5.6Z"
        />
        <path
          d="M329.1,311.4h-10.9c.2,3.2,2.2,4.9,5.5,4.9s3.7-.7,4.9-1.7v2.6c-1.1.9-3.1,1.6-5.2,1.6-4.8,0-8-3.1-8-8s2.6-7.9,7.3-7.9,6.4,2.3,6.4,6.4v2ZM318.3,309.4h8.1c0-2.5-1.6-3.9-3.8-3.9s-3.9,1.6-4.3,3.9Z"
        />
        <path
          d="M331.8,317.1v-2.6c1.5,1.3,3.3,2,5.2,2s3.1-.8,3.1-2.2-.4-1.6-1.9-2.1l-2.8-.9c-2.4-.8-3.5-2.2-3.5-4.1s2.1-4.2,5.4-4.2,3.5.6,4.8,1.4v2.7c-1.3-1.1-3.1-1.7-4.7-1.7s-2.8.6-2.8,1.7.6,1.6,1.8,1.9l2.7.8c2.7.8,3.8,2.3,3.8,4.3s-2.3,4.7-5.5,4.7-3.9-.6-5.5-1.8Z"
        />
      </g>
      <g :class="['no-pointer', textOn(Land_Nature)]">
        <path d="M188.1,251.9l1.1.4-2,5-8.4-3.4.5-1.2,7.3,2.9,1.5-3.8Z" />
        <path
          d="M188.2,245.3l3.6,1.7-.5,1.1-.8-.4c.5.6.5,1.3.2,2.1-.6,1.2-1.8,1.7-2.9,1.1-1.1-.5-1.5-1.8-.9-3,.4-.8.9-1.1,1.5-1.2l-.5-.2c-1-.5-1.9-.1-2.4.8-.3.7-.3,1.5,0,2.2l-1.1-.5c-.1-.7-.1-1.4.3-2.3.7-1.5,2.1-2.1,3.7-1.3ZM189.4,247.2c-.6-.3-1.3,0-1.7.8-.4.8-.2,1.5.5,1.8.7.3,1.3,0,1.7-.8.4-.8.1-1.5-.5-1.8Z"
        />
        <path
          d="M191.7,238.5l3.6,2-.6,1-3.3-1.8c-1.1-.6-1.8-.5-2.3.4-.5,1-.2,1.9,1,2.6l3.1,1.7-.6,1-5.7-3.1.6-1,1,.5c-.6-.7-.6-1.6-.1-2.5.7-1.2,1.9-1.5,3.4-.7Z"
        />
        <path
          d="M191.4,229l7.9,5-.6,1-1.1-.7c.5.7.7,1.7,0,2.7-.9,1.4-2.7,1.7-4.4.6-1.8-1.1-2.2-3-1.3-4.4.5-.8,1.2-1.2,2.3-1.1l-3.4-2.1.6-1ZM195.9,233.2c-1.1-.7-2.4-.6-3,.4-.6,1-.2,2.2,1,2.9,1.2.8,2.4.6,3-.4.7-1,.2-2.2-.9-3Z"
        />
        <path
          d="M204.3,220.2l-1,1.3,3.4,2.8-.7.9-1.6-1.3c.9,1.2.7,2.7-.3,3.9-1.1,1.4-2.8,1.7-4,.7-.9-.7-1.1-1.9-.7-2.9-.7.5-1.8.6-2.5,0-1.2-.9-1.3-2.6,0-4.1.5-.7,1.1-1.1,1.8-1.3l1,.8c-.6,0-1.3.4-1.9,1.2-.8,1-.7,1.9,0,2.4.6.5,1.4.4,2.2-.6l1.8-2.2-1.2-1,.4-1.2,1.5,1.2,1-1.3.8.6ZM202.5,222.4l-1.8,2.3c-.8,1.1-.6,2.1.1,2.7.8.6,1.8.4,2.6-.5.9-1.2,1-2.8-.9-4.4Z"
        />
        <path
          d="M209.3,208.2l6.4,6.4-1.2,1.2-8.8-2.4,5.6,5.6-.8.8-6.4-6.4,1.3-1.4,8.5,2.3-5.4-5.4.8-.8Z"
        />
        <path
          d="M218.4,207.1l2.6,3-.9.8-.6-.7c.2.7,0,1.4-.7,2-1,.9-2.3.8-3.1-.1-.8-.9-.7-2.2.4-3.2.6-.5,1.3-.7,1.9-.5l-.4-.4c-.8-.9-1.7-.9-2.5-.2-.6.5-.9,1.2-.9,2l-.8-.9c.1-.7.5-1.4,1.2-2,1.3-1.1,2.7-1,3.9.3ZM218.7,209.4c-.4-.5-1.2-.5-1.9,0-.7.6-.8,1.3-.3,1.8.5.6,1.2.6,1.9,0,.7-.6.8-1.4.3-1.9Z"
        />
        <path
          d="M221.9,202.4l-1.4,1.1,3.4,4.3-.9.7-3.4-4.3-1.2,1-.6-.8,1.2-1-1-1.3.7-1,1.2,1.6,1.4-1.1.6.8Z"
        />
        <path
          d="M226.8,197.6l3.7,5.3-1,.7-.7-1c.2,1,0,1.7-.9,2.3-1.2.8-2.4.6-3.4-.7l-2.4-3.4,1-.7,2.2,3.1c.7,1,1.5,1.2,2.3.6.9-.6.9-1.6,0-2.8l-2-2.8,1-.7Z"
        />
        <path
          d="M231.9,194.6l.6,1c-.4,0-.7,0-1,.3-.7.4-.8,1.3-.1,2.4l1.9,3-1,.6-3.5-5.5,1-.6.7,1.1c-.2-.9,0-1.7.6-2,.3-.2.6-.2.9-.2Z"
        />
        <path
          d="M239.4,194.1l-4.1,2.3c.8,1.2,1.9,1.4,3.1.7.7-.4,1.3-1,1.5-1.7l.6,1c-.2.6-.8,1.2-1.6,1.7-1.8,1-3.7.5-4.7-1.3-1-1.7-.7-3.5,1.1-4.5,1.5-.8,2.9-.5,3.8,1.1l.4.7ZM234.9,195.6l3.1-1.7c-.6-1-1.4-1.1-2.3-.7-1,.5-1.1,1.4-.8,2.4Z"
        />
      </g>
      <g :class="['no-pointer', textOn(Healthy_Diet)]">
        <path
          d="M355.8,191.3l-4.3,8-1.1-.6,1.9-3.6-4.1-2.2-1.9,3.6-1.1-.6,4.3-8,1.1.6-1.9,3.4,4.1,2.2,1.9-3.4,1.1.6Z"
        />
        <path
          d="M359.4,200.7l-4-2.5c-.7,1.2-.3,2.3.8,3.1.7.4,1.5.6,2.2.5l-.6,1c-.6,0-1.5-.2-2.3-.6-1.8-1.1-2.2-3-1.1-4.8,1.1-1.7,2.8-2.3,4.5-1.2,1.4.9,1.8,2.4.8,3.9l-.5.7ZM356,197.5l3,1.9c.6-.9.3-1.8-.5-2.3-.9-.6-1.8-.3-2.5.4Z"
        />
        <path
          d="M365.3,203.8l-2.3,3.2-1-.7.5-.7c-.7.3-1.4.3-2.1-.2-1.1-.8-1.3-2.1-.6-3.1.7-1,2-1.1,3.2-.3.7.5,1,1.1.9,1.7l.3-.5c.7-.9.5-1.9-.4-2.5-.6-.5-1.4-.6-2.1-.5l.7-1c.7,0,1.4.1,2.2.7,1.4,1,1.6,2.4.6,3.8ZM363.2,204.7c.4-.5.2-1.3-.5-1.8-.7-.5-1.4-.5-1.9.1-.4.6-.3,1.3.4,1.8.7.5,1.5.4,1.9-.2Z"
        />
        <path d="M370.2,200.9l.9.7-5.8,7.3-.9-.7,5.8-7.3Z" />
        <path
          d="M373.3,208.4l-1.3-1.1-3.6,4.2-.9-.8,3.6-4.2-1.2-1,.7-.8,1.2,1,1.1-1.2,1.2.5-1.3,1.5,1.3,1.1-.7.8Z"
        />
        <path
          d="M377.4,214.2l-2.8,2.9-.9-.8,2.6-2.8c.9-.9.9-1.6.2-2.3-.8-.8-1.8-.6-2.7.3l-2.4,2.5-.9-.8,6.5-6.8.9.8-2.7,2.8c.8-.3,1.7-.1,2.4.6,1,1,1,2.3-.2,3.5Z"
        />
        <path
          d="M384.3,218l-9.4,3.1-.9-.9,3.3-1,2.6-5.8.9.9-2.1,4.4,4.6-1.6.9.9Z"
        />
        <path
          d="M389.6,220.2l1.9,2.5c1.7,2.3,1.2,4.6-.9,6.2-2.1,1.6-4.6,1.5-6.4-.9l-1.7-2.3,7.2-5.5ZM385,227.3c1.4,1.8,3.1,1.8,4.7.6,1.6-1.2,2.1-2.8.7-4.6l-1-1.4-5.4,4.1,1,1.2Z"
        />
        <path
          d="M393.1,229.3l.7,1-5.4,3.7-.7-1,5.4-3.7ZM394.6,228c.4-.2.8-.1,1.1.2.2.4.2.8-.2,1.1-.4.2-.8.2-1.1-.2-.2-.4-.2-.9.2-1.1Z"
        />
        <path
          d="M395,238.6l-2.5-4c-1.1.8-1.3,2-.6,3.1.4.7,1.1,1.2,1.7,1.4l-1,.6c-.6-.2-1.3-.8-1.8-1.6-1.1-1.8-.7-3.7,1.1-4.8,1.7-1,3.5-.8,4.6.9.9,1.4.6,2.9-.9,3.8l-.7.5ZM393.3,234.2l1.9,3c.9-.6,1.1-1.5.6-2.3-.6-.9-1.5-1.1-2.4-.7Z"
        />
        <path
          d="M399.7,242.1l-.9-1.5-4.8,2.7-.6-1,4.8-2.7-.8-1.4.9-.5.8,1.4,1.4-.8.9.9-1.8,1,.9,1.5-.9.5Z"
        />
      </g>
      <g :class="['no-pointer', textOn(Education_Career_Readiness)]">
        <path
          d="M173.9,309.7h-1.1s-.2-5.6-.2-5.6l9.1-.3.2,5.6h-1.1s-.1-4.3-.1-4.3h-2.6c0,0,.1,4.2.1,4.2h-1.1s-.1-4-.1-4h-3.1c0,0,.1,4.5.1,4.5Z"
        />
        <path
          d="M182.8,316.6l-9.3.9v-1.2c-.1,0,1.2-.1,1.2-.1-.8-.3-1.6-.9-1.7-2.1-.2-1.7,1.1-3,3.1-3.2,2.1-.2,3.6,1,3.8,2.6,0,.9-.2,1.7-1.1,2.3l4-.4v1.2ZM176.6,316c1.3-.1,2.2-1,2.1-2.2-.1-1.2-1.1-1.9-2.6-1.7-1.4.1-2.2,1-2.1,2.1.1,1.2,1.2,1.9,2.6,1.8Z"
        />
        <path
          d="M181.1,324.2l-6.4,1.1-.2-1.2,1.2-.2c-1-.2-1.5-.8-1.7-1.8-.2-1.4.5-2.5,2.1-2.7l4.1-.7.2,1.2-3.8.6c-1.2.2-1.7.8-1.5,1.8.2,1.1,1.1,1.5,2.5,1.3l3.3-.6.2,1.2Z"
        />
        <path
          d="M178.2,326.4c1.9-.5,3.6.5,4.1,2.5.2.9.1,1.6,0,2.1l-1.3.3c.4-.7.4-1.4.3-2.1-.3-1.3-1.4-1.9-2.8-1.6-1.3.3-2.1,1.3-1.8,2.8.2.7.6,1.3,1.1,1.7l-1.1.3c-.5-.5-.9-1.1-1.1-1.9-.5-2,.7-3.6,2.6-4.1Z"
        />
        <path
          d="M182,337.8l-3.8,1.1-.3-1.1.8-.2c-.7-.1-1.3-.6-1.5-1.5-.4-1.3.2-2.4,1.4-2.8,1.2-.4,2.3.3,2.7,1.7.2.8,0,1.5-.3,1.9l.5-.2c1.1-.3,1.5-1.2,1.2-2.2-.2-.7-.7-1.3-1.4-1.7l1.2-.3c.6.4,1.1,1,1.3,1.9.5,1.6-.2,2.9-1.8,3.4ZM179.8,337.3c.6-.2,1-.9.7-1.7-.3-.9-.9-1.2-1.6-1-.7.2-1,.8-.8,1.7.3.9.9,1.2,1.6,1Z"
        />
        <path
          d="M185.3,342.7l-.6-1.7-5.2,1.8-.4-1.1,5.2-1.8-.5-1.5,1-.3.5,1.5,1.5-.5.8,1-1.9.7.6,1.7-1,.3Z"
        />
        <path
          d="M186.7,343.4l.4,1.1-6,2.4-.4-1.1,6-2.4ZM188.5,342.5c.4-.2.8,0,1,.5.2.4,0,.8-.4,1-.4.2-.8,0-1-.4-.2-.4,0-.9.4-1Z"
        />
        <path
          d="M184.8,347.3c1.8-.8,3.6-.3,4.4,1.4.8,1.8,0,3.5-1.8,4.3-1.8.8-3.6.3-4.5-1.5-.8-1.8,0-3.5,1.8-4.3ZM186.9,352c1.3-.6,1.8-1.6,1.3-2.8-.5-1.1-1.7-1.4-2.9-.8s-1.8,1.6-1.3,2.7c.5,1.1,1.7,1.4,3,.8Z"
        />
        <path
          d="M191.6,359.2l-3.6,1.9-.6-1.1,3.3-1.8c1.1-.6,1.4-1.3.9-2.2-.5-1-1.5-1.2-2.7-.5l-3.1,1.7-.6-1.1,5.7-3.1.6,1.1-1,.5c.9,0,1.7.4,2.2,1.3.7,1.2.2,2.4-1.2,3.2Z"
        />
        <path
          d="M199,370.1l-.9-1.4-3.7,2.5-.7-1,1.7-1.1c-1.4.5-2.8-.2-3.7-1.4-1-1.5-.8-3.1.5-4,1-.7,2.2-.5,2.9.2-.3-.8,0-1.9.8-2.4,1.2-.8,2.8-.4,3.9,1.2.5.7.7,1.4.7,2.1l-1.1.7c0-.6,0-1.4-.6-2.2-.7-1-1.6-1.3-2.3-.8-.6.4-.8,1.2,0,2.3l1.6,2.3,1.3-.9,1,.8-1.6,1.1.9,1.4-.9.6ZM197.4,367.7l-1.7-2.5c-.8-1.1-1.8-1.2-2.6-.7-.8.5-.9,1.6-.3,2.6.8,1.2,2.4,1.8,4.5.5Z"
        />
        <path
          d="M201,372.5c2.2-1.8,5-1.6,6.8.5.8.9,1.1,1.9,1.1,2.6l-1.1.9c0-.8-.2-1.8-1-2.7-1.4-1.6-3.4-1.7-5-.4-1.6,1.3-1.9,3.3-.5,5,.7.9,1.7,1.3,2.5,1.5l-1,.8c-.9-.2-1.8-.8-2.4-1.6-1.9-2.3-1.5-5,.6-6.7Z"
        />
        <path
          d="M210,383.4l-2.8,2.7-.8-.9.6-.6c-.7.2-1.4,0-2-.6-.9-.9-.9-2.3,0-3.1.9-.9,2.2-.8,3.2.2.6.6.7,1.3.6,1.8l.4-.4c.8-.8.8-1.7,0-2.5-.5-.6-1.2-.8-2-.8l.9-.8c.7.1,1.4.4,2,1.1,1.2,1.2,1.2,2.7,0,3.9ZM207.8,383.9c.5-.5.5-1.2-.2-1.9-.6-.7-1.3-.7-1.9-.2-.5.5-.5,1.2.1,1.9.6.6,1.4.7,1.9.2Z"
        />
        <path
          d="M215.7,385.5l-.8.8c0-.4-.3-.7-.5-.9-.6-.5-1.5-.4-2.4.5l-2.4,2.5-.9-.8,4.4-4.7.9.8-.9.9c.8-.5,1.6-.4,2.1,0,.2.2.4.5.4.8Z"
        />
        <path
          d="M218.6,392.3l-3.6-3c-.8,1.1-.6,2.3.4,3.2.6.5,1.4.8,2.1.8l-.7.9c-.6,0-1.5-.3-2.2-.9-1.6-1.3-1.8-3.3-.4-4.9,1.3-1.5,3.1-1.9,4.6-.6,1.3,1.1,1.5,2.6.3,3.9l-.6.7ZM215.6,388.6l2.7,2.3c.7-.9.6-1.7-.2-2.4-.8-.7-1.7-.6-2.5,0Z"
        />
        <path
          d="M224.4,396.6l-3.8-2.8c-.7,1.2-.5,2.3.6,3.1.6.5,1.5.7,2.1.7l-.7.9c-.6,0-1.5-.3-2.2-.8-1.7-1.2-2-3.2-.7-4.9,1.2-1.6,2.9-2.1,4.6-.8,1.3,1,1.6,2.5.6,3.9l-.5.7ZM221.2,393.1l2.8,2.1c.6-.9.5-1.8-.3-2.3-.9-.7-1.8-.5-2.5.3Z"
        />
        <path
          d="M230.6,396.8l-.6,1c-.1-.4-.4-.6-.7-.8-.7-.4-1.5-.1-2.2.9l-1.9,2.9-1-.7,3.6-5.4,1,.7-.7,1.1c.8-.6,1.5-.7,2.1-.3.3.2.4.4.5.7Z"
        />
        <path
          d="M235.7,407l-1.1-5.5-2,3.8-1.1-.6,4.3-8,3.1,1.7c1.5.8,1.9,2.3,1.2,3.6-.7,1.4-2.2,1.7-3.8.9h-.2c0-.1,1.1,4.9,1.1,4.9l-1.5-.8ZM234.9,401l1.6.8c1.1.6,1.9.4,2.4-.5.4-.8.2-1.6-.8-2.1l-1.7-.9-1.5,2.7Z"
        />
        <path
          d="M244.9,408l-4.3-2c-.5,1.3,0,2.3,1.3,2.9.7.3,1.6.4,2.2.2l-.5,1c-.6.1-1.5,0-2.3-.3-1.9-.9-2.6-2.7-1.7-4.6.8-1.8,2.5-2.6,4.3-1.8,1.5.7,2.1,2.1,1.4,3.7l-.4.8ZM241,405.2l3.2,1.5c.4-1,0-1.8-.8-2.2-1-.5-1.8,0-2.4.8Z"
        />
        <path
          d="M251.4,409.6l-1.4,3.7-1.1-.4.3-.8c-.5.5-1.3.6-2.1.3-1.2-.5-1.8-1.7-1.3-2.8.4-1.2,1.7-1.6,3-1.1.8.3,1.2.8,1.3,1.4l.2-.5c.4-1.1,0-1.9-1-2.3-.7-.3-1.5-.2-2.2.1l.4-1.1c.7-.2,1.4-.2,2.3,0,1.6.6,2.2,1.9,1.6,3.5ZM249.6,410.9c.2-.6,0-1.3-.9-1.6-.9-.3-1.5,0-1.8.6-.3.7,0,1.3.9,1.7.8.3,1.6,0,1.8-.6Z"
        />
        <path
          d="M260.5,406.8l-2.8,8.9-1.1-.4.4-1.3c-.6.7-1.4,1.1-2.6.8-1.6-.5-2.3-2.2-1.7-4.1.6-2,2.3-2.9,3.9-2.5.9.3,1.5.9,1.6,1.9l1.2-3.8,1.1.4ZM257.6,412.3c.4-1.3,0-2.4-1.2-2.8-1.1-.4-2.2.3-2.6,1.7-.4,1.4,0,2.4,1.1,2.8,1.2.4,2.2-.4,2.6-1.7Z"
        />
        <path
          d="M261.6,410l1.2.3-1.6,6.3-1.2-.3,1.6-6.3ZM261.9,408.1c.1-.4.5-.6,1-.5.4.1.7.5.6.9-.1.4-.5.7-.9.6s-.7-.5-.6-1Z"
        />
        <path
          d="M269.7,414.3l-.8,4-1.2-.2.8-3.7c.3-1.3,0-1.9-1.1-2.1-1.1-.2-1.9.4-2.1,1.7l-.7,3.4-1.2-.2,1.3-6.4,1.2.2-.2,1.1c.5-.8,1.4-1,2.4-.8,1.3.3,2,1.4,1.7,3Z"
        />
        <path
          d="M277,416.4l-4.7-.6c0,1.4.7,2.2,2.1,2.4.8.1,1.6,0,2.2-.4l-.2,1.1c-.5.3-1.4.5-2.3.4-2.1-.3-3.3-1.8-3-3.9.3-1.9,1.6-3.2,3.6-2.9,1.6.2,2.6,1.4,2.4,3.1v.8ZM272.5,414.9l3.5.5c.1-1.1-.4-1.8-1.4-1.9-1.1-.2-1.8.4-2.1,1.4Z"
        />
        <path
          d="M278.1,419v-1.1c.7.6,1.5,1,2.3,1,.8,0,1.4-.2,1.4-.9,0-.4-.1-.7-.7-1l-1.2-.5c-1-.4-1.4-1.1-1.4-1.9,0-1.1,1.1-1.8,2.5-1.6.8,0,1.5.4,2,.8v1.2c-.6-.5-1.4-.8-2.1-.9-.8,0-1.2.2-1.3.7,0,.4.2.7.7.9l1.1.4c1.1.4,1.6,1.1,1.5,2,0,1.2-1.1,2-2.5,1.9-.9,0-1.7-.4-2.3-1Z"
        />
        <path
          d="M284.3,419.5v-1.1c.7.6,1.4.9,2.3.9.8,0,1.3-.3,1.4-.9,0-.4-.2-.7-.8-.9l-1.2-.4c-1-.4-1.5-1-1.5-1.8,0-1.1,1-1.8,2.4-1.8.8,0,1.5.3,2,.7v1.2c-.6-.5-1.3-.8-2.1-.8-.8,0-1.2.2-1.2.7,0,.4.3.7.8.9l1.1.4c1.2.4,1.6,1,1.6,1.9,0,1.2-1,2-2.4,2-.9,0-1.7-.3-2.4-.8Z"
        />
      </g>
      <g :class="['no-pointer', textOn(Sport_Physical_Activity)]">
        <path
          d="M314.6,417l-.2-1.3c.9.6,1.9.9,3.1.7,1.2-.2,1.7-.8,1.5-1.7-.1-.7-.6-1-2-1.3l-.9-.2c-1.4-.3-2.3-1-2.5-2.2-.3-1.5.7-2.7,2.5-3.1,1.2-.2,2.2,0,2.7.4l.2,1.4c-.8-.5-1.7-.8-2.7-.6-1.1.2-1.6.8-1.5,1.6.1.8.7,1,1.8,1.3l1,.2c1.7.4,2.4,1,2.6,2.2.3,1.6-.7,2.9-2.5,3.2-1,.2-2.1,0-3.1-.5Z"
        />
        <path
          d="M327.9,411.5c.5,2.1-.5,3.8-2.1,4.2-.9.2-1.8,0-2.4-.7l.9,3.5-1.2.3-2.2-8.8,1.2-.3.3,1.3c.2-.9.7-1.8,1.9-2.1,1.7-.4,3.2.8,3.6,2.7ZM326.7,411.9c-.3-1.3-1.3-2.1-2.5-1.8-1.2.3-1.7,1.5-1.3,2.8.3,1.3,1.3,2.1,2.5,1.8s1.7-1.5,1.4-2.8Z"
        />
        <path
          d="M329.2,411.2c-.6-1.9.1-3.7,2-4.3,1.9-.6,3.5.5,4.2,2.3.6,1.9-.1,3.7-2,4.3-1.9.6-3.5-.5-4.1-2.3ZM334.1,409.6c-.4-1.3-1.4-2-2.6-1.7-1.2.4-1.6,1.5-1.1,2.9s1.4,2.1,2.6,1.7c1.2-.4,1.6-1.6,1.2-2.9Z"
        />
        <path
          d="M339.2,404.4l.4,1.1c-.4,0-.7,0-1.1,0-.7.3-1,1.2-.6,2.4l1.3,3.3-1.1.4-2.4-6.2,1.1-.4.5,1.2c0-1,.3-1.6,1-1.9.3-.1.6-.1.9,0Z"
        />
        <path
          d="M344.2,403.1l-1.6.7,2.2,5.1-1.1.5-2.2-5.1-1.5.6-.4-.9,1.5-.6-.7-1.5,1-.8.8,1.9,1.6-.7.4.9Z"
        />
        <path
          d="M356.4,398l-1.5.8,2.2,3.9-1.1.6-1-1.8c.3,1.5-.4,2.8-1.8,3.6-1.6.9-3.3.5-4-.9-.6-1.1-.3-2.2.5-2.9-.9.2-1.9-.1-2.4-1-.7-1.3-.2-2.9,1.6-3.9.8-.4,1.5-.6,2.2-.5l.6,1.1c-.6-.1-1.4,0-2.3.4-1.1.6-1.4,1.5-1,2.3.4.7,1.2.9,2.3.2l2.5-1.4-.8-1.4.9-.9,1,1.7,1.5-.8.5.9ZM353.9,399.4l-2.6,1.5c-1.2.7-1.4,1.7-.9,2.5.5.9,1.5,1.1,2.6.5,1.3-.7,2.1-2.2.9-4.5Z"
        />
        <path
          d="M364.3,390.4c1,1.4.8,3.1-.9,4.3l-1.4,1,1.9,2.7-1,.7-5.3-7.6,2.7-1.9c1.4-1,3-.7,4.1.7ZM363.2,391.1c-.6-.9-1.5-1.1-2.5-.4l-1.4,1,2.1,3,1.3-.9c1.1-.8,1.3-1.7.6-2.7Z"
        />
        <path
          d="M371.2,387.6l2.6,3.2-.9.8-2.4-3c-.8-1-1.5-1.2-2.3-.5-.9.7-.9,1.7,0,2.8l2.2,2.8-.9.8-6-7.4.9-.8,2.5,3.1c-.2-.9,0-1.7.9-2.4,1.1-.9,2.4-.7,3.5.6Z"
        />
        <path
          d="M375.1,380.7l3.1,9.5-1,.9-1-3.4-5.9-2.7.9-.9,4.5,2.1-1.6-4.7.9-.9Z"
        />
        <path
          d="M379.8,384.6l-.8-.8c.9,0,1.7-.4,2.2-1,.6-.6.7-1.2.3-1.7-.3-.3-.6-.4-1.2,0l-1.2.6c-1,.5-1.8.4-2.4-.2-.8-.8-.7-2,.3-3,.6-.6,1.3-.9,1.9-1.1l.8.8c-.7,0-1.5.4-2,1-.6.6-.7,1.1-.3,1.4.3.3.7.3,1.2,0l1.1-.6c1.1-.6,1.9-.5,2.5.1.9.9.8,2.2-.2,3.2-.7.7-1.4,1-2.3,1.2Z"
        />
        <path
          d="M378.3,374.6c-.3-.3-.3-.8,0-1.1.3-.3.8-.4,1.1,0s.4.8,0,1.1c-.3.3-.8.4-1.1,0ZM379.9,375.8l.8-.9,4.9,4.4-.8.9-4.9-4.4Z"
        />
        <path
          d="M384.3,375.8c-1.5-1.3-1.8-3.3-.5-4.9.6-.8,1.2-1.1,1.7-1.2l1,.8c-.8.1-1.4.5-1.9,1.1-.9,1.1-.7,2.4.4,3.2,1.1.9,2.4.9,3.4-.3.5-.5.7-1.3.7-1.9l.9.8c0,.8-.4,1.4-.9,2-1.3,1.6-3.4,1.7-4.9.4Z"
        />
        <path
          d="M391.2,365.7l3.2,2.4-.7,1-.7-.5c.3.7.3,1.4-.2,2.2-.8,1.1-2.1,1.3-3.1.6-1-.7-1.2-2.1-.3-3.2.5-.7,1.1-1,1.7-.9l-.5-.3c-.9-.7-1.9-.5-2.5.4-.5.6-.6,1.4-.5,2.2l-1-.7c0-.7.1-1.5.7-2.2,1-1.4,2.5-1.7,3.9-.6ZM392.1,367.9c-.6-.4-1.3-.3-1.8.5-.6.8-.5,1.5.1,1.9.6.4,1.3.3,1.9-.4.5-.7.4-1.5-.2-1.9Z"
        />
        <path d="M387.8,361l.7-1,7.9,5.3-.7,1-7.9-5.3Z" />
        <path
          d="M399.7,354.8l-1.8,3.2,1.8,1.9-.6,1.2-6.6-7.2.8-1.5,9.6,1.7-.7,1.2-2.5-.5ZM398.6,354.6l-4.7-.9,3.3,3.5,1.5-2.6Z"
        />
        <path
          d="M400.4,351.6c-1.8-.9-2.6-2.7-1.7-4.6.4-.9.9-1.3,1.4-1.6l1.2.6c-.7.3-1.2.8-1.5,1.5-.6,1.2,0,2.5,1.2,3,1.2.6,2.5.3,3.2-1.1.3-.6.4-1.4.2-2l1.1.5c.1.7,0,1.4-.4,2.2-.9,1.9-2.8,2.5-4.7,1.6Z"
        />
        <path
          d="M402.8,340.6l-.7,1.7,5.2,2.1-.5,1.1-5.2-2.1-.6,1.5-1-.4.6-1.5-1.5-.6v-1.3c0,0,2,.8,2,.8l.7-1.7,1,.4Z"
        />
        <path
          d="M400.3,338.6c-.4-.1-.6-.6-.4-1,.2-.4.6-.6,1-.5.4.1.6.6.5,1-.2.4-.6.6-1,.5ZM402.2,339.1l.4-1.1,6.2,2.3-.4,1.1-6.2-2.3Z"
        />
        <path d="M405,330.7l5.5,4.4-.3,1.1-7.1.5.4-1.2,5.4-.3-4.3-3.3.4-1.2Z" />
        <path
          d="M403.3,329.2c-.4-.1-.6-.5-.5-1,.1-.4.5-.7.9-.6.4.1.7.5.6,1-.1.4-.6.7-1,.6ZM405.3,329.5l.3-1.2,6.4,1.7-.3,1.2-6.4-1.7Z"
        />
        <path
          d="M407.9,322.8l-.4,1.8,5.4,1.2-.3,1.2-5.4-1.2-.4,1.6-1-.2.4-1.6-1.6-.4v-1.3c-.1,0,1.9.5,1.9.5l.4-1.8,1,.2Z"
        />
        <path
          d="M408.1,315.9l8.3,5.6-.2,1.3-2.9-2.1-6.3,1.5.2-1.3,4.8-1.1-4.2-2.7.2-1.3Z"
        />
      </g>
      <g :class="[displayPicto(Land_Nature)]">
        <path
          d="M271.9,243.1l-2.4,9.1h-1.6l-2-7.9-2,7.9h-1.6l-2.3-9.1h1.4l1.8,7.7,2-7.7h1.7l2,7.7,1.9-7.7h1.3Z"
        />
        <path
          d="M278.4,249.2h-4.7c.1,1.4,1,2.1,2.4,2.1s1.6-.3,2.1-.7v1.1c-.5.4-1.3.7-2.2.7-2.1,0-3.5-1.4-3.5-3.5s1.1-3.4,3.2-3.4,2.8,1,2.8,2.8v.9ZM273.7,248.3h3.5c0-1.1-.7-1.7-1.7-1.7s-1.7.7-1.9,1.7Z"
        />
        <path
          d="M283,251.6v-1.1c.6.5,1.4.9,2.3.9s1.3-.3,1.3-1-.2-.7-.8-.9l-1.2-.4c-1.1-.3-1.5-1-1.5-1.8s.9-1.8,2.4-1.8,1.5.3,2.1.6v1.2c-.6-.5-1.3-.7-2.1-.7s-1.2.3-1.2.8.3.7.8.8l1.2.3c1.2.3,1.6,1,1.6,1.9s-1,2.1-2.4,2.1-1.7-.2-2.4-.8Z"
        />
        <path
          d="M294.7,245.7v6.5h-1.2v-1.2c-.4.9-1.1,1.4-2,1.4-1.4,0-2.3-.9-2.3-2.5v-4.1h1.2v3.8c0,1.2.5,1.8,1.5,1.8s1.7-.8,1.7-2.3v-3.4h1.2Z"
        />
        <path
          d="M303,248.9c0,2.1-1.4,3.5-3,3.5s-1.7-.5-2.1-1.3v3.5h-1.2v-9h1.2v1.3c.4-.8,1.1-1.5,2.3-1.5,1.7,0,2.8,1.5,2.8,3.4ZM301.8,249c0-1.4-.8-2.3-2-2.3s-2,1-2,2.4.7,2.3,1.9,2.3,2-1,2-2.4Z"
        />
        <path
          d="M310.9,248.9c0,2.1-1.4,3.5-3,3.5s-1.7-.5-2.1-1.3v3.5h-1.2v-9h1.2v1.3c.4-.8,1.1-1.5,2.3-1.5,1.7,0,2.8,1.5,2.8,3.4ZM309.7,249c0-1.4-.8-2.3-2-2.3s-2,1-2,2.4.7,2.3,1.9,2.3,2-1,2-2.4Z"
        />
        <path
          d="M312,249c0-2,1.2-3.4,3.2-3.4s3.2,1.5,3.2,3.4-1.2,3.4-3.2,3.4-3.2-1.5-3.2-3.4ZM317.2,249c0-1.4-.7-2.4-2-2.4s-1.9,1-1.9,2.4.7,2.4,1.9,2.4,2-1,2-2.4Z"
        />
        <path
          d="M323.5,245.9v1.1c-.3-.2-.7-.3-1-.3-.8,0-1.4.7-1.4,2v3.5h-1.2v-6.5h1.2v1.3c.3-.9.9-1.4,1.6-1.4s.6,0,.9.3Z"
        />
        <path
          d="M328.5,246.7h-1.8v5.5h-1.2v-5.5h-1.6v-1h1.6v-1.6l1.2-.4v2h1.8v1Z"
        />
        <path
          d="M242.5,259.8c0-.4.4-.8.8-.8s.8.3.8.8-.3.8-.8.8-.8-.4-.8-.8ZM242.7,261.7h1.2v6.5h-1.2v-6.5Z"
        />
        <path
          d="M251.5,264.2v4.1h-1.2v-3.8c0-1.3-.4-1.8-1.5-1.8s-1.8.8-1.8,2.1v3.5h-1.2v-6.5h1.2v1.1c.4-.8,1.1-1.3,2.2-1.3s2.3,1,2.3,2.6Z"
        />
        <path
          d="M257.1,262.7h-1.8v5.5h-1.2v-5.5h-1.6v-1h1.6v-1.6l1.2-.4v2h1.8v1Z"
        />
        <path
          d="M263.7,265.2h-4.7c.1,1.4,1,2.1,2.4,2.1s1.6-.3,2.1-.7v1.1c-.5.4-1.3.7-2.2.7-2.1,0-3.5-1.4-3.5-3.5s1.1-3.4,3.2-3.4,2.8,1,2.8,2.8v.9ZM259,264.3h3.5c0-1.1-.7-1.7-1.7-1.7s-1.7.7-1.9,1.7Z"
        />
        <path
          d="M268.9,261.9v1.1c-.3-.2-.7-.3-1-.3-.8,0-1.4.7-1.4,2v3.5h-1.2v-6.5h1.2v1.3c.3-.9.9-1.4,1.6-1.4s.6,0,.9.3Z"
        />
        <path d="M275.6,261.7l-2.5,6.5h-1.1l-2.5-6.5h1.3l1.8,5,1.8-5h1.2Z" />
        <path
          d="M282.2,265.2h-4.7c.1,1.4,1,2.1,2.4,2.1s1.6-.3,2.1-.7v1.1c-.5.4-1.3.7-2.2.7-2.1,0-3.5-1.4-3.5-3.5s1.1-3.4,3.2-3.4,2.8,1,2.8,2.8v.9ZM277.5,264.3h3.5c0-1.1-.7-1.7-1.7-1.7s-1.7.7-1.9,1.7Z"
        />
        <path
          d="M289.4,264.2v4.1h-1.2v-3.8c0-1.3-.4-1.8-1.5-1.8s-1.8.8-1.8,2.1v3.5h-1.2v-6.5h1.2v1.1c.4-.8,1.1-1.3,2.2-1.3s2.3,1,2.3,2.6Z"
        />
        <path
          d="M295,262.7h-1.8v5.5h-1.2v-5.5h-1.6v-1h1.6v-1.6l1.2-.4v2h1.8v1Z"
        />
        <path
          d="M296.1,259.8c0-.4.4-.8.8-.8s.8.3.8.8-.3.8-.8.8-.8-.4-.8-.8ZM296.2,261.7h1.2v6.5h-1.2v-6.5Z"
        />
        <path
          d="M299,265c0-2,1.2-3.4,3.2-3.4s3.2,1.5,3.2,3.4-1.2,3.4-3.2,3.4-3.2-1.5-3.2-3.4ZM304.2,265c0-1.4-.7-2.4-2-2.4s-1.9,1-1.9,2.4.7,2.4,1.9,2.4,2-1,2-2.4Z"
        />
        <path
          d="M312.6,264.2v4.1h-1.2v-3.8c0-1.3-.4-1.8-1.5-1.8s-1.8.8-1.8,2.1v3.5h-1.2v-6.5h1.2v1.1c.4-.8,1.1-1.3,2.2-1.3s2.3,1,2.3,2.6Z"
        />
        <path
          d="M314.1,267.6v-1.1c.6.5,1.4.9,2.3.9s1.3-.3,1.3-1-.2-.7-.8-.9l-1.2-.4c-1.1-.3-1.5-1-1.5-1.8s.9-1.8,2.4-1.8,1.5.3,2.1.6v1.2c-.6-.5-1.3-.7-2.1-.7s-1.2.3-1.2.8.3.7.8.8l1.2.3c1.2.3,1.6,1,1.6,1.9s-1,2.1-2.4,2.1-1.7-.2-2.4-.8Z"
        />
        <path
          d="M327.2,262.7h-1.8v5.5h-1.2v-5.5h-1.6v-1h1.6v-1.6l1.2-.4v2h1.8v1Z"
        />
        <path
          d="M334,264.2v4.1h-1.2v-3.8c0-1.3-.4-1.8-1.5-1.8s-1.8.8-1.8,2.1v3.5h-1.2v-9.4h1.2v3.9c.4-.8,1.1-1.2,2.2-1.2s2.3,1,2.3,2.6Z"
        />
        <path
          d="M340.8,264.3v4h-1.2v-.9c-.3.7-1,1.1-1.8,1.1-1.3,0-2.3-.9-2.3-2.1s1-2.1,2.4-2.1,1.4.4,1.7.8v-.6c0-1.1-.7-1.8-1.7-1.8s-1.5.3-2,.9v-1.2c.5-.4,1.2-.7,2.2-.7,1.7,0,2.8,1,2.8,2.7ZM339.6,266.2c0-.7-.5-1.2-1.4-1.2s-1.4.5-1.4,1.2.5,1.2,1.4,1.2,1.5-.5,1.5-1.2Z"
        />
        <path
          d="M346.4,262.7h-1.8v5.5h-1.2v-5.5h-1.6v-1h1.6v-1.6l1.2-.4v2h1.8v1Z"
        />
        <path
          d="M212.6,281c0-2,1.4-3.4,3.4-3.4s1.6.2,2,.5v1.3c-.6-.5-1.2-.7-2-.7-1.4,0-2.2,1-2.2,2.3s.8,2.4,2.4,2.4,1.4-.3,1.9-.7v1.2c-.6.4-1.3.6-2.1.6-2,0-3.4-1.5-3.4-3.5Z"
        />
        <path
          d="M219.2,281c0-2,1.2-3.4,3.2-3.4s3.2,1.5,3.2,3.4-1.2,3.4-3.2,3.4-3.2-1.5-3.2-3.4ZM224.3,281c0-1.4-.7-2.4-2-2.4s-1.9,1-1.9,2.4.7,2.4,1.9,2.4,2-1,2-2.4Z"
        />
        <path
          d="M232.7,280.2v4.1h-1.2v-3.8c0-1.3-.4-1.8-1.5-1.8s-1.8.8-1.8,2.1v3.5h-1.2v-6.5h1.2v1.1c.4-.8,1.1-1.3,2.2-1.3s2.3,1,2.3,2.6Z"
        />
        <path
          d="M240.2,280.2v4.1h-1.2v-3.8c0-1.3-.4-1.8-1.5-1.8s-1.8.8-1.8,2.1v3.5h-1.2v-6.5h1.2v1.1c.4-.8,1.1-1.3,2.2-1.3s2.3,1,2.3,2.6Z"
        />
        <path
          d="M247.7,281.2h-4.7c.1,1.4,1,2.1,2.4,2.1s1.6-.3,2.1-.7v1.1c-.5.4-1.3.7-2.2.7-2.1,0-3.5-1.4-3.5-3.5s1.1-3.4,3.2-3.4,2.8,1,2.8,2.8v.9ZM243,280.3h3.5c0-1.1-.7-1.7-1.7-1.7s-1.7.7-1.9,1.7Z"
        />
        <path
          d="M248.8,281c0-2,1.4-3.4,3.4-3.4s1.6.2,2,.5v1.3c-.6-.5-1.2-.7-2-.7-1.4,0-2.2,1-2.2,2.3s.8,2.4,2.4,2.4,1.4-.3,1.9-.7v1.2c-.6.4-1.3.6-2.1.6-2,0-3.4-1.5-3.4-3.5Z"
        />
        <path
          d="M259.6,278.7h-1.8v5.5h-1.2v-5.5h-1.6v-1h1.6v-1.6l1.2-.4v2h1.8v1Z"
        />
        <path
          d="M263.4,281c0-2,1.4-3.4,3.4-3.4s1.6.2,2,.5v1.3c-.6-.5-1.2-.7-2-.7-1.4,0-2.2,1-2.2,2.3s.8,2.4,2.4,2.4,1.4-.3,1.9-.7v1.2c-.6.4-1.3.6-2.1.6-2,0-3.4-1.5-3.4-3.5Z"
        />
        <path
          d="M276,280.2v4.1h-1.2v-3.8c0-1.3-.4-1.8-1.5-1.8s-1.8.8-1.8,2.1v3.5h-1.2v-9.4h1.2v3.9c.4-.8,1.1-1.2,2.2-1.2s2.3,1,2.3,2.6Z"
        />
        <path
          d="M277.8,275.8c0-.4.4-.8.8-.8s.8.3.8.8-.3.8-.8.8-.8-.4-.8-.8ZM278,277.7h1.2v6.5h-1.2v-6.5Z"
        />
        <path d="M281.2,274.9h1.2v9.4h-1.2v-9.4Z" />
        <path
          d="M290.3,274.9v9.4h-1.2v-1.3c-.4.8-1,1.5-2.2,1.5s-2.9-1.4-2.9-3.4,1.3-3.5,3-3.5,1.7.4,2.1,1.3v-4h1.2ZM289.2,280.9c0-1.4-.7-2.3-2-2.3s-2,1-2,2.4.8,2.3,1.9,2.3,2-1,2-2.4Z"
        />
        <path
          d="M295.9,277.9v1.1c-.3-.2-.7-.3-1-.3-.8,0-1.4.7-1.4,2v3.5h-1.2v-6.5h1.2v1.3c.3-.9.9-1.4,1.6-1.4s.6,0,.9.3Z"
        />
        <path
          d="M302.6,281.2h-4.7c.1,1.4,1,2.1,2.4,2.1s1.6-.3,2.1-.7v1.1c-.5.4-1.3.7-2.2.7-2.1,0-3.5-1.4-3.5-3.5s1.1-3.4,3.2-3.4,2.8,1,2.8,2.8v.9ZM297.9,280.3h3.5c0-1.1-.7-1.7-1.7-1.7s-1.7.7-1.9,1.7Z"
        />
        <path
          d="M309.8,280.2v4.1h-1.2v-3.8c0-1.3-.4-1.8-1.5-1.8s-1.8.8-1.8,2.1v3.5h-1.2v-6.5h1.2v1.1c.4-.8,1.1-1.3,2.2-1.3s2.3,1,2.3,2.6Z"
        />
        <path
          d="M319.9,280.3v4h-1.2v-.9c-.3.7-1,1.1-1.8,1.1-1.3,0-2.3-.9-2.3-2.1s1-2.1,2.4-2.1,1.4.4,1.7.8v-.6c0-1.1-.7-1.8-1.7-1.8s-1.5.3-2,.9v-1.2c.5-.4,1.2-.7,2.2-.7,1.7,0,2.8,1,2.8,2.7ZM318.8,282.2c0-.7-.5-1.2-1.4-1.2s-1.4.5-1.4,1.2.5,1.2,1.4,1.2,1.5-.5,1.5-1.2Z"
        />
        <path
          d="M327.5,280.2v4.1h-1.2v-3.8c0-1.3-.4-1.8-1.5-1.8s-1.8.8-1.8,2.1v3.5h-1.2v-6.5h1.2v1.1c.4-.8,1.1-1.3,2.2-1.3s2.3,1,2.3,2.6Z"
        />
        <path
          d="M335.3,274.9v9.4h-1.2v-1.3c-.4.8-1,1.5-2.2,1.5s-2.9-1.4-2.9-3.4,1.3-3.5,3-3.5,1.7.4,2.1,1.3v-4h1.2ZM334.1,280.9c0-1.4-.7-2.3-2-2.3s-2,1-2,2.4.8,2.3,1.9,2.3,2-1,2-2.4Z"
        />
        <path
          d="M346,277.7l-4.1,9h-1.3l1.5-3.1-2.5-5.8h1.3l1.8,4.5,2-4.5h1.3Z"
        />
        <path
          d="M346.5,281c0-2,1.2-3.4,3.2-3.4s3.2,1.5,3.2,3.4-1.2,3.4-3.2,3.4-3.2-1.5-3.2-3.4ZM351.6,281c0-1.4-.7-2.4-2-2.4s-1.9,1-1.9,2.4.7,2.4,1.9,2.4,2-1,2-2.4Z"
        />
        <path
          d="M359.9,277.7v6.5h-1.2v-1.2c-.4.9-1.1,1.4-2,1.4-1.4,0-2.3-.9-2.3-2.5v-4.1h1.2v3.8c0,1.2.5,1.8,1.5,1.8s1.7-.8,1.7-2.3v-3.4h1.2Z"
        />
        <path
          d="M367.5,280.2v4.1h-1.2v-3.8c0-1.3-.4-1.8-1.5-1.8s-1.8.8-1.8,2.1v3.5h-1.2v-6.5h1.2v1.1c.4-.8,1.1-1.3,2.2-1.3s2.3,1,2.3,2.6Z"
        />
        <path
          d="M375.2,277.7v5.9c0,2-1.3,3.2-3.3,3.2s-1.7-.2-2.3-.8v-1.2c.6.6,1.4.9,2.2.9,1.6,0,2.2-1,2.2-2.4v-.8c-.4,1-1.1,1.5-2.2,1.5-1.8,0-2.8-1.3-2.8-3.2s1.2-3.3,3-3.3,1.6.4,2,1.4v-1.2h1.2ZM374,280.8c0-1.3-.8-2.2-1.9-2.2s-1.9.9-1.9,2.2.7,2.1,1.8,2.1,1.9-.9,1.9-2.2Z"
        />
        <path
          d="M221.1,296.9c0,2.1-1.4,3.5-3,3.5s-1.7-.5-2.1-1.3v3.5h-1.2v-9h1.2v1.3c.4-.8,1.1-1.5,2.3-1.5,1.7,0,2.8,1.5,2.8,3.4ZM219.9,297c0-1.4-.8-2.3-2-2.3s-2,1-2,2.4.7,2.3,1.9,2.3,2-1,2-2.4Z"
        />
        <path
          d="M228.2,297.2h-4.7c.1,1.4,1,2.1,2.4,2.1s1.6-.3,2.1-.7v1.1c-.5.4-1.3.7-2.2.7-2.1,0-3.5-1.4-3.5-3.5s1.1-3.4,3.2-3.4,2.8,1,2.8,2.8v.9ZM223.5,296.3h3.5c0-1.1-.7-1.7-1.7-1.7s-1.7.7-1.9,1.7Z"
        />
        <path
          d="M229.3,297c0-2,1.2-3.4,3.2-3.4s3.2,1.5,3.2,3.4-1.2,3.4-3.2,3.4-3.2-1.5-3.2-3.4ZM234.5,297c0-1.4-.7-2.4-2-2.4s-1.9,1-1.9,2.4.7,2.4,1.9,2.4,2-1,2-2.4Z"
        />
        <path
          d="M243.5,296.9c0,2.1-1.4,3.5-3,3.5s-1.7-.5-2.1-1.3v3.5h-1.2v-9h1.2v1.3c.4-.8,1.1-1.5,2.3-1.5,1.7,0,2.8,1.5,2.8,3.4ZM242.3,297c0-1.4-.8-2.3-2-2.3s-2,1-2,2.4.7,2.3,1.9,2.3,2-1,2-2.4Z"
        />
        <path d="M245.1,290.9h1.2v9.4h-1.2v-9.4Z" />
        <path
          d="M253.9,297.2h-4.7c.1,1.4,1,2.1,2.4,2.1s1.6-.3,2.1-.7v1.1c-.5.4-1.3.7-2.2.7-2.1,0-3.5-1.4-3.5-3.5s1.1-3.4,3.2-3.4,2.8,1,2.8,2.8v.9ZM249.2,296.3h3.5c0-1.1-.7-1.7-1.7-1.7s-1.7.7-1.9,1.7Z"
        />
        <path
          d="M262.3,294.7h-1.8v5.5h-1.2v-5.5h-1.6v-1h1.6v-1.6l1.2-.4v2h1.8v1Z"
        />
        <path
          d="M262.9,297c0-2,1.2-3.4,3.2-3.4s3.2,1.5,3.2,3.4-1.2,3.4-3.2,3.4-3.2-1.5-3.2-3.4ZM268.1,297c0-1.4-.7-2.4-2-2.4s-1.9,1-1.9,2.4.7,2.4,1.9,2.4,2-1,2-2.4Z"
        />
        <path
          d="M277.7,294.7h-1.8v5.5h-1.2v-5.5h-1.6v-1h1.6v-1.6l1.2-.4v2h1.8v1Z"
        />
        <path
          d="M284.5,296.2v4.1h-1.2v-3.8c0-1.3-.4-1.8-1.5-1.8s-1.8.8-1.8,2.1v3.5h-1.2v-9.4h1.2v3.9c.4-.8,1.1-1.2,2.2-1.2s2.3,1,2.3,2.6Z"
        />
        <path
          d="M291.9,297.2h-4.7c.1,1.4,1,2.1,2.4,2.1s1.6-.3,2.1-.7v1.1c-.5.4-1.3.7-2.2.7-2.1,0-3.5-1.4-3.5-3.5s1.1-3.4,3.2-3.4,2.8,1,2.8,2.8v.9ZM287.3,296.3h3.5c0-1.1-.7-1.7-1.7-1.7s-1.7.7-1.9,1.7Z"
        />
        <path d="M296.9,290.9h1.2v9.4h-1.2v-9.4Z" />
        <path
          d="M305.1,296.3v4h-1.2v-.9c-.3.7-1,1.1-1.8,1.1-1.3,0-2.3-.9-2.3-2.1s1-2.1,2.4-2.1,1.4.4,1.7.8v-.6c0-1.1-.7-1.8-1.7-1.8s-1.5.3-2,.9v-1.2c.5-.4,1.2-.7,2.2-.7,1.7,0,2.8,1,2.8,2.7ZM303.9,298.2c0-.7-.5-1.2-1.4-1.2s-1.4.5-1.4,1.2.5,1.2,1.4,1.2,1.5-.5,1.5-1.2Z"
        />
        <path
          d="M312.6,296.2v4.1h-1.2v-3.8c0-1.3-.4-1.8-1.5-1.8s-1.8.8-1.8,2.1v3.5h-1.2v-6.5h1.2v1.1c.4-.8,1.1-1.3,2.2-1.3s2.3,1,2.3,2.6Z"
        />
        <path
          d="M320.4,290.9v9.4h-1.2v-1.3c-.4.8-1,1.5-2.2,1.5s-2.9-1.4-2.9-3.4,1.3-3.5,3-3.5,1.7.4,2.1,1.3v-4h1.2ZM319.2,296.9c0-1.4-.7-2.3-2-2.3s-2,1-2,2.4.8,2.3,1.9,2.3,2-1,2-2.4Z"
        />
        <path d="M322.4,298.7h1.5l-1.2,3.5h-.9l.6-3.5Z" />
        <path
          d="M328.7,299.6v-1.1c.6.5,1.4.9,2.3.9s1.3-.3,1.3-1-.2-.7-.8-.9l-1.2-.4c-1.1-.3-1.5-1-1.5-1.8s.9-1.8,2.4-1.8,1.5.3,2.1.6v1.2c-.6-.5-1.3-.7-2.1-.7s-1.2.3-1.2.8.3.7.8.8l1.2.3c1.2.3,1.6,1,1.6,1.9s-1,2.1-2.4,2.1-1.7-.2-2.4-.8Z"
        />
        <path
          d="M340.5,293.7v6.5h-1.2v-1.2c-.4.9-1.1,1.4-2,1.4-1.4,0-2.3-.9-2.3-2.5v-4.1h1.2v3.8c0,1.2.5,1.8,1.5,1.8s1.7-.8,1.7-2.3v-3.4h1.2Z"
        />
        <path
          d="M348.8,296.9c0,2.1-1.4,3.5-3,3.5s-1.7-.5-2.1-1.3v3.5h-1.2v-9h1.2v1.3c.4-.8,1.1-1.5,2.3-1.5,1.7,0,2.8,1.5,2.8,3.4ZM347.5,297c0-1.4-.8-2.3-2-2.3s-2,1-2,2.4.7,2.3,1.9,2.3,2-1,2-2.4Z"
        />
        <path
          d="M356.6,296.9c0,2.1-1.4,3.5-3,3.5s-1.7-.5-2.1-1.3v3.5h-1.2v-9h1.2v1.3c.4-.8,1.1-1.5,2.3-1.5,1.7,0,2.8,1.5,2.8,3.4ZM355.4,297c0-1.4-.8-2.3-2-2.3s-2,1-2,2.4.7,2.3,1.9,2.3,2-1,2-2.4Z"
        />
        <path
          d="M357.7,297c0-2,1.2-3.4,3.2-3.4s3.2,1.5,3.2,3.4-1.2,3.4-3.2,3.4-3.2-1.5-3.2-3.4ZM362.9,297c0-1.4-.7-2.4-2-2.4s-1.9,1-1.9,2.4.7,2.4,1.9,2.4,2-1,2-2.4Z"
        />
        <path
          d="M369.3,293.9v1.1c-.3-.2-.7-.3-1-.3-.8,0-1.4.7-1.4,2v3.5h-1.2v-6.5h1.2v1.3c.3-.9.9-1.4,1.6-1.4s.6,0,.9.3Z"
        />
        <path
          d="M374.3,294.7h-1.8v5.5h-1.2v-5.5h-1.6v-1h1.6v-1.6l1.2-.4v2h1.8v1Z"
        />
        <path
          d="M233.1,309.9v1.1c-.3-.2-.7-.3-1-.3-.8,0-1.4.7-1.4,2v3.5h-1.2v-6.5h1.2v1.3c.3-.9.9-1.4,1.6-1.4s.6,0,.9.3Z"
        />
        <path
          d="M239.8,309.7v6.5h-1.2v-1.2c-.4.9-1.1,1.4-2,1.4-1.4,0-2.3-.9-2.3-2.5v-4.1h1.2v3.8c0,1.2.5,1.8,1.5,1.8s1.7-.8,1.7-2.3v-3.4h1.2Z"
        />
        <path
          d="M245.5,309.9v1.1c-.3-.2-.7-.3-1-.3-.8,0-1.4.7-1.4,2v3.5h-1.2v-6.5h1.2v1.3c.3-.9.9-1.4,1.6-1.4s.6,0,.9.3Z"
        />
        <path
          d="M251.5,312.3v4h-1.2v-.9c-.3.7-1,1.1-1.8,1.1-1.3,0-2.3-.9-2.3-2.1s1-2.1,2.4-2.1,1.4.4,1.7.8v-.6c0-1.1-.7-1.8-1.7-1.8s-1.5.3-2,.9v-1.2c.5-.4,1.2-.7,2.2-.7,1.7,0,2.8,1,2.8,2.7ZM250.3,314.2c0-.7-.5-1.2-1.4-1.2s-1.4.5-1.4,1.2.5,1.2,1.4,1.2,1.5-.5,1.5-1.2Z"
        />
        <path d="M253.4,306.9h1.2v9.4h-1.2v-9.4Z" />
        <path
          d="M259.6,313c0-2,1.4-3.4,3.4-3.4s1.6.2,2,.5v1.3c-.6-.5-1.2-.7-2-.7-1.4,0-2.2,1-2.2,2.3s.8,2.4,2.4,2.4,1.4-.3,1.9-.7v1.2c-.6.4-1.3.6-2.1.6-2,0-3.4-1.5-3.4-3.5Z"
        />
        <path
          d="M266.2,313c0-1.9,1.2-3.4,3.2-3.4s3.2,1.5,3.2,3.4-1.2,3.4-3.2,3.4-3.2-1.5-3.2-3.4ZM271.3,313c0-1.4-.7-2.4-2-2.4s-1.9,1-1.9,2.4.7,2.4,1.9,2.4,2-1,2-2.4Z"
        />
        <path
          d="M282.9,312v4.2h-1.2v-4.1c0-1.1-.4-1.6-1.2-1.6s-1.4.6-1.4,1.4v4.2h-1.2v-4.2c0-.9-.5-1.4-1.3-1.4s-1.4.7-1.4,1.7v4h-1.2v-6.5h1.2v1.1c.4-.8,1-1.3,1.8-1.3s1.5.5,1.8,1.2c.4-.8,1-1.2,1.9-1.2,1.3,0,2.1.9,2.1,2.4Z"
        />
        <path
          d="M293.7,312v4.2h-1.2v-4.1c0-1.1-.4-1.6-1.2-1.6s-1.4.6-1.4,1.4v4.2h-1.2v-4.2c0-.9-.5-1.4-1.3-1.4s-1.4.7-1.4,1.7v4h-1.2v-6.5h1.2v1.1c.4-.8,1-1.3,1.8-1.3s1.5.5,1.8,1.2c.4-.8,1-1.2,1.9-1.2,1.3,0,2.1.9,2.1,2.4Z"
        />
        <path
          d="M301.1,309.7v6.5h-1.2v-1.2c-.4.9-1.1,1.4-2,1.4-1.4,0-2.3-.9-2.3-2.5v-4.1h1.2v3.8c0,1.2.5,1.8,1.5,1.8s1.7-.8,1.7-2.3v-3.4h1.2Z"
        />
        <path
          d="M308.7,312.2v4.1h-1.2v-3.8c0-1.3-.4-1.8-1.5-1.8s-1.8.8-1.8,2.1v3.5h-1.2v-6.5h1.2v1.1c.4-.8,1.1-1.3,2.2-1.3s2.3,1,2.3,2.6Z"
        />
        <path
          d="M310.5,307.8c0-.4.4-.8.8-.8s.8.3.8.8-.3.8-.8.8-.8-.4-.8-.8ZM310.7,309.7h1.2v6.5h-1.2v-6.5Z"
        />
        <path
          d="M317.7,310.7h-1.8v5.5h-1.2v-5.5h-1.6v-1h1.6v-1.6l1.2-.4v2h1.8v1Z"
        />
        <path
          d="M318.7,307.8c0-.4.4-.8.8-.8s.8.3.8.8-.3.8-.8.8-.8-.4-.8-.8ZM318.9,309.7h1.2v6.5h-1.2v-6.5Z"
        />
        <path
          d="M327.7,313.2h-4.7c.1,1.4,1,2.1,2.4,2.1s1.6-.3,2.1-.7v1.1c-.5.4-1.3.7-2.2.7-2.1,0-3.5-1.4-3.5-3.5s1.1-3.4,3.2-3.4,2.8,1,2.8,2.8v.9ZM323,312.3h3.5c0-1.1-.7-1.7-1.7-1.7s-1.7.7-1.9,1.7Z"
        />
        <path
          d="M328.9,315.6v-1.1c.6.5,1.4.9,2.3.9s1.3-.3,1.3-1-.2-.7-.8-.9l-1.2-.4c-1.1-.3-1.5-1-1.5-1.8s.9-1.8,2.4-1.8,1.5.3,2.1.6v1.2c-.6-.5-1.3-.7-2.1-.7s-1.2.3-1.2.8.3.7.8.8l1.2.3c1.2.3,1.6,1,1.6,1.9s-1,2.1-2.4,2.1-1.7-.2-2.4-.8Z"
        />
        <path
          d="M343.4,312.3v4h-1.2v-.9c-.3.7-1,1.1-1.8,1.1-1.3,0-2.3-.9-2.3-2.1s1-2.1,2.4-2.1,1.4.4,1.7.8v-.6c0-1.1-.7-1.8-1.7-1.8s-1.5.3-2,.9v-1.2c.5-.4,1.2-.7,2.2-.7,1.7,0,2.8,1,2.8,2.7ZM342.2,314.2c0-.7-.5-1.2-1.4-1.2s-1.4.5-1.4,1.2.5,1.2,1.4,1.2,1.5-.5,1.5-1.2Z"
        />
        <path
          d="M350.9,312.2v4.1h-1.2v-3.8c0-1.3-.4-1.8-1.5-1.8s-1.8.8-1.8,2.1v3.5h-1.2v-6.5h1.2v1.1c.4-.8,1.1-1.3,2.2-1.3s2.3,1,2.3,2.6Z"
        />
        <path
          d="M358.7,306.9v9.4h-1.2v-1.3c-.4.8-1,1.5-2.2,1.5s-2.9-1.4-2.9-3.4,1.3-3.5,3-3.5,1.7.4,2.1,1.3v-4h1.2ZM357.6,312.9c0-1.4-.7-2.3-2-2.3s-2,1-2,2.4.8,2.3,1.9,2.3,2-1,2-2.4Z"
        />
        <path
          d="M235.7,328.9c0,2.1-1.4,3.5-3,3.5s-1.7-.5-2.1-1.3v3.5h-1.2v-9h1.2v1.3c.4-.8,1.1-1.5,2.3-1.5,1.7,0,2.8,1.5,2.8,3.4ZM234.5,329c0-1.4-.8-2.3-2-2.3s-2,1-2,2.4.7,2.3,1.9,2.3,2-1,2-2.4Z"
        />
        <path
          d="M240.9,325.9v1.1c-.3-.2-.7-.3-1-.3-.8,0-1.4.7-1.4,2v3.5h-1.2v-6.5h1.2v1.3c.3-.9.9-1.4,1.6-1.4s.6,0,.9.3Z"
        />
        <path
          d="M241.6,329c0-1.9,1.2-3.4,3.2-3.4s3.2,1.5,3.2,3.4-1.2,3.4-3.2,3.4-3.2-1.5-3.2-3.4ZM246.7,329c0-1.4-.7-2.4-2-2.4s-1.9,1-1.9,2.4.7,2.4,1.9,2.4,2-1,2-2.4Z"
        />
        <path
          d="M258.3,328v4.2h-1.2v-4.1c0-1.1-.4-1.6-1.2-1.6s-1.4.6-1.4,1.4v4.2h-1.2v-4.2c0-.9-.5-1.4-1.3-1.4s-1.4.7-1.4,1.7v4h-1.2v-6.5h1.2v1.1c.4-.8,1-1.3,1.8-1.3s1.5.5,1.8,1.2c.4-.8,1-1.2,1.9-1.2,1.3,0,2.1.9,2.1,2.4Z"
        />
        <path
          d="M259.8,329c0-1.9,1.2-3.4,3.2-3.4s3.2,1.5,3.2,3.4-1.2,3.4-3.2,3.4-3.2-1.5-3.2-3.4ZM264.9,329c0-1.4-.7-2.4-2-2.4s-1.9,1-1.9,2.4.7,2.4,1.9,2.4,2-1,2-2.4Z"
        />
        <path
          d="M271.3,326.7h-1.8v5.5h-1.2v-5.5h-1.6v-1h1.6v-1.6l1.2-.4v2h1.8v1Z"
        />
        <path
          d="M277.9,329.2h-4.7c.1,1.4,1,2.1,2.4,2.1s1.6-.3,2.1-.7v1.1c-.5.4-1.3.7-2.2.7-2.1,0-3.5-1.4-3.5-3.5s1.1-3.4,3.2-3.4,2.8,1,2.8,2.8v.9ZM273.2,328.3h3.5c0-1.1-.7-1.7-1.7-1.7s-1.7.7-1.9,1.7Z"
        />
        <path
          d="M282.5,331.6v-1.1c.6.5,1.4.9,2.3.9s1.3-.3,1.3-1-.2-.7-.8-.9l-1.2-.4c-1.1-.3-1.5-1-1.5-1.8s.9-1.8,2.4-1.8,1.5.3,2.1.6v1.2c-.6-.5-1.3-.7-2.1-.7s-1.2.3-1.2.8.3.7.8.8l1.2.3c1.2.3,1.6,1,1.6,1.9s-1,2.1-2.4,2.1-1.7-.2-2.4-.8Z"
        />
        <path
          d="M294.2,325.7v6.5h-1.2v-1.2c-.4.9-1.1,1.4-2,1.4-1.4,0-2.3-.9-2.3-2.5v-4.1h1.2v3.8c0,1.2.5,1.8,1.5,1.8s1.7-.8,1.7-2.3v-3.4h1.2Z"
        />
        <path
          d="M295.8,331.6v-1.1c.6.5,1.4.9,2.3.9s1.3-.3,1.3-1-.2-.7-.8-.9l-1.2-.4c-1.1-.3-1.5-1-1.5-1.8s.9-1.8,2.4-1.8,1.5.3,2.1.6v1.2c-.6-.5-1.3-.7-2.1-.7s-1.2.3-1.2.8.3.7.8.8l1.2.3c1.2.3,1.6,1,1.6,1.9s-1,2.1-2.4,2.1-1.7-.2-2.4-.8Z"
        />
        <path
          d="M305.9,326.7h-1.8v5.5h-1.2v-5.5h-1.6v-1h1.6v-1.6l1.2-.4v2h1.8v1Z"
        />
        <path
          d="M311.8,328.3v4h-1.2v-.9c-.3.7-1,1.1-1.8,1.1-1.3,0-2.3-.9-2.3-2.1s1-2.1,2.4-2.1,1.4.4,1.7.8v-.6c0-1.1-.7-1.8-1.7-1.8s-1.5.3-2,.9v-1.2c.5-.4,1.2-.7,2.2-.7,1.7,0,2.8,1,2.8,2.7ZM310.7,330.2c0-.7-.5-1.2-1.4-1.2s-1.4.5-1.4,1.2.5,1.2,1.4,1.2,1.5-.5,1.5-1.2Z"
        />
        <path
          d="M313.6,323.8c0-.4.4-.8.8-.8s.8.3.8.8-.3.8-.8.8-.8-.4-.8-.8ZM313.8,325.7h1.2v6.5h-1.2v-6.5Z"
        />
        <path
          d="M322.7,328.2v4.1h-1.2v-3.8c0-1.3-.4-1.8-1.5-1.8s-1.8.8-1.8,2.1v3.5h-1.2v-6.5h1.2v1.1c.4-.8,1.1-1.3,2.2-1.3s2.3,1,2.3,2.6Z"
        />
        <path
          d="M329.5,328.3v4h-1.2v-.9c-.3.7-1,1.1-1.8,1.1-1.3,0-2.3-.9-2.3-2.1s1-2.1,2.4-2.1,1.4.4,1.7.8v-.6c0-1.1-.7-1.8-1.7-1.8s-1.5.3-2,.9v-1.2c.5-.4,1.2-.7,2.2-.7,1.7,0,2.8,1,2.8,2.7ZM328.3,330.2c0-.7-.5-1.2-1.4-1.2s-1.4.5-1.4,1.2.5,1.2,1.4,1.2,1.5-.5,1.5-1.2Z"
        />
        <path
          d="M337.7,328.9c0,2.1-1.4,3.5-3,3.5s-1.8-.5-2.2-1.4v1.2h-1.2v-9.4h1.2v4.2c.4-.8,1.1-1.5,2.3-1.5,1.7,0,2.8,1.5,2.8,3.4ZM336.5,329c0-1.4-.8-2.3-2-2.3s-2,1-2,2.4.7,2.3,1.9,2.3,2-1,2-2.4Z"
        />
        <path
          d="M339.1,323.8c0-.4.4-.8.8-.8s.8.3.8.8-.3.8-.8.8-.8-.4-.8-.8ZM339.3,325.7h1.2v6.5h-1.2v-6.5Z"
        />
        <path d="M342.6,322.9h1.2v9.4h-1.2v-9.4Z" />
        <path
          d="M345.6,323.8c0-.4.4-.8.8-.8s.8.3.8.8-.3.8-.8.8-.8-.4-.8-.8ZM345.8,325.7h1.2v6.5h-1.2v-6.5Z"
        />
        <path
          d="M352.8,326.7h-1.8v5.5h-1.2v-5.5h-1.6v-1h1.6v-1.6l1.2-.4v2h1.8v1Z"
        />
        <path
          d="M359.6,325.7l-4.1,9h-1.3l1.5-3.1-2.5-5.8h1.3l1.8,4.5,2-4.5h1.3Z"
        />
        <path
          d="M257,344.3v4h-1.2v-.9c-.3.7-1,1.1-1.8,1.1-1.3,0-2.3-.9-2.3-2.1s1-2.1,2.4-2.1,1.4.4,1.7.8v-.6c0-1.1-.7-1.8-1.7-1.8s-1.5.3-2,.9v-1.2c.5-.4,1.2-.7,2.2-.7,1.7,0,2.8,1,2.8,2.7ZM255.8,346.2c0-.7-.5-1.2-1.4-1.2s-1.4.5-1.4,1.2.5,1.2,1.4,1.2,1.5-.5,1.5-1.2Z"
        />
        <path
          d="M264.5,344.2v4.1h-1.2v-3.8c0-1.3-.4-1.8-1.5-1.8s-1.8.8-1.8,2.1v3.5h-1.2v-6.5h1.2v1.1c.4-.8,1.1-1.3,2.2-1.3s2.3,1,2.3,2.6Z"
        />
        <path
          d="M272.3,338.9v9.4h-1.2v-1.3c-.4.8-1,1.5-2.2,1.5s-2.9-1.4-2.9-3.4,1.3-3.5,3-3.5,1.7.4,2.1,1.3v-4h1.2ZM271.1,344.9c0-1.4-.7-2.3-2-2.3s-2,1-2,2.4.8,2.3,1.9,2.3,2-1,2-2.4Z"
        />
        <path
          d="M286.6,341.7l-2.1,6.5h-1.1l-1.6-5.2-1.7,5.2h-1.1l-2-6.5h1.3l1.3,4.8,1.5-4.8h1.3l1.5,4.8,1.4-4.8h1.2Z"
        />
        <path
          d="M293.3,345.2h-4.7c.1,1.4,1,2.1,2.4,2.1s1.6-.3,2.1-.7v1.1c-.5.4-1.3.7-2.2.7-2.1,0-3.5-1.4-3.5-3.5s1.1-3.4,3.2-3.4,2.8,1,2.8,2.8v.9ZM288.6,344.3h3.5c0-1.1-.7-1.7-1.7-1.7s-1.7.7-1.9,1.7Z"
        />
        <path d="M294.9,338.9h1.2v9.4h-1.2v-9.4Z" />
        <path d="M298.2,338.9h1.2v9.4h-1.2v-9.4Z" />
        <path
          d="M307.7,344.9c0,2.1-1.4,3.5-3,3.5s-1.8-.5-2.2-1.4v1.2h-1.2v-9.4h1.2v4.2c.4-.8,1.1-1.5,2.3-1.5,1.7,0,2.8,1.5,2.8,3.4ZM306.5,345c0-1.4-.8-2.3-2-2.3s-2,1-2,2.4.7,2.3,1.9,2.3,2-1,2-2.4Z"
        />
        <path
          d="M314.8,345.2h-4.7c.1,1.4,1,2.1,2.4,2.1s1.6-.3,2.1-.7v1.1c-.5.4-1.3.7-2.2.7-2.1,0-3.5-1.4-3.5-3.5s1.1-3.4,3.2-3.4,2.8,1,2.8,2.8v.9ZM310.1,344.3h3.5c0-1.1-.7-1.7-1.7-1.7s-1.7.7-1.9,1.7Z"
        />
        <path
          d="M316.2,339.8c0-.4.4-.8.8-.8s.8.3.8.8-.3.8-.8.8-.8-.4-.8-.8ZM316.4,341.7h1.2v6.5h-1.2v-6.5Z"
        />
        <path
          d="M325.3,344.2v4.1h-1.2v-3.8c0-1.3-.4-1.8-1.5-1.8s-1.8.8-1.8,2.1v3.5h-1.2v-6.5h1.2v1.1c.4-.8,1.1-1.3,2.2-1.3s2.3,1,2.3,2.6Z"
        />
        <path
          d="M333,341.7v5.9c0,2-1.3,3.2-3.3,3.2s-1.7-.2-2.3-.8v-1.2c.6.6,1.4.9,2.2.9,1.6,0,2.2-1,2.2-2.4v-.8c-.4,1-1.1,1.5-2.2,1.5-1.8,0-2.8-1.3-2.8-3.2s1.2-3.3,3-3.3,1.6.4,2,1.4v-1.2h1.2ZM331.8,344.8c0-1.3-.8-2.2-1.9-2.2s-1.9.9-1.9,2.2.7,2.1,1.8,2.1,1.9-.9,1.9-2.2Z"
        />
        <path d="M334.7,347.5c0-.5.4-.9.9-.9s.9.4.9.9-.4.9-.9.9-.9-.4-.9-.9Z" />
      </g>
      <g :class="[displayPicto(Healthy_Diet)]">
        <path
          d="M271.9,233.8l-2.4,9.1h-1.6l-2-7.9-2,7.9h-1.6l-2.3-9.1h1.4l1.8,7.7,2-7.7h1.7l2,7.7,1.9-7.7h1.3Z"
        />
        <path
          d="M278.4,239.9h-4.7c.1,1.4,1,2.1,2.4,2.1s1.6-.3,2.1-.7v1.1c-.5.4-1.3.7-2.2.7-2.1,0-3.5-1.4-3.5-3.5s1.1-3.4,3.2-3.4,2.8,1,2.8,2.8v.9ZM273.7,239h3.5c0-1.1-.7-1.7-1.7-1.7s-1.7.7-1.9,1.7Z"
        />
        <path
          d="M283,242.3v-1.1c.6.5,1.4.9,2.3.9s1.3-.3,1.3-1-.2-.7-.8-.9l-1.2-.4c-1.1-.3-1.5-1-1.5-1.8s.9-1.8,2.4-1.8,1.5.3,2.1.6v1.2c-.6-.5-1.3-.7-2.1-.7s-1.2.3-1.2.8.3.7.8.8l1.2.3c1.2.3,1.6,1,1.6,1.9s-1,2.1-2.4,2.1-1.7-.2-2.4-.8Z"
        />
        <path
          d="M294.7,236.4v6.5h-1.2v-1.2c-.4.9-1.1,1.4-2,1.4-1.4,0-2.3-.9-2.3-2.5v-4.1h1.2v3.8c0,1.2.5,1.8,1.5,1.8s1.7-.8,1.7-2.3v-3.4h1.2Z"
        />
        <path
          d="M303,239.6c0,2.1-1.4,3.5-3,3.5s-1.7-.5-2.1-1.3v3.5h-1.2v-9h1.2v1.3c.4-.8,1.1-1.5,2.3-1.5,1.7,0,2.8,1.5,2.8,3.4ZM301.8,239.6c0-1.4-.8-2.3-2-2.3s-2,1-2,2.4.7,2.3,1.9,2.3,2-1,2-2.4Z"
        />
        <path
          d="M310.9,239.6c0,2.1-1.4,3.5-3,3.5s-1.7-.5-2.1-1.3v3.5h-1.2v-9h1.2v1.3c.4-.8,1.1-1.5,2.3-1.5,1.7,0,2.8,1.5,2.8,3.4ZM309.7,239.6c0-1.4-.8-2.3-2-2.3s-2,1-2,2.4.7,2.3,1.9,2.3,2-1,2-2.4Z"
        />
        <path
          d="M312,239.6c0-2,1.2-3.4,3.2-3.4s3.2,1.5,3.2,3.4-1.2,3.4-3.2,3.4-3.2-1.5-3.2-3.4ZM317.2,239.6c0-1.4-.7-2.4-2-2.4s-1.9,1-1.9,2.4.7,2.4,1.9,2.4,2-1,2-2.4Z"
        />
        <path
          d="M323.5,236.6v1.1c-.3-.2-.7-.3-1-.3-.8,0-1.4.7-1.4,2v3.5h-1.2v-6.5h1.2v1.3c.3-.9.9-1.4,1.6-1.4s.6,0,.9.3Z"
        />
        <path
          d="M328.5,237.4h-1.8v5.5h-1.2v-5.5h-1.6v-1h1.6v-1.6l1.2-.4v2h1.8v1Z"
        />
        <path
          d="M226.9,250.4c0-.4.4-.8.8-.8s.8.3.8.8-.3.8-.8.8-.8-.4-.8-.8ZM227.1,252.4h1.2v6.5h-1.2v-6.5Z"
        />
        <path
          d="M235.9,254.8v4.1h-1.2v-3.8c0-1.3-.4-1.8-1.5-1.8s-1.8.8-1.8,2.1v3.5h-1.2v-6.5h1.2v1.1c.4-.8,1.1-1.3,2.2-1.3s2.3,1,2.3,2.6Z"
        />
        <path
          d="M241.5,253.4h-1.8v5.5h-1.2v-5.5h-1.6v-1h1.6v-1.6l1.2-.4v2h1.8v1Z"
        />
        <path
          d="M248.1,255.9h-4.7c.1,1.4,1,2.1,2.4,2.1s1.6-.3,2.1-.7v1.1c-.5.4-1.3.7-2.2.7-2.1,0-3.5-1.4-3.5-3.5s1.1-3.4,3.2-3.4,2.8,1,2.8,2.8v.9ZM243.4,255h3.5c0-1.1-.7-1.7-1.7-1.7s-1.7.7-1.9,1.7Z"
        />
        <path
          d="M253.3,252.6v1.1c-.3-.2-.7-.3-1-.3-.8,0-1.4.7-1.4,2v3.5h-1.2v-6.5h1.2v1.3c.3-.9.9-1.4,1.6-1.4s.6,0,.9.3Z"
        />
        <path d="M260,252.4l-2.5,6.5h-1.1l-2.5-6.5h1.3l1.8,5,1.8-5h1.2Z" />
        <path
          d="M266.6,255.9h-4.7c.1,1.4,1,2.1,2.4,2.1s1.6-.3,2.1-.7v1.1c-.5.4-1.3.7-2.2.7-2.1,0-3.5-1.4-3.5-3.5s1.1-3.4,3.2-3.4,2.8,1,2.8,2.8v.9ZM261.9,255h3.5c0-1.1-.7-1.7-1.7-1.7s-1.7.7-1.9,1.7Z"
        />
        <path
          d="M273.8,254.8v4.1h-1.2v-3.8c0-1.3-.4-1.8-1.5-1.8s-1.8.8-1.8,2.1v3.5h-1.2v-6.5h1.2v1.1c.4-.8,1.1-1.3,2.2-1.3s2.3,1,2.3,2.6Z"
        />
        <path
          d="M279.4,253.4h-1.8v5.5h-1.2v-5.5h-1.6v-1h1.6v-1.6l1.2-.4v2h1.8v1Z"
        />
        <path
          d="M280.4,250.4c0-.4.4-.8.8-.8s.8.3.8.8-.3.8-.8.8-.8-.4-.8-.8ZM280.6,252.4h1.2v6.5h-1.2v-6.5Z"
        />
        <path
          d="M283.4,255.6c0-2,1.2-3.4,3.2-3.4s3.2,1.5,3.2,3.4-1.2,3.4-3.2,3.4-3.2-1.5-3.2-3.4ZM288.5,255.6c0-1.4-.7-2.4-2-2.4s-1.9,1-1.9,2.4.7,2.4,1.9,2.4,2-1,2-2.4Z"
        />
        <path
          d="M296.9,254.8v4.1h-1.2v-3.8c0-1.3-.4-1.8-1.5-1.8s-1.8.8-1.8,2.1v3.5h-1.2v-6.5h1.2v1.1c.4-.8,1.1-1.3,2.2-1.3s2.3,1,2.3,2.6Z"
        />
        <path
          d="M298.5,258.3v-1.1c.6.5,1.4.9,2.3.9s1.3-.3,1.3-1-.2-.7-.8-.9l-1.2-.4c-1.1-.3-1.5-1-1.5-1.8s.9-1.8,2.4-1.8,1.5.3,2.1.6v1.2c-.6-.5-1.3-.7-2.1-.7s-1.2.3-1.2.8.3.7.8.8l1.2.3c1.2.3,1.6,1,1.6,1.9s-1,2.1-2.4,2.1-1.7-.2-2.4-.8Z"
        />
        <path
          d="M311.6,253.4h-1.8v5.5h-1.2v-5.5h-1.6v-1h1.6v-1.6l1.2-.4v2h1.8v1Z"
        />
        <path
          d="M318.4,254.8v4.1h-1.2v-3.8c0-1.3-.4-1.8-1.5-1.8s-1.8.8-1.8,2.1v3.5h-1.2v-9.4h1.2v3.9c.4-.8,1.1-1.2,2.2-1.2s2.3,1,2.3,2.6Z"
        />
        <path
          d="M325.2,254.9v4h-1.2v-.9c-.3.7-1,1.1-1.8,1.1-1.3,0-2.3-.9-2.3-2.1s1-2.1,2.4-2.1,1.4.4,1.7.8v-.6c0-1.1-.7-1.8-1.7-1.8s-1.5.3-2,.9v-1.2c.5-.4,1.2-.7,2.2-.7,1.7,0,2.8,1,2.8,2.7ZM324,256.9c0-.7-.5-1.2-1.4-1.2s-1.4.5-1.4,1.2.5,1.2,1.4,1.2,1.5-.5,1.5-1.2Z"
        />
        <path
          d="M330.8,253.4h-1.8v5.5h-1.2v-5.5h-1.6v-1h1.6v-1.6l1.2-.4v2h1.8v1Z"
        />
        <path
          d="M334.9,250.4c0-.4.4-.8.8-.8s.8.3.8.8-.3.8-.8.8-.8-.4-.8-.8ZM335.1,252.4h1.2v6.5h-1.2v-6.5Z"
        />
        <path
          d="M343.9,254.8v4.1h-1.2v-3.8c0-1.3-.4-1.8-1.5-1.8s-1.8.8-1.8,2.1v3.5h-1.2v-6.5h1.2v1.1c.4-.8,1.1-1.3,2.2-1.3s2.3,1,2.3,2.6Z"
        />
        <path
          d="M345.4,258.3v-1.1c.6.5,1.4.9,2.3.9s1.3-.3,1.3-1-.2-.7-.8-.9l-1.2-.4c-1.1-.3-1.5-1-1.5-1.8s.9-1.8,2.4-1.8,1.5.3,2.1.6v1.2c-.6-.5-1.3-.7-2.1-.7s-1.2.3-1.2.8.3.7.8.8l1.2.3c1.2.3,1.6,1,1.6,1.9s-1,2.1-2.4,2.1-1.7-.2-2.4-.8Z"
        />
        <path
          d="M355.5,253.4h-1.8v5.5h-1.2v-5.5h-1.6v-1h1.6v-1.6l1.2-.4v2h1.8v1Z"
        />
        <path
          d="M356.5,250.4c0-.4.4-.8.8-.8s.8.3.8.8-.3.8-.8.8-.8-.4-.8-.8ZM356.7,252.4h1.2v6.5h-1.2v-6.5Z"
        />
        <path d="M360,249.5h1.2v9.4h-1.2v-9.4Z" />
        <path
          d="M227,270.8v4.1h-1.2v-3.8c0-1.3-.4-1.8-1.5-1.8s-1.8.8-1.8,2.1v3.5h-1.2v-9.4h1.2v3.9c.4-.8,1.1-1.2,2.2-1.2s2.3,1,2.3,2.6Z"
        />
        <path
          d="M228.5,271.6c0-2,1.2-3.4,3.2-3.4s3.2,1.5,3.2,3.4-1.2,3.4-3.2,3.4-3.2-1.5-3.2-3.4ZM233.6,271.6c0-1.4-.7-2.4-2-2.4s-1.9,1-1.9,2.4.7,2.4,1.9,2.4,2-1,2-2.4Z"
        />
        <path d="M236.4,265.5h1.2v9.4h-1.2v-9.4Z" />
        <path
          d="M239.5,266.4c0-.4.4-.8.8-.8s.8.3.8.8-.3.8-.8.8-.8-.4-.8-.8ZM239.7,268.4h1.2v6.5h-1.2v-6.5Z"
        />
        <path
          d="M242.6,274.3v-1.1c.6.5,1.4.9,2.3.9s1.3-.3,1.3-1-.2-.7-.8-.9l-1.2-.4c-1.1-.3-1.5-1-1.5-1.8s.9-1.8,2.4-1.8,1.5.3,2.1.6v1.2c-.6-.5-1.3-.7-2.1-.7s-1.2.3-1.2.8.3.7.8.8l1.2.3c1.2.3,1.6,1,1.6,1.9s-1,2.1-2.4,2.1-1.7-.2-2.4-.8Z"
        />
        <path
          d="M252.6,269.4h-1.8v5.5h-1.2v-5.5h-1.6v-1h1.6v-1.6l1.2-.4v2h1.8v1Z"
        />
        <path
          d="M253.6,266.4c0-.4.4-.8.8-.8s.8.3.8.8-.3.8-.8.8-.8-.4-.8-.8ZM253.8,268.4h1.2v6.5h-1.2v-6.5Z"
        />
        <path
          d="M256.6,271.6c0-2,1.4-3.4,3.4-3.4s1.6.2,2,.5v1.3c-.6-.5-1.2-.7-2-.7-1.4,0-2.2,1-2.2,2.3s.8,2.4,2.4,2.4,1.4-.3,1.9-.7v1.2c-.6.4-1.3.6-2.1.6-2,0-3.4-1.5-3.4-3.5Z"
        />
        <path
          d="M272.5,268.4v6.5h-1.2v-1.2c-.4.9-1.1,1.4-2,1.4-1.4,0-2.3-.9-2.3-2.5v-4.1h1.2v3.8c0,1.2.5,1.8,1.5,1.8s1.7-.8,1.7-2.3v-3.4h1.2Z"
        />
        <path
          d="M280.1,270.8v4.1h-1.2v-3.8c0-1.3-.4-1.8-1.5-1.8s-1.8.8-1.8,2.1v3.5h-1.2v-6.5h1.2v1.1c.4-.8,1.1-1.3,2.2-1.3s2.3,1,2.3,2.6Z"
        />
        <path
          d="M287.9,265.5v9.4h-1.2v-1.3c-.4.8-1,1.5-2.2,1.5s-2.9-1.4-2.9-3.4,1.3-3.5,3-3.5,1.7.4,2.1,1.3v-4h1.2ZM286.7,271.6c0-1.4-.7-2.3-2-2.3s-2,1-2,2.4.8,2.3,1.9,2.3,2-1,2-2.4Z"
        />
        <path
          d="M295.4,271.9h-4.7c.1,1.4,1,2.1,2.4,2.1s1.6-.3,2.1-.7v1.1c-.5.4-1.3.7-2.2.7-2.1,0-3.5-1.4-3.5-3.5s1.1-3.4,3.2-3.4,2.8,1,2.8,2.8v.9ZM290.7,271h3.5c0-1.1-.7-1.7-1.7-1.7s-1.7.7-1.9,1.7Z"
        />
        <path
          d="M300.6,268.6v1.1c-.3-.2-.7-.3-1-.3-.8,0-1.4.7-1.4,2v3.5h-1.2v-6.5h1.2v1.3c.3-.9.9-1.4,1.6-1.4s.6,0,.9.3Z"
        />
        <path
          d="M301.4,274.3v-1.1c.6.5,1.4.9,2.3.9s1.3-.3,1.3-1-.2-.7-.8-.9l-1.2-.4c-1.1-.3-1.5-1-1.5-1.8s.9-1.8,2.4-1.8,1.5.3,2.1.6v1.2c-.6-.5-1.3-.7-2.1-.7s-1.2.3-1.2.8.3.7.8.8l1.2.3c1.2.3,1.6,1,1.6,1.9s-1,2.1-2.4,2.1-1.7-.2-2.4-.8Z"
        />
        <path
          d="M311.4,269.4h-1.8v5.5h-1.2v-5.5h-1.6v-1h1.6v-1.6l1.2-.4v2h1.8v1Z"
        />
        <path
          d="M317.4,270.9v4h-1.2v-.9c-.3.7-1,1.1-1.8,1.1-1.3,0-2.3-.9-2.3-2.1s1-2.1,2.4-2.1,1.4.4,1.7.8v-.6c0-1.1-.7-1.8-1.7-1.8s-1.5.3-2,.9v-1.2c.5-.4,1.2-.7,2.2-.7,1.7,0,2.8,1,2.8,2.7ZM316.2,272.9c0-.7-.5-1.2-1.4-1.2s-1.4.5-1.4,1.2.5,1.2,1.4,1.2,1.5-.5,1.5-1.2Z"
        />
        <path
          d="M325,270.8v4.1h-1.2v-3.8c0-1.3-.4-1.8-1.5-1.8s-1.8.8-1.8,2.1v3.5h-1.2v-6.5h1.2v1.1c.4-.8,1.1-1.3,2.2-1.3s2.3,1,2.3,2.6Z"
        />
        <path
          d="M332.7,265.5v9.4h-1.2v-1.3c-.4.8-1,1.5-2.2,1.5s-2.9-1.4-2.9-3.4,1.3-3.5,3-3.5,1.7.4,2.1,1.3v-4h1.2ZM331.6,271.6c0-1.4-.7-2.3-2-2.3s-2,1-2,2.4.8,2.3,1.9,2.3,2-1,2-2.4Z"
        />
        <path
          d="M334.6,266.4c0-.4.4-.8.8-.8s.8.3.8.8-.3.8-.8.8-.8-.4-.8-.8ZM334.8,268.4h1.2v6.5h-1.2v-6.5Z"
        />
        <path
          d="M343.6,270.8v4.1h-1.2v-3.8c0-1.3-.4-1.8-1.5-1.8s-1.8.8-1.8,2.1v3.5h-1.2v-6.5h1.2v1.1c.4-.8,1.1-1.3,2.2-1.3s2.3,1,2.3,2.6Z"
        />
        <path
          d="M351.3,268.4v5.9c0,2-1.3,3.2-3.3,3.2s-1.7-.2-2.3-.8v-1.2c.6.6,1.4.9,2.2.9,1.6,0,2.2-1,2.2-2.4v-.8c-.4,1-1.1,1.5-2.2,1.5-1.8,0-2.8-1.3-2.8-3.2s1.2-3.3,3-3.3,1.6.4,2,1.4v-1.2h1.2ZM350.1,271.4c0-1.3-.8-2.2-1.9-2.2s-1.9.9-1.9,2.2.7,2.1,1.8,2.1,1.9-.9,1.9-2.2Z"
        />
        <path
          d="M356.3,271.6c0-2,1.2-3.4,3.2-3.4s3.2,1.5,3.2,3.4-1.2,3.4-3.2,3.4-3.2-1.5-3.2-3.4ZM361.4,271.6c0-1.4-.7-2.4-2-2.4s-1.9,1-1.9,2.4.7,2.4,1.9,2.4,2-1,2-2.4Z"
        />
        <path
          d="M365.7,267.5v.9h2v1h-2v5.5h-1.2v-5.5h-1.1v-1h1.1v-.8c0-1.4.8-2.2,2.1-2.2s1,.1,1.3.3v1c-.3-.2-.7-.3-1.1-.3-.7,0-1,.4-1,1.1Z"
        />
        <path
          d="M220.7,287.6c0,2.1-1.4,3.5-3,3.5s-1.8-.5-2.2-1.4v1.2h-1.2v-9.4h1.2v4.2c.4-.8,1.1-1.5,2.3-1.5,1.7,0,2.8,1.5,2.8,3.4ZM219.5,287.6c0-1.4-.8-2.3-2-2.3s-2,1-2,2.4.7,2.3,1.9,2.3,2-1,2-2.4Z"
        />
        <path
          d="M227.1,286.9v4h-1.2v-.9c-.3.7-1,1.1-1.8,1.1-1.3,0-2.3-.9-2.3-2.1s1-2.1,2.4-2.1,1.4.4,1.7.8v-.6c0-1.1-.7-1.8-1.7-1.8s-1.5.3-2,.9v-1.2c.5-.4,1.2-.7,2.2-.7,1.7,0,2.8,1,2.8,2.7ZM226,288.9c0-.7-.5-1.2-1.4-1.2s-1.4.5-1.4,1.2.5,1.2,1.4,1.2,1.5-.5,1.5-1.2Z"
        />
        <path d="M229.1,281.5h1.2v9.4h-1.2v-9.4Z" />
        <path
          d="M237.2,286.9v4h-1.2v-.9c-.3.7-1,1.1-1.8,1.1-1.3,0-2.3-.9-2.3-2.1s1-2.1,2.4-2.1,1.4.4,1.7.8v-.6c0-1.1-.7-1.8-1.7-1.8s-1.5.3-2,.9v-1.2c.5-.4,1.2-.7,2.2-.7,1.7,0,2.8,1,2.8,2.7ZM236,288.9c0-.7-.5-1.2-1.4-1.2s-1.4.5-1.4,1.2.5,1.2,1.4,1.2,1.5-.5,1.5-1.2Z"
        />
        <path
          d="M244.8,286.8v4.1h-1.2v-3.8c0-1.3-.4-1.8-1.5-1.8s-1.8.8-1.8,2.1v3.5h-1.2v-6.5h1.2v1.1c.4-.8,1.1-1.3,2.2-1.3s2.3,1,2.3,2.6Z"
        />
        <path
          d="M246.2,287.6c0-2,1.4-3.4,3.4-3.4s1.6.2,2,.5v1.3c-.6-.5-1.2-.7-2-.7-1.4,0-2.2,1-2.2,2.3s.8,2.4,2.4,2.4,1.4-.3,1.9-.7v1.2c-.6.4-1.3.6-2.1.6-2,0-3.4-1.5-3.4-3.5Z"
        />
        <path
          d="M258.8,287.9h-4.7c.1,1.4,1,2.1,2.4,2.1s1.6-.3,2.1-.7v1.1c-.5.4-1.3.7-2.2.7-2.1,0-3.5-1.4-3.5-3.5s1.1-3.4,3.2-3.4,2.8,1,2.8,2.8v.9ZM254.1,287h3.5c0-1.1-.7-1.7-1.7-1.7s-1.7.7-1.9,1.7Z"
        />
        <path
          d="M266.2,281.5v9.4h-1.2v-1.3c-.4.8-1,1.5-2.2,1.5s-2.9-1.4-2.9-3.4,1.3-3.5,3-3.5,1.7.4,2.1,1.3v-4h1.2ZM265,287.6c0-1.4-.7-2.3-2-2.3s-2,1-2,2.4.8,2.3,1.9,2.3,2-1,2-2.4Z"
        />
        <path
          d="M277.5,281.5v9.4h-1.2v-1.3c-.4.8-1,1.5-2.2,1.5s-2.9-1.4-2.9-3.4,1.3-3.5,3-3.5,1.7.4,2.1,1.3v-4h1.2ZM276.3,287.6c0-1.4-.7-2.3-2-2.3s-2,1-2,2.4.8,2.3,1.9,2.3,2-1,2-2.4Z"
        />
        <path
          d="M279.3,282.4c0-.4.4-.8.8-.8s.8.3.8.8-.3.8-.8.8-.8-.4-.8-.8ZM279.5,284.4h1.2v6.5h-1.2v-6.5Z"
        />
        <path
          d="M288.3,287.9h-4.7c.1,1.4,1,2.1,2.4,2.1s1.6-.3,2.1-.7v1.1c-.5.4-1.3.7-2.2.7-2.1,0-3.5-1.4-3.5-3.5s1.1-3.4,3.2-3.4,2.8,1,2.8,2.8v.9ZM283.6,287h3.5c0-1.1-.7-1.7-1.7-1.7s-1.7.7-1.9,1.7Z"
        />
        <path
          d="M293.5,285.4h-1.8v5.5h-1.2v-5.5h-1.6v-1h1.6v-1.6l1.2-.4v2h1.8v1Z"
        />
        <path
          d="M294.2,290.3v-1.1c.6.5,1.4.9,2.3.9s1.3-.3,1.3-1-.2-.7-.8-.9l-1.2-.4c-1.1-.3-1.5-1-1.5-1.8s.9-1.8,2.4-1.8,1.5.3,2.1.6v1.2c-.6-.5-1.3-.7-2.1-.7s-1.2.3-1.2.8.3.7.8.8l1.2.3c1.2.3,1.6,1,1.6,1.9s-1,2.1-2.4,2.1-1.7-.2-2.4-.8Z"
        />
        <path
          d="M308.8,286.9v4h-1.2v-.9c-.3.7-1,1.1-1.8,1.1-1.3,0-2.3-.9-2.3-2.1s1-2.1,2.4-2.1,1.4.4,1.7.8v-.6c0-1.1-.7-1.8-1.7-1.8s-1.5.3-2,.9v-1.2c.5-.4,1.2-.7,2.2-.7,1.7,0,2.8,1,2.8,2.7ZM307.6,288.9c0-.7-.5-1.2-1.4-1.2s-1.4.5-1.4,1.2.5,1.2,1.4,1.2,1.5-.5,1.5-1.2Z"
        />
        <path
          d="M316.3,286.8v4.1h-1.2v-3.8c0-1.3-.4-1.8-1.5-1.8s-1.8.8-1.8,2.1v3.5h-1.2v-6.5h1.2v1.1c.4-.8,1.1-1.3,2.2-1.3s2.3,1,2.3,2.6Z"
        />
        <path
          d="M324.1,281.5v9.4h-1.2v-1.3c-.4.8-1,1.5-2.2,1.5s-2.9-1.4-2.9-3.4,1.3-3.5,3-3.5,1.7.4,2.1,1.3v-4h1.2ZM322.9,287.6c0-1.4-.7-2.3-2-2.3s-2,1-2,2.4.8,2.3,1.9,2.3,2-1,2-2.4Z"
        />
        <path
          d="M329.1,290.3v-1.1c.6.5,1.4.9,2.3.9s1.3-.3,1.3-1-.2-.7-.8-.9l-1.2-.4c-1.1-.3-1.5-1-1.5-1.8s.9-1.8,2.4-1.8,1.5.3,2.1.6v1.2c-.6-.5-1.3-.7-2.1-.7s-1.2.3-1.2.8.3.7.8.8l1.2.3c1.2.3,1.6,1,1.6,1.9s-1,2.1-2.4,2.1-1.7-.2-2.4-.8Z"
        />
        <path
          d="M340.9,284.4v6.5h-1.2v-1.2c-.4.9-1.1,1.4-2,1.4-1.4,0-2.3-.9-2.3-2.5v-4.1h1.2v3.8c0,1.2.5,1.8,1.5,1.8s1.7-.8,1.7-2.3v-3.4h1.2Z"
        />
        <path
          d="M349.2,287.6c0,2.1-1.4,3.5-3,3.5s-1.7-.5-2.1-1.3v3.5h-1.2v-9h1.2v1.3c.4-.8,1.1-1.5,2.3-1.5,1.7,0,2.8,1.5,2.8,3.4ZM347.9,287.6c0-1.4-.8-2.3-2-2.3s-2,1-2,2.4.7,2.3,1.9,2.3,2-1,2-2.4Z"
        />
        <path
          d="M357,287.6c0,2.1-1.4,3.5-3,3.5s-1.7-.5-2.1-1.3v3.5h-1.2v-9h1.2v1.3c.4-.8,1.1-1.5,2.3-1.5,1.7,0,2.8,1.5,2.8,3.4ZM355.8,287.6c0-1.4-.8-2.3-2-2.3s-2,1-2,2.4.7,2.3,1.9,2.3,2-1,2-2.4Z"
        />
        <path
          d="M358.1,287.6c0-2,1.2-3.4,3.2-3.4s3.2,1.5,3.2,3.4-1.2,3.4-3.2,3.4-3.2-1.5-3.2-3.4ZM363.3,287.6c0-1.4-.7-2.4-2-2.4s-1.9,1-1.9,2.4.7,2.4,1.9,2.4,2-1,2-2.4Z"
        />
        <path
          d="M369.7,284.6v1.1c-.3-.2-.7-.3-1-.3-.8,0-1.4.7-1.4,2v3.5h-1.2v-6.5h1.2v1.3c.3-.9.9-1.4,1.6-1.4s.6,0,.9.3Z"
        />
        <path
          d="M374.6,285.4h-1.8v5.5h-1.2v-5.5h-1.6v-1h1.6v-1.6l1.2-.4v2h1.8v1Z"
        />
        <path
          d="M228.8,303.6c0-2,1.4-3.4,3.4-3.4s1.6.2,2,.5v1.3c-.6-.5-1.2-.7-2-.7-1.4,0-2.2,1-2.2,2.3s.8,2.4,2.4,2.4,1.4-.3,1.9-.7v1.2c-.6.4-1.3.6-2.1.6-2,0-3.4-1.5-3.4-3.5Z"
        />
        <path
          d="M235.4,303.6c0-2,1.2-3.4,3.2-3.4s3.2,1.5,3.2,3.4-1.2,3.4-3.2,3.4-3.2-1.5-3.2-3.4ZM240.5,303.6c0-1.4-.7-2.4-2-2.4s-1.9,1-1.9,2.4.7,2.4,1.9,2.4,2-1,2-2.4Z"
        />
        <path
          d="M252.1,302.6v4.3h-1.2v-4.1c0-1.1-.4-1.6-1.2-1.6s-1.4.6-1.4,1.4v4.2h-1.2v-4.2c0-.9-.5-1.4-1.3-1.4s-1.4.7-1.4,1.7v4h-1.2v-6.5h1.2v1.1c.4-.8,1-1.3,1.8-1.3s1.5.5,1.8,1.2c.4-.8,1-1.2,1.9-1.2,1.3,0,2.1.9,2.1,2.4Z"
        />
        <path
          d="M260.4,303.6c0,2.1-1.4,3.5-3,3.5s-1.7-.5-2.1-1.3v3.5h-1.2v-9h1.2v1.3c.4-.8,1.1-1.5,2.3-1.5,1.7,0,2.8,1.5,2.8,3.4ZM259.2,303.6c0-1.4-.8-2.3-2-2.3s-2,1-2,2.4.7,2.3,1.9,2.3,2-1,2-2.4Z"
        />
        <path
          d="M265.5,300.6v1.1c-.3-.2-.7-.3-1-.3-.8,0-1.4.7-1.4,2v3.5h-1.2v-6.5h1.2v1.3c.3-.9.9-1.4,1.6-1.4s.6,0,.9.3Z"
        />
        <path
          d="M272.2,303.9h-4.7c.1,1.4,1,2.1,2.4,2.1s1.6-.3,2.1-.7v1.1c-.5.4-1.3.7-2.2.7-2.1,0-3.5-1.4-3.5-3.5s1.1-3.4,3.2-3.4,2.8,1,2.8,2.8v.9ZM267.5,303h3.5c0-1.1-.7-1.7-1.7-1.7s-1.7.7-1.9,1.7Z"
        />
        <path
          d="M279.4,302.8v4.1h-1.2v-3.8c0-1.3-.4-1.8-1.5-1.8s-1.8.8-1.8,2.1v3.5h-1.2v-9.4h1.2v3.9c.4-.8,1.1-1.2,2.2-1.2s2.3,1,2.3,2.6Z"
        />
        <path
          d="M286.8,303.9h-4.7c.1,1.4,1,2.1,2.4,2.1s1.6-.3,2.1-.7v1.1c-.5.4-1.3.7-2.2.7-2.1,0-3.5-1.4-3.5-3.5s1.1-3.4,3.2-3.4,2.8,1,2.8,2.8v.9ZM282.1,303h3.5c0-1.1-.7-1.7-1.7-1.7s-1.7.7-1.9,1.7Z"
        />
        <path
          d="M294,302.8v4.1h-1.2v-3.8c0-1.3-.4-1.8-1.5-1.8s-1.8.8-1.8,2.1v3.5h-1.2v-6.5h1.2v1.1c.4-.8,1.1-1.3,2.2-1.3s2.3,1,2.3,2.6Z"
        />
        <path
          d="M295.6,306.3v-1.1c.6.5,1.4.9,2.3.9s1.3-.3,1.3-1-.2-.7-.8-.9l-1.2-.4c-1.1-.3-1.5-1-1.5-1.8s.9-1.8,2.4-1.8,1.5.3,2.1.6v1.2c-.6-.5-1.3-.7-2.1-.7s-1.2.3-1.2.8.3.7.8.8l1.2.3c1.2.3,1.6,1,1.6,1.9s-1,2.1-2.4,2.1-1.7-.2-2.4-.8Z"
        />
        <path
          d="M301.7,298.4c0-.4.4-.8.8-.8s.8.3.8.8-.3.8-.8.8-.8-.4-.8-.8ZM301.9,300.4h1.2v6.5h-1.2v-6.5Z"
        />
        <path d="M310.6,300.4l-2.5,6.5h-1.1l-2.5-6.5h1.3l1.8,5,1.8-5h1.2Z" />
        <path
          d="M317.2,303.9h-4.7c.1,1.4,1,2.1,2.4,2.1s1.6-.3,2.1-.7v1.1c-.5.4-1.3.7-2.2.7-2.1,0-3.5-1.4-3.5-3.5s1.1-3.4,3.2-3.4,2.8,1,2.8,2.8v.9ZM312.5,303h3.5c0-1.1-.7-1.7-1.7-1.7s-1.7.7-1.9,1.7Z"
        />
        <path
          d="M327,302.9v4h-1.2v-.9c-.3.7-1,1.1-1.8,1.1-1.3,0-2.3-.9-2.3-2.1s1-2.1,2.4-2.1,1.4.4,1.7.8v-.6c0-1.1-.7-1.8-1.7-1.8s-1.5.3-2,.9v-1.2c.5-.4,1.2-.7,2.2-.7,1.7,0,2.8,1,2.8,2.7ZM325.8,304.9c0-.7-.5-1.2-1.4-1.2s-1.4.5-1.4,1.2.5,1.2,1.4,1.2,1.5-.5,1.5-1.2Z"
        />
        <path
          d="M328.5,303.6c0-2,1.4-3.4,3.4-3.4s1.6.2,2,.5v1.3c-.6-.5-1.2-.7-2-.7-1.4,0-2.2,1-2.2,2.3s.8,2.4,2.4,2.4,1.4-.3,1.9-.7v1.2c-.6.4-1.3.6-2.1.6-2,0-3.4-1.5-3.4-3.5Z"
        />
        <path
          d="M335.1,303.6c0-2,1.4-3.4,3.4-3.4s1.6.2,2,.5v1.3c-.6-.5-1.2-.7-2-.7-1.4,0-2.2,1-2.2,2.3s.8,2.4,2.4,2.4,1.4-.3,1.9-.7v1.2c-.6.4-1.3.6-2.1.6-2,0-3.4-1.5-3.4-3.5Z"
        />
        <path
          d="M347.6,303.9h-4.7c.1,1.4,1,2.1,2.4,2.1s1.6-.3,2.1-.7v1.1c-.5.4-1.3.7-2.2.7-2.1,0-3.5-1.4-3.5-3.5s1.1-3.4,3.2-3.4,2.8,1,2.8,2.8v.9ZM342.9,303h3.5c0-1.1-.7-1.7-1.7-1.7s-1.7.7-1.9,1.7Z"
        />
        <path
          d="M348.8,306.3v-1.1c.6.5,1.4.9,2.3.9s1.3-.3,1.3-1-.2-.7-.8-.9l-1.2-.4c-1.1-.3-1.5-1-1.5-1.8s.9-1.8,2.4-1.8,1.5.3,2.1.6v1.2c-.6-.5-1.3-.7-2.1-.7s-1.2.3-1.2.8.3.7.8.8l1.2.3c1.2.3,1.6,1,1.6,1.9s-1,2.1-2.4,2.1-1.7-.2-2.4-.8Z"
        />
        <path
          d="M354.7,306.3v-1.1c.6.5,1.4.9,2.3.9s1.3-.3,1.3-1-.2-.7-.8-.9l-1.2-.4c-1.1-.3-1.5-1-1.5-1.8s.9-1.8,2.4-1.8,1.5.3,2.1.6v1.2c-.6-.5-1.3-.7-2.1-.7s-1.2.3-1.2.8.3.7.8.8l1.2.3c1.2.3,1.6,1,1.6,1.9s-1,2.1-2.4,2.1-1.7-.2-2.4-.8Z"
        />
        <path
          d="M228.6,317.4h-1.8v5.5h-1.2v-5.5h-1.6v-1h1.6v-1.6l1.2-.4v2h1.8v1Z"
        />
        <path
          d="M229.2,319.6c0-2,1.2-3.4,3.2-3.4s3.2,1.5,3.2,3.4-1.2,3.4-3.2,3.4-3.2-1.5-3.2-3.4ZM234.3,319.6c0-1.4-.7-2.4-2-2.4s-1.9,1-1.9,2.4.7,2.4,1.9,2.4,2-1,2-2.4Z"
        />
        <path
          d="M242,315.5v.9h2v1h-2v5.5h-1.2v-5.5h-1.1v-1h1.1v-.8c0-1.4.8-2.2,2.1-2.2s1,.1,1.3.3v1c-.3-.2-.7-.3-1.1-.3-.7,0-1,.4-1,1.1Z"
        />
        <path
          d="M244.6,319.6c0-2,1.2-3.4,3.2-3.4s3.2,1.5,3.2,3.4-1.2,3.4-3.2,3.4-3.2-1.5-3.2-3.4ZM249.7,319.6c0-1.4-.7-2.4-2-2.4s-1.9,1-1.9,2.4.7,2.4,1.9,2.4,2-1,2-2.4Z"
        />
        <path
          d="M252.1,319.6c0-2,1.2-3.4,3.2-3.4s3.2,1.5,3.2,3.4-1.2,3.4-3.2,3.4-3.2-1.5-3.2-3.4ZM257.2,319.6c0-1.4-.7-2.4-2-2.4s-1.9,1-1.9,2.4.7,2.4,1.9,2.4,2-1,2-2.4Z"
        />
        <path
          d="M265.8,313.5v9.4h-1.2v-1.3c-.4.8-1,1.5-2.2,1.5s-2.9-1.4-2.9-3.4,1.3-3.5,3-3.5,1.7.4,2.1,1.3v-4h1.2ZM264.7,319.6c0-1.4-.7-2.3-2-2.3s-2,1-2,2.4.8,2.3,1.9,2.3,2-1,2-2.4Z"
        />
        <path
          d="M277.5,319.6c0,2.1-1.4,3.5-3,3.5s-1.7-.5-2.1-1.3v3.5h-1.2v-9h1.2v1.3c.4-.8,1.1-1.5,2.3-1.5,1.7,0,2.8,1.5,2.8,3.4ZM276.3,319.6c0-1.4-.8-2.3-2-2.3s-2,1-2,2.4.7,2.3,1.9,2.3,2-1,2-2.4Z"
        />
        <path
          d="M282.7,316.6v1.1c-.3-.2-.7-.3-1-.3-.8,0-1.4.7-1.4,2v3.5h-1.2v-6.5h1.2v1.3c.3-.9.9-1.4,1.6-1.4s.6,0,.9.3Z"
        />
        <path
          d="M283.3,319.6c0-2,1.2-3.4,3.2-3.4s3.2,1.5,3.2,3.4-1.2,3.4-3.2,3.4-3.2-1.5-3.2-3.4ZM288.5,319.6c0-1.4-.7-2.4-2-2.4s-1.9,1-1.9,2.4.7,2.4,1.9,2.4,2-1,2-2.4Z"
        />
        <path
          d="M297,316.4v5.9c0,2-1.3,3.2-3.3,3.2s-1.7-.2-2.3-.8v-1.2c.6.6,1.4.9,2.2.9,1.6,0,2.2-1,2.2-2.4v-.8c-.4,1-1.1,1.5-2.2,1.5-1.8,0-2.8-1.3-2.8-3.2s1.2-3.3,3-3.3,1.6.4,2,1.4v-1.2h1.2ZM295.8,319.4c0-1.3-.8-2.2-1.9-2.2s-1.9.9-1.9,2.2.7,2.1,1.8,2.1,1.9-.9,1.9-2.2Z"
        />
        <path
          d="M302.6,316.6v1.1c-.3-.2-.7-.3-1-.3-.8,0-1.4.7-1.4,2v3.5h-1.2v-6.5h1.2v1.3c.3-.9.9-1.4,1.6-1.4s.6,0,.9.3Z"
        />
        <path
          d="M308.7,318.9v4h-1.2v-.9c-.3.7-1,1.1-1.8,1.1-1.3,0-2.3-.9-2.3-2.1s1-2.1,2.4-2.1,1.4.4,1.7.8v-.6c0-1.1-.7-1.8-1.7-1.8s-1.5.3-2,.9v-1.2c.5-.4,1.2-.7,2.2-.7,1.7,0,2.8,1,2.8,2.7ZM307.5,320.9c0-.7-.5-1.2-1.4-1.2s-1.4.5-1.4,1.2.5,1.2,1.4,1.2,1.5-.5,1.5-1.2Z"
        />
        <path
          d="M319.4,318.6v4.3h-1.2v-4.1c0-1.1-.4-1.6-1.2-1.6s-1.4.6-1.4,1.4v4.2h-1.2v-4.2c0-.9-.5-1.4-1.3-1.4s-1.4.7-1.4,1.7v4h-1.2v-6.5h1.2v1.1c.4-.8,1-1.3,1.8-1.3s1.5.5,1.8,1.2c.4-.8,1-1.2,1.9-1.2,1.3,0,2.1.9,2.1,2.4Z"
        />
        <path
          d="M330.2,318.6v4.3h-1.2v-4.1c0-1.1-.4-1.6-1.2-1.6s-1.4.6-1.4,1.4v4.2h-1.2v-4.2c0-.9-.5-1.4-1.3-1.4s-1.4.7-1.4,1.7v4h-1.2v-6.5h1.2v1.1c.4-.8,1-1.3,1.8-1.3s1.5.5,1.8,1.2c.4-.8,1-1.2,1.9-1.2,1.3,0,2.1.9,2.1,2.4Z"
        />
        <path
          d="M337.7,319.9h-4.7c.1,1.4,1,2.1,2.4,2.1s1.6-.3,2.1-.7v1.1c-.5.4-1.3.7-2.2.7-2.1,0-3.5-1.4-3.5-3.5s1.1-3.4,3.2-3.4,2.8,1,2.8,2.8v.9ZM333,319h3.5c0-1.1-.7-1.7-1.7-1.7s-1.7.7-1.9,1.7Z"
        />
        <path
          d="M338.9,322.3v-1.1c.6.5,1.4.9,2.3.9s1.3-.3,1.3-1-.2-.7-.8-.9l-1.2-.4c-1.1-.3-1.5-1-1.5-1.8s.9-1.8,2.4-1.8,1.5.3,2.1.6v1.2c-.6-.5-1.3-.7-2.1-.7s-1.2.3-1.2.8.3.7.8.8l1.2.3c1.2.3,1.6,1,1.6,1.9s-1,2.1-2.4,2.1-1.7-.2-2.4-.8Z"
        />
        <path
          d="M350.1,315.5v.9h2v1h-2v5.5h-1.2v-5.5h-1.1v-1h1.1v-.8c0-1.4.8-2.2,2.1-2.2s1,.1,1.3.3v1c-.3-.2-.7-.3-1.1-.3-.7,0-1,.4-1,1.1Z"
        />
        <path
          d="M352.7,319.6c0-2,1.2-3.4,3.2-3.4s3.2,1.5,3.2,3.4-1.2,3.4-3.2,3.4-3.2-1.5-3.2-3.4ZM357.8,319.6c0-1.4-.7-2.4-2-2.4s-1.9,1-1.9,2.4.7,2.4,1.9,2.4,2-1,2-2.4Z"
        />
        <path
          d="M364.2,316.6v1.1c-.3-.2-.7-.3-1-.3-.8,0-1.4.7-1.4,2v3.5h-1.2v-6.5h1.2v1.3c.3-.9.9-1.4,1.6-1.4s.6,0,.9.3Z"
        />
        <path
          d="M227.1,335.6c0-2,1.4-3.4,3.4-3.4s1.6.2,2,.5v1.3c-.6-.5-1.2-.7-2-.7-1.4,0-2.2,1-2.2,2.3s.8,2.4,2.4,2.4,1.4-.3,1.9-.7v1.2c-.6.4-1.3.6-2.1.6-2,0-3.4-1.5-3.4-3.5Z"
        />
        <path
          d="M239.7,334.8v4.1h-1.2v-3.8c0-1.3-.4-1.8-1.5-1.8s-1.8.8-1.8,2.1v3.5h-1.2v-9.4h1.2v3.9c.4-.8,1.1-1.2,2.2-1.2s2.3,1,2.3,2.6Z"
        />
        <path
          d="M241.5,330.4c0-.4.4-.8.8-.8s.8.3.8.8-.3.8-.8.8-.8-.3-.8-.8ZM241.7,332.4h1.2v6.5h-1.2v-6.5Z"
        />
        <path d="M244.9,329.5h1.2v9.4h-1.2v-9.4Z" />
        <path
          d="M254,329.5v9.4h-1.2v-1.3c-.4.8-1,1.5-2.2,1.5s-2.9-1.4-2.9-3.4,1.3-3.5,3-3.5,1.7.4,2.1,1.3v-4h1.2ZM252.9,335.6c0-1.4-.7-2.3-2-2.3s-2,1-2,2.4.8,2.3,1.9,2.3,2-1,2-2.4Z"
        />
        <path
          d="M259.7,332.6v1.1c-.3-.2-.7-.3-1-.3-.8,0-1.4.7-1.4,2v3.5h-1.2v-6.5h1.2v1.3c.3-.9.9-1.4,1.6-1.4s.6,0,.9.3Z"
        />
        <path
          d="M266.3,335.9h-4.7c.1,1.4,1,2.1,2.4,2.1s1.6-.3,2.1-.7v1.1c-.5.4-1.3.7-2.2.7-2.1,0-3.5-1.4-3.5-3.5s1.1-3.4,3.2-3.4,2.8,1,2.8,2.8v.9ZM261.6,335h3.5c0-1.1-.7-1.7-1.7-1.7s-1.7.7-1.9,1.7Z"
        />
        <path
          d="M273.5,334.8v4.1h-1.2v-3.8c0-1.3-.4-1.8-1.5-1.8s-1.8.8-1.8,2.1v3.5h-1.2v-6.5h1.2v1.1c.4-.8,1.1-1.3,2.2-1.3s2.3,1,2.3,2.6Z"
        />
        <path d="M275.4,337.3h1.5l-1.2,3.5h-.9l.6-3.5Z" />
        <path
          d="M287.4,332.4l-4.1,9h-1.3l1.5-3.1-2.5-5.8h1.3l1.8,4.5,2-4.5h1.3Z"
        />
        <path
          d="M287.9,335.6c0-2,1.2-3.4,3.2-3.4s3.2,1.5,3.2,3.4-1.2,3.4-3.2,3.4-3.2-1.5-3.2-3.4ZM293.1,335.6c0-1.4-.7-2.4-2-2.4s-1.9,1-1.9,2.4.7,2.4,1.9,2.4,2-1,2-2.4Z"
        />
        <path
          d="M301.3,332.4v6.5h-1.2v-1.2c-.4.9-1.1,1.4-2,1.4-1.4,0-2.3-.9-2.3-2.5v-4.1h1.2v3.8c0,1.2.5,1.8,1.5,1.8s1.7-.8,1.7-2.3v-3.4h1.2Z"
        />
        <path
          d="M308.9,334.8v4.1h-1.2v-3.8c0-1.3-.4-1.8-1.5-1.8s-1.8.8-1.8,2.1v3.5h-1.2v-6.5h1.2v1.1c.4-.8,1.1-1.3,2.2-1.3s2.3,1,2.3,2.6Z"
        />
        <path
          d="M316.6,332.4v5.9c0,2-1.3,3.2-3.3,3.2s-1.7-.2-2.3-.8v-1.2c.6.6,1.4.9,2.2.9,1.6,0,2.2-1,2.2-2.4v-.8c-.4,1-1.1,1.5-2.2,1.5-1.8,0-2.8-1.3-2.8-3.2s1.2-3.3,3-3.3,1.6.4,2,1.4v-1.2h1.2ZM315.4,335.4c0-1.3-.8-2.2-1.9-2.2s-1.9.9-1.9,2.2.7,2.1,1.8,2.1,1.9-.9,1.9-2.2Z"
        />
        <path
          d="M328.3,335.6c0,2.1-1.4,3.5-3,3.5s-1.7-.5-2.1-1.3v3.5h-1.2v-9h1.2v1.3c.4-.8,1.1-1.5,2.3-1.5,1.7,0,2.8,1.5,2.8,3.4ZM327.1,335.6c0-1.4-.8-2.3-2-2.3s-2,1-2,2.4.7,2.3,1.9,2.3,2-1,2-2.4Z"
        />
        <path
          d="M335.4,335.9h-4.7c.1,1.4,1,2.1,2.4,2.1s1.6-.3,2.1-.7v1.1c-.5.4-1.3.7-2.2.7-2.1,0-3.5-1.4-3.5-3.5s1.1-3.4,3.2-3.4,2.8,1,2.8,2.8v.9ZM330.7,335h3.5c0-1.1-.7-1.7-1.7-1.7s-1.7.7-1.9,1.7Z"
        />
        <path
          d="M336.6,335.6c0-2,1.2-3.4,3.2-3.4s3.2,1.5,3.2,3.4-1.2,3.4-3.2,3.4-3.2-1.5-3.2-3.4ZM341.7,335.6c0-1.4-.7-2.4-2-2.4s-1.9,1-1.9,2.4.7,2.4,1.9,2.4,2-1,2-2.4Z"
        />
        <path
          d="M350.8,335.6c0,2.1-1.4,3.5-3,3.5s-1.7-.5-2.1-1.3v3.5h-1.2v-9h1.2v1.3c.4-.8,1.1-1.5,2.3-1.5,1.7,0,2.8,1.5,2.8,3.4ZM349.5,335.6c0-1.4-.8-2.3-2-2.3s-2,1-2,2.4.7,2.3,1.9,2.3,2-1,2-2.4Z"
        />
        <path d="M352.4,329.5h1.2v9.4h-1.2v-9.4Z" />
        <path
          d="M361.1,335.9h-4.7c.1,1.4,1,2.1,2.4,2.1s1.6-.3,2.1-.7v1.1c-.5.4-1.3.7-2.2.7-2.1,0-3.5-1.4-3.5-3.5s1.1-3.4,3.2-3.4,2.8,1,2.8,2.8v.9ZM356.4,335h3.5c0-1.1-.7-1.7-1.7-1.7s-1.7.7-1.9,1.7Z"
        />
        <path
          d="M247.8,350.9v4h-1.2v-.9c-.3.7-1,1.1-1.8,1.1-1.3,0-2.3-.9-2.3-2.1s1-2.1,2.4-2.1,1.4.4,1.7.8v-.6c0-1.1-.7-1.8-1.7-1.8s-1.5.3-2,.9v-1.2c.5-.4,1.2-.7,2.2-.7,1.7,0,2.8,1,2.8,2.7ZM246.7,352.9c0-.7-.5-1.2-1.4-1.2s-1.4.5-1.4,1.2.5,1.2,1.4,1.2,1.5-.5,1.5-1.2Z"
        />
        <path
          d="M255.4,350.8v4.1h-1.2v-3.8c0-1.3-.4-1.8-1.5-1.8s-1.8.8-1.8,2.1v3.5h-1.2v-6.5h1.2v1.1c.4-.8,1.1-1.3,2.2-1.3s2.3,1,2.3,2.6Z"
        />
        <path
          d="M263.2,345.5v9.4h-1.2v-1.3c-.4.8-1,1.5-2.2,1.5s-2.9-1.4-2.9-3.4,1.3-3.5,3-3.5,1.7.4,2.1,1.3v-4h1.2ZM262,351.6c0-1.4-.7-2.3-2-2.3s-2,1-2,2.4.8,2.3,1.9,2.3,2-1,2-2.4Z"
        />
        <path
          d="M272,349.4h-1.8v5.5h-1.2v-5.5h-1.6v-1h1.6v-1.6l1.2-.4v2h1.8v1Z"
        />
        <path
          d="M278.8,350.8v4.1h-1.2v-3.8c0-1.3-.4-1.8-1.5-1.8s-1.8.8-1.8,2.1v3.5h-1.2v-9.4h1.2v3.9c.4-.8,1.1-1.2,2.2-1.2s2.3,1,2.3,2.6Z"
        />
        <path
          d="M286.3,351.9h-4.7c.1,1.4,1,2.1,2.4,2.1s1.6-.3,2.1-.7v1.1c-.5.4-1.3.7-2.2.7-2.1,0-3.5-1.4-3.5-3.5s1.1-3.4,3.2-3.4,2.8,1,2.8,2.8v.9ZM281.6,351h3.5c0-1.1-.7-1.7-1.7-1.7s-1.7.7-1.9,1.7Z"
        />
        <path
          d="M287.7,346.4c0-.4.4-.8.8-.8s.8.3.8.8-.3.8-.8.8-.8-.3-.8-.8ZM287.9,348.4h1.2v6.5h-1.2v-6.5Z"
        />
        <path
          d="M294.8,348.6v1.1c-.3-.2-.7-.3-1-.3-.8,0-1.4.7-1.4,2v3.5h-1.2v-6.5h1.2v1.3c.3-.9.9-1.4,1.6-1.4s.6,0,.9.3Z"
        />
        <path
          d="M300.6,347.5v.9h2v1h-2v5.5h-1.2v-5.5h-1.1v-1h1.1v-.8c0-1.4.8-2.2,2.1-2.2s1,.1,1.3.3v1c-.3-.2-.7-.3-1.1-.3-.7,0-1,.4-1,1.1Z"
        />
        <path
          d="M308.6,350.9v4h-1.2v-.9c-.3.7-1,1.1-1.8,1.1-1.3,0-2.3-.9-2.3-2.1s1-2.1,2.4-2.1,1.4.4,1.7.8v-.6c0-1.1-.7-1.8-1.7-1.8s-1.5.3-2,.9v-1.2c.5-.4,1.2-.7,2.2-.7,1.7,0,2.8,1,2.8,2.7ZM307.4,352.9c0-.7-.5-1.2-1.4-1.2s-1.4.5-1.4,1.2.5,1.2,1.4,1.2,1.5-.5,1.5-1.2Z"
        />
        <path
          d="M319.4,350.6v4.3h-1.2v-4.1c0-1.1-.4-1.6-1.2-1.6s-1.4.6-1.4,1.4v4.2h-1.2v-4.2c0-.9-.5-1.4-1.3-1.4s-1.4.7-1.4,1.7v4h-1.2v-6.5h1.2v1.1c.4-.8,1-1.3,1.8-1.3s1.5.5,1.8,1.2c.4-.8,1-1.2,1.9-1.2,1.3,0,2.1.9,2.1,2.4Z"
        />
        <path
          d="M321.1,346.4c0-.4.4-.8.8-.8s.8.3.8.8-.3.8-.8.8-.8-.3-.8-.8ZM321.3,348.4h1.2v6.5h-1.2v-6.5Z"
        />
        <path d="M324.6,345.5h1.2v9.4h-1.2v-9.4Z" />
        <path
          d="M327.7,346.4c0-.4.4-.8.8-.8s.8.3.8.8-.3.8-.8.8-.8-.3-.8-.8ZM327.9,348.4h1.2v6.5h-1.2v-6.5Z"
        />
        <path
          d="M336.6,351.9h-4.7c.1,1.4,1,2.1,2.4,2.1s1.6-.3,2.1-.7v1.1c-.5.4-1.3.7-2.2.7-2.1,0-3.5-1.4-3.5-3.5s1.1-3.4,3.2-3.4,2.8,1,2.8,2.8v.9ZM332,351h3.5c0-1.1-.7-1.7-1.7-1.7s-1.7.7-1.9,1.7Z"
        />
        <path
          d="M337.8,354.3v-1.1c.6.5,1.4.9,2.3.9s1.3-.3,1.3-1-.2-.7-.8-.9l-1.2-.4c-1.1-.3-1.5-1-1.5-1.8s.9-1.8,2.4-1.8,1.5.3,2.1.6v1.2c-.6-.5-1.3-.7-2.1-.7s-1.2.3-1.2.8.3.7.8.8l1.2.3c1.2.3,1.6,1,1.6,1.9s-1,2.1-2.4,2.1-1.7-.2-2.4-.8Z"
        />
        <path d="M343.8,354.2c0-.5.4-.9.9-.9s.9.4.9.9-.4.9-.9.9-.9-.4-.9-.9Z" />
      </g>
      <g :class="[displayPicto(Sport_Physical_Activity)]">
        <path
          d="M271.9,243.1l-2.4,9.1h-1.6l-2-7.9-2,7.9h-1.6l-2.3-9.1h1.4l1.8,7.7,2-7.7h1.7l2,7.7,1.9-7.7h1.3Z"
        />
        <path
          d="M278.4,249.2h-4.7c.1,1.4,1,2.1,2.4,2.1s1.6-.3,2.1-.7v1.1c-.5.4-1.3.7-2.2.7-2.1,0-3.5-1.4-3.5-3.5s1.1-3.4,3.2-3.4,2.8,1,2.8,2.8v.9ZM273.7,248.3h3.5c0-1.1-.7-1.7-1.7-1.7s-1.7.7-1.9,1.7Z"
        />
        <path
          d="M283,251.6v-1.1c.6.5,1.4.9,2.3.9s1.3-.3,1.3-1-.2-.7-.8-.9l-1.2-.4c-1.1-.3-1.5-1-1.5-1.8s.9-1.8,2.4-1.8,1.5.3,2.1.6v1.2c-.6-.5-1.3-.7-2.1-.7s-1.2.3-1.2.8.3.7.8.8l1.2.3c1.2.3,1.6,1,1.6,1.9s-1,2.1-2.4,2.1-1.7-.2-2.4-.8Z"
        />
        <path
          d="M294.7,245.7v6.5h-1.2v-1.2c-.4.9-1.1,1.4-2,1.4-1.4,0-2.3-.9-2.3-2.5v-4.1h1.2v3.8c0,1.2.5,1.8,1.5,1.8s1.7-.8,1.7-2.3v-3.4h1.2Z"
        />
        <path
          d="M303,248.9c0,2.1-1.4,3.5-3,3.5s-1.7-.5-2.1-1.3v3.5h-1.2v-9h1.2v1.3c.4-.8,1.1-1.5,2.3-1.5,1.7,0,2.8,1.5,2.8,3.4ZM301.8,249c0-1.4-.8-2.3-2-2.3s-2,1-2,2.4.7,2.3,1.9,2.3,2-1,2-2.4Z"
        />
        <path
          d="M310.9,248.9c0,2.1-1.4,3.5-3,3.5s-1.7-.5-2.1-1.3v3.5h-1.2v-9h1.2v1.3c.4-.8,1.1-1.5,2.3-1.5,1.7,0,2.8,1.5,2.8,3.4ZM309.7,249c0-1.4-.8-2.3-2-2.3s-2,1-2,2.4.7,2.3,1.9,2.3,2-1,2-2.4Z"
        />
        <path
          d="M312,249c0-2,1.2-3.4,3.2-3.4s3.2,1.5,3.2,3.4-1.2,3.4-3.2,3.4-3.2-1.5-3.2-3.4ZM317.2,249c0-1.4-.7-2.4-2-2.4s-1.9,1-1.9,2.4.7,2.4,1.9,2.4,2-1,2-2.4Z"
        />
        <path
          d="M323.5,245.9v1.1c-.3-.2-.7-.3-1-.3-.8,0-1.4.7-1.4,2v3.5h-1.2v-6.5h1.2v1.3c.3-.9.9-1.4,1.6-1.4s.6,0,.9.3Z"
        />
        <path
          d="M328.5,246.7h-1.8v5.5h-1.2v-5.5h-1.6v-1h1.6v-1.6l1.2-.4v2h1.8v1Z"
        />
        <path
          d="M242.5,259.8c0-.4.4-.8.8-.8s.8.3.8.8-.3.8-.8.8-.8-.4-.8-.8ZM242.7,261.7h1.2v6.5h-1.2v-6.5Z"
        />
        <path
          d="M251.5,264.2v4.1h-1.2v-3.8c0-1.3-.4-1.8-1.5-1.8s-1.8.8-1.8,2.1v3.5h-1.2v-6.5h1.2v1.1c.4-.8,1.1-1.3,2.2-1.3s2.3,1,2.3,2.6Z"
        />
        <path
          d="M257.1,262.7h-1.8v5.5h-1.2v-5.5h-1.6v-1h1.6v-1.6l1.2-.4v2h1.8v1Z"
        />
        <path
          d="M263.7,265.2h-4.7c.1,1.4,1,2.1,2.4,2.1s1.6-.3,2.1-.7v1.1c-.5.4-1.3.7-2.2.7-2.1,0-3.5-1.4-3.5-3.5s1.1-3.4,3.2-3.4,2.8,1,2.8,2.8v.9ZM259,264.3h3.5c0-1.1-.7-1.7-1.7-1.7s-1.7.7-1.9,1.7Z"
        />
        <path
          d="M268.9,261.9v1.1c-.3-.2-.7-.3-1-.3-.8,0-1.4.7-1.4,2v3.5h-1.2v-6.5h1.2v1.3c.3-.9.9-1.4,1.6-1.4s.6,0,.9.3Z"
        />
        <path d="M275.6,261.7l-2.5,6.5h-1.1l-2.5-6.5h1.3l1.8,5,1.8-5h1.2Z" />
        <path
          d="M282.2,265.2h-4.7c.1,1.4,1,2.1,2.4,2.1s1.6-.3,2.1-.7v1.1c-.5.4-1.3.7-2.2.7-2.1,0-3.5-1.4-3.5-3.5s1.1-3.4,3.2-3.4,2.8,1,2.8,2.8v.9ZM277.5,264.3h3.5c0-1.1-.7-1.7-1.7-1.7s-1.7.7-1.9,1.7Z"
        />
        <path
          d="M289.4,264.2v4.1h-1.2v-3.8c0-1.3-.4-1.8-1.5-1.8s-1.8.8-1.8,2.1v3.5h-1.2v-6.5h1.2v1.1c.4-.8,1.1-1.3,2.2-1.3s2.3,1,2.3,2.6Z"
        />
        <path
          d="M295,262.7h-1.8v5.5h-1.2v-5.5h-1.6v-1h1.6v-1.6l1.2-.4v2h1.8v1Z"
        />
        <path
          d="M296.1,259.8c0-.4.4-.8.8-.8s.8.3.8.8-.3.8-.8.8-.8-.4-.8-.8ZM296.2,261.7h1.2v6.5h-1.2v-6.5Z"
        />
        <path
          d="M299,265c0-2,1.2-3.4,3.2-3.4s3.2,1.5,3.2,3.4-1.2,3.4-3.2,3.4-3.2-1.5-3.2-3.4ZM304.2,265c0-1.4-.7-2.4-2-2.4s-1.9,1-1.9,2.4.7,2.4,1.9,2.4,2-1,2-2.4Z"
        />
        <path
          d="M312.6,264.2v4.1h-1.2v-3.8c0-1.3-.4-1.8-1.5-1.8s-1.8.8-1.8,2.1v3.5h-1.2v-6.5h1.2v1.1c.4-.8,1.1-1.3,2.2-1.3s2.3,1,2.3,2.6Z"
        />
        <path
          d="M314.1,267.6v-1.1c.6.5,1.4.9,2.3.9s1.3-.3,1.3-1-.2-.7-.8-.9l-1.2-.4c-1.1-.3-1.5-1-1.5-1.8s.9-1.8,2.4-1.8,1.5.3,2.1.6v1.2c-.6-.5-1.3-.7-2.1-.7s-1.2.3-1.2.8.3.7.8.8l1.2.3c1.2.3,1.6,1,1.6,1.9s-1,2.1-2.4,2.1-1.7-.2-2.4-.8Z"
        />
        <path
          d="M327.2,262.7h-1.8v5.5h-1.2v-5.5h-1.6v-1h1.6v-1.6l1.2-.4v2h1.8v1Z"
        />
        <path
          d="M334,264.2v4.1h-1.2v-3.8c0-1.3-.4-1.8-1.5-1.8s-1.8.8-1.8,2.1v3.5h-1.2v-9.4h1.2v3.9c.4-.8,1.1-1.2,2.2-1.2s2.3,1,2.3,2.6Z"
        />
        <path
          d="M340.8,264.3v4h-1.2v-.9c-.3.7-1,1.1-1.8,1.1-1.3,0-2.3-.9-2.3-2.1s1-2.1,2.4-2.1,1.4.4,1.7.8v-.6c0-1.1-.7-1.8-1.7-1.8s-1.5.3-2,.9v-1.2c.5-.4,1.2-.7,2.2-.7,1.7,0,2.8,1,2.8,2.7ZM339.6,266.2c0-.7-.5-1.2-1.4-1.2s-1.4.5-1.4,1.2.5,1.2,1.4,1.2,1.5-.5,1.5-1.2Z"
        />
        <path
          d="M346.4,262.7h-1.8v5.5h-1.2v-5.5h-1.6v-1h1.6v-1.6l1.2-.4v2h1.8v1Z"
        />
        <path
          d="M237.1,281.2h-4.7c.1,1.4,1,2.1,2.4,2.1s1.6-.3,2.1-.7v1.1c-.5.4-1.3.7-2.2.7-2.1,0-3.5-1.4-3.5-3.5s1.1-3.4,3.2-3.4,2.8,1,2.8,2.8v.9ZM232.4,280.3h3.5c0-1.1-.7-1.7-1.7-1.7s-1.7.7-1.9,1.7Z"
        />
        <path
          d="M244.3,280.2v4.1h-1.2v-3.8c0-1.3-.4-1.8-1.5-1.8s-1.8.8-1.8,2.1v3.5h-1.2v-6.5h1.2v1.1c.4-.8,1.1-1.3,2.2-1.3s2.3,1,2.3,2.6Z"
        />
        <path
          d="M251.9,280.2v4.1h-1.2v-3.8c0-1.3-.4-1.8-1.5-1.8s-1.8.8-1.8,2.1v3.5h-1.2v-9.4h1.2v3.9c.4-.8,1.1-1.2,2.2-1.2s2.3,1,2.3,2.6Z"
        />
        <path
          d="M258.7,280.3v4h-1.2v-.9c-.3.7-1,1.1-1.8,1.1-1.3,0-2.3-.9-2.3-2.1s1-2.1,2.4-2.1,1.4.4,1.7.8v-.6c0-1.1-.7-1.8-1.7-1.8s-1.5.3-2,.9v-1.2c.5-.4,1.2-.7,2.2-.7,1.7,0,2.8,1,2.8,2.7ZM257.5,282.2c0-.7-.5-1.2-1.4-1.2s-1.4.5-1.4,1.2.5,1.2,1.4,1.2,1.5-.5,1.5-1.2Z"
        />
        <path
          d="M266.2,280.2v4.1h-1.2v-3.8c0-1.3-.4-1.8-1.5-1.8s-1.8.8-1.8,2.1v3.5h-1.2v-6.5h1.2v1.1c.4-.8,1.1-1.3,2.2-1.3s2.3,1,2.3,2.6Z"
        />
        <path
          d="M267.7,281c0-2,1.4-3.4,3.4-3.4s1.6.2,2,.5v1.3c-.6-.5-1.2-.7-2-.7-1.4,0-2.2,1-2.2,2.3s.8,2.4,2.4,2.4,1.4-.3,1.9-.7v1.2c-.6.4-1.3.6-2.1.6-2,0-3.4-1.5-3.4-3.5Z"
        />
        <path
          d="M280.2,281.2h-4.7c.1,1.4,1,2.1,2.4,2.1s1.6-.3,2.1-.7v1.1c-.5.4-1.3.7-2.2.7-2.1,0-3.5-1.4-3.5-3.5s1.1-3.4,3.2-3.4,2.8,1,2.8,2.8v.9ZM275.5,280.3h3.5c0-1.1-.7-1.7-1.7-1.7s-1.7.7-1.9,1.7Z"
        />
        <path
          d="M284.7,281c0-2,1.4-3.4,3.4-3.4s1.6.2,2,.5v1.3c-.6-.5-1.2-.7-2-.7-1.4,0-2.2,1-2.2,2.3s.8,2.4,2.4,2.4,1.4-.3,1.9-.7v1.2c-.6.4-1.3.6-2.1.6-2,0-3.4-1.5-3.4-3.5Z"
        />
        <path
          d="M297.4,280.2v4.1h-1.2v-3.8c0-1.3-.4-1.8-1.5-1.8s-1.8.8-1.8,2.1v3.5h-1.2v-9.4h1.2v3.9c.4-.8,1.1-1.2,2.2-1.2s2.3,1,2.3,2.6Z"
        />
        <path
          d="M299.1,275.8c0-.4.4-.8.8-.8s.8.3.8.8-.3.8-.8.8-.8-.4-.8-.8ZM299.3,277.7h1.2v6.5h-1.2v-6.5Z"
        />
        <path d="M302.6,274.9h1.2v9.4h-1.2v-9.4Z" />
        <path
          d="M311.7,274.9v9.4h-1.2v-1.3c-.4.8-1,1.5-2.2,1.5s-2.9-1.4-2.9-3.4,1.3-3.5,3-3.5,1.7.4,2.1,1.3v-4h1.2ZM310.5,280.9c0-1.4-.7-2.3-2-2.3s-2,1-2,2.4.8,2.3,1.9,2.3,2-1,2-2.4Z"
        />
        <path
          d="M317.3,277.9v1.1c-.3-.2-.7-.3-1-.3-.8,0-1.4.7-1.4,2v3.5h-1.2v-6.5h1.2v1.3c.3-.9.9-1.4,1.6-1.4s.6,0,.9.3Z"
        />
        <path
          d="M323.9,281.2h-4.7c.1,1.4,1,2.1,2.4,2.1s1.6-.3,2.1-.7v1.1c-.5.4-1.3.7-2.2.7-2.1,0-3.5-1.4-3.5-3.5s1.1-3.4,3.2-3.4,2.8,1,2.8,2.8v.9ZM319.2,280.3h3.5c0-1.1-.7-1.7-1.7-1.7s-1.7.7-1.9,1.7Z"
        />
        <path
          d="M331.1,280.2v4.1h-1.2v-3.8c0-1.3-.4-1.8-1.5-1.8s-1.8.8-1.8,2.1v3.5h-1.2v-6.5h1.2v1.1c.4-.8,1.1-1.3,2.2-1.3s2.3,1,2.3,2.6Z"
        />
        <path
          d="M341.3,280.3v4h-1.2v-.9c-.3.7-1,1.1-1.8,1.1-1.3,0-2.3-.9-2.3-2.1s1-2.1,2.4-2.1,1.4.4,1.7.8v-.6c0-1.1-.7-1.8-1.7-1.8s-1.5.3-2,.9v-1.2c.5-.4,1.2-.7,2.2-.7,1.7,0,2.8,1,2.8,2.7ZM340.1,282.2c0-.7-.5-1.2-1.4-1.2s-1.4.5-1.4,1.2.5,1.2,1.4,1.2,1.5-.5,1.5-1.2Z"
        />
        <path
          d="M348.9,280.2v4.1h-1.2v-3.8c0-1.3-.4-1.8-1.5-1.8s-1.8.8-1.8,2.1v3.5h-1.2v-6.5h1.2v1.1c.4-.8,1.1-1.3,2.2-1.3s2.3,1,2.3,2.6Z"
        />
        <path
          d="M356.6,274.9v9.4h-1.2v-1.3c-.4.8-1,1.5-2.2,1.5s-2.9-1.4-2.9-3.4,1.3-3.5,3-3.5,1.7.4,2.1,1.3v-4h1.2ZM355.5,280.9c0-1.4-.7-2.3-2-2.3s-2,1-2,2.4.8,2.3,1.9,2.3,2-1,2-2.4Z"
        />
        <path
          d="M234.3,293.7l-4.1,9h-1.3l1.5-3.1-2.5-5.8h1.3l1.8,4.5,2-4.5h1.3Z"
        />
        <path
          d="M234.8,297c0-2,1.2-3.4,3.2-3.4s3.2,1.5,3.2,3.4-1.2,3.4-3.2,3.4-3.2-1.5-3.2-3.4ZM239.9,297c0-1.4-.7-2.4-2-2.4s-1.9,1-1.9,2.4.7,2.4,1.9,2.4,2-1,2-2.4Z"
        />
        <path
          d="M248.2,293.7v6.5h-1.2v-1.2c-.4.9-1.1,1.4-2,1.4-1.4,0-2.3-.9-2.3-2.5v-4.1h1.2v3.8c0,1.2.5,1.8,1.5,1.8s1.7-.8,1.7-2.3v-3.4h1.2Z"
        />
        <path
          d="M255.8,296.2v4.1h-1.2v-3.8c0-1.3-.4-1.8-1.5-1.8s-1.8.8-1.8,2.1v3.5h-1.2v-6.5h1.2v1.1c.4-.8,1.1-1.3,2.2-1.3s2.3,1,2.3,2.6Z"
        />
        <path
          d="M263.5,293.7v5.9c0,2-1.3,3.2-3.3,3.2s-1.7-.2-2.3-.8v-1.2c.6.6,1.4.9,2.2.9,1.6,0,2.2-1,2.2-2.4v-.8c-.4,1-1.1,1.5-2.2,1.5-1.8,0-2.8-1.3-2.8-3.2s1.2-3.3,3-3.3,1.6.4,2,1.4v-1.2h1.2ZM262.3,296.8c0-1.3-.8-2.2-1.9-2.2s-1.9.9-1.9,2.2.7,2.1,1.8,2.1,1.9-.9,1.9-2.2Z"
        />
        <path
          d="M275.2,296.9c0,2.1-1.4,3.5-3,3.5s-1.7-.5-2.1-1.3v3.5h-1.2v-9h1.2v1.3c.4-.8,1.1-1.5,2.3-1.5,1.7,0,2.8,1.5,2.8,3.4ZM274,297c0-1.4-.8-2.3-2-2.3s-2,1-2,2.4.7,2.3,1.9,2.3,2-1,2-2.4Z"
        />
        <path
          d="M282.3,297.2h-4.7c.1,1.4,1,2.1,2.4,2.1s1.6-.3,2.1-.7v1.1c-.5.4-1.3.7-2.2.7-2.1,0-3.5-1.4-3.5-3.5s1.1-3.4,3.2-3.4,2.8,1,2.8,2.8v.9ZM277.6,296.3h3.5c0-1.1-.7-1.7-1.7-1.7s-1.7.7-1.9,1.7Z"
        />
        <path
          d="M283.4,297c0-2,1.2-3.4,3.2-3.4s3.2,1.5,3.2,3.4-1.2,3.4-3.2,3.4-3.2-1.5-3.2-3.4ZM288.6,297c0-1.4-.7-2.4-2-2.4s-1.9,1-1.9,2.4.7,2.4,1.9,2.4,2-1,2-2.4Z"
        />
        <path
          d="M297.6,296.9c0,2.1-1.4,3.5-3,3.5s-1.7-.5-2.1-1.3v3.5h-1.2v-9h1.2v1.3c.4-.8,1.1-1.5,2.3-1.5,1.7,0,2.8,1.5,2.8,3.4ZM296.4,297c0-1.4-.8-2.3-2-2.3s-2,1-2,2.4.7,2.3,1.9,2.3,2-1,2-2.4Z"
        />
        <path d="M299.2,290.9h1.2v9.4h-1.2v-9.4Z" />
        <path
          d="M308,297.2h-4.7c.1,1.4,1,2.1,2.4,2.1s1.6-.3,2.1-.7v1.1c-.5.4-1.3.7-2.2.7-2.1,0-3.5-1.4-3.5-3.5s1.1-3.4,3.2-3.4,2.8,1,2.8,2.8v.9ZM303.3,296.3h3.5c0-1.1-.7-1.7-1.7-1.7s-1.7.7-1.9,1.7Z"
        />
        <path d="M309.7,290.6h1.4l-1.2,3.5h-.8l.6-3.5Z" />
        <path
          d="M311.6,299.6v-1.1c.6.5,1.4.9,2.3.9s1.3-.3,1.3-1-.2-.7-.8-.9l-1.2-.4c-1.1-.3-1.5-1-1.5-1.8s.9-1.8,2.4-1.8,1.5.3,2.1.6v1.2c-.6-.5-1.3-.7-2.1-.7s-1.2.3-1.2.8.3.7.8.8l1.2.3c1.2.3,1.6,1,1.6,1.9s-1,2.1-2.4,2.1-1.7-.2-2.4-.8Z"
        />
        <path
          d="M330.1,296v4.3h-1.2v-4.1c0-1.1-.4-1.6-1.2-1.6s-1.4.6-1.4,1.4v4.2h-1.2v-4.2c0-.9-.5-1.4-1.3-1.4s-1.4.7-1.4,1.7v4h-1.2v-6.5h1.2v1.1c.4-.8,1-1.3,1.8-1.3s1.5.5,1.8,1.2c.4-.8,1-1.2,1.9-1.2,1.3,0,2.1.9,2.1,2.4Z"
        />
        <path
          d="M337.6,297.2h-4.7c.1,1.4,1,2.1,2.4,2.1s1.6-.3,2.1-.7v1.1c-.5.4-1.3.7-2.2.7-2.1,0-3.5-1.4-3.5-3.5s1.1-3.4,3.2-3.4,2.8,1,2.8,2.8v.9ZM332.9,296.3h3.5c0-1.1-.7-1.7-1.7-1.7s-1.7.7-1.9,1.7Z"
        />
        <path
          d="M344.8,296.2v4.1h-1.2v-3.8c0-1.3-.4-1.8-1.5-1.8s-1.8.8-1.8,2.1v3.5h-1.2v-6.5h1.2v1.1c.4-.8,1.1-1.3,2.2-1.3s2.3,1,2.3,2.6Z"
        />
        <path
          d="M350.4,294.7h-1.8v5.5h-1.2v-5.5h-1.6v-1h1.6v-1.6l1.2-.4v2h1.8v1Z"
        />
        <path
          d="M356.3,296.3v4h-1.2v-.9c-.3.7-1,1.1-1.8,1.1-1.3,0-2.3-.9-2.3-2.1s1-2.1,2.4-2.1,1.4.4,1.7.8v-.6c0-1.1-.7-1.8-1.7-1.8s-1.5.3-2,.9v-1.2c.5-.4,1.2-.7,2.2-.7,1.7,0,2.8,1,2.8,2.7ZM355.2,298.2c0-.7-.5-1.2-1.4-1.2s-1.4.5-1.4,1.2.5,1.2,1.4,1.2,1.5-.5,1.5-1.2Z"
        />
        <path d="M358.3,290.9h1.2v9.4h-1.2v-9.4Z" />
        <path
          d="M223,312.3v4h-1.2v-.9c-.3.7-1,1.1-1.8,1.1-1.3,0-2.3-.9-2.3-2.1s1-2.1,2.4-2.1,1.4.4,1.7.8v-.6c0-1.1-.7-1.8-1.7-1.8s-1.5.3-2,.9v-1.2c.5-.4,1.2-.7,2.2-.7,1.7,0,2.8,1,2.8,2.7ZM221.9,314.2c0-.7-.5-1.2-1.4-1.2s-1.4.5-1.4,1.2.5,1.2,1.4,1.2,1.5-.5,1.5-1.2Z"
        />
        <path
          d="M230.6,312.2v4.1h-1.2v-3.8c0-1.3-.4-1.8-1.5-1.8s-1.8.8-1.8,2.1v3.5h-1.2v-6.5h1.2v1.1c.4-.8,1.1-1.3,2.2-1.3s2.3,1,2.3,2.6Z"
        />
        <path
          d="M238.4,306.9v9.4h-1.2v-1.3c-.4.8-1,1.5-2.2,1.5s-2.9-1.4-2.9-3.4,1.3-3.5,3-3.5,1.7.4,2.1,1.3v-4h1.2ZM237.2,312.9c0-1.4-.7-2.3-2-2.3s-2,1-2,2.4.8,2.3,1.9,2.3,2-1,2-2.4Z"
        />
        <path
          d="M250.1,312.9c0,2.1-1.4,3.5-3,3.5s-1.7-.5-2.1-1.3v3.5h-1.2v-9h1.2v1.3c.4-.8,1.1-1.5,2.3-1.5,1.7,0,2.8,1.5,2.8,3.4ZM248.8,313c0-1.4-.8-2.3-2-2.3s-2,1-2,2.4.7,2.3,1.9,2.3,2-1,2-2.4Z"
        />
        <path
          d="M257.2,312.2v4.1h-1.2v-3.8c0-1.3-.4-1.8-1.5-1.8s-1.8.8-1.8,2.1v3.5h-1.2v-9.4h1.2v3.9c.4-.8,1.1-1.2,2.2-1.2s2.3,1,2.3,2.6Z"
        />
        <path
          d="M264.6,309.7l-4.1,9h-1.3l1.5-3.1-2.5-5.8h1.3l1.8,4.5,2-4.5h1.3Z"
        />
        <path
          d="M265.1,315.6v-1.1c.6.5,1.4.9,2.3.9s1.3-.3,1.3-1-.2-.7-.8-.9l-1.2-.4c-1.1-.3-1.5-1-1.5-1.8s.9-1.8,2.4-1.8,1.5.3,2.1.6v1.2c-.6-.5-1.3-.7-2.1-.7s-1.2.3-1.2.8.3.7.8.8l1.2.3c1.2.3,1.6,1,1.6,1.9s-1,2.1-2.4,2.1-1.7-.2-2.4-.8Z"
        />
        <path
          d="M271.3,307.8c0-.4.4-.8.8-.8s.8.3.8.8-.3.8-.8.8-.8-.4-.8-.8ZM271.4,309.7h1.2v6.5h-1.2v-6.5Z"
        />
        <path
          d="M274.2,313c0-2,1.4-3.4,3.4-3.4s1.6.2,2,.5v1.3c-.6-.5-1.2-.7-2-.7-1.4,0-2.2,1-2.2,2.3s.8,2.4,2.4,2.4,1.4-.3,1.9-.7v1.2c-.6.4-1.3.6-2.1.6-2,0-3.4-1.5-3.4-3.5Z"
        />
        <path
          d="M286.1,312.3v4h-1.2v-.9c-.3.7-1,1.1-1.8,1.1-1.3,0-2.3-.9-2.3-2.1s1-2.1,2.4-2.1,1.4.4,1.7.8v-.6c0-1.1-.7-1.8-1.7-1.8s-1.5.3-2,.9v-1.2c.5-.4,1.2-.7,2.2-.7,1.7,0,2.8,1,2.8,2.7ZM284.9,314.2c0-.7-.5-1.2-1.4-1.2s-1.4.5-1.4,1.2.5,1.2,1.4,1.2,1.5-.5,1.5-1.2Z"
        />
        <path d="M288.1,306.9h1.2v9.4h-1.2v-9.4Z" />
        <path
          d="M300.6,306.9v9.4h-1.2v-1.3c-.4.8-1,1.5-2.2,1.5s-2.9-1.4-2.9-3.4,1.3-3.5,3-3.5,1.7.4,2.1,1.3v-4h1.2ZM299.4,312.9c0-1.4-.7-2.3-2-2.3s-2,1-2,2.4.8,2.3,1.9,2.3,2-1,2-2.4Z"
        />
        <path
          d="M308.1,313.2h-4.7c.1,1.4,1,2.1,2.4,2.1s1.6-.3,2.1-.7v1.1c-.5.4-1.3.7-2.2.7-2.1,0-3.5-1.4-3.5-3.5s1.1-3.4,3.2-3.4,2.8,1,2.8,2.8v.9ZM303.4,312.3h3.5c0-1.1-.7-1.7-1.7-1.7s-1.7.7-1.9,1.7Z"
        />
        <path d="M315,309.7l-2.5,6.5h-1.1l-2.5-6.5h1.3l1.8,5,1.8-5h1.2Z" />
        <path
          d="M321.6,313.2h-4.7c.1,1.4,1,2.1,2.4,2.1s1.6-.3,2.1-.7v1.1c-.5.4-1.3.7-2.2.7-2.1,0-3.5-1.4-3.5-3.5s1.1-3.4,3.2-3.4,2.8,1,2.8,2.8v.9ZM316.9,312.3h3.5c0-1.1-.7-1.7-1.7-1.7s-1.7.7-1.9,1.7Z"
        />
        <path d="M323.2,306.9h1.2v9.4h-1.2v-9.4Z" />
        <path
          d="M326,313c0-1.9,1.2-3.4,3.2-3.4s3.2,1.5,3.2,3.4-1.2,3.4-3.2,3.4-3.2-1.5-3.2-3.4ZM331.1,313c0-1.4-.7-2.4-2-2.4s-1.9,1-1.9,2.4.7,2.4,1.9,2.4,2-1,2-2.4Z"
        />
        <path
          d="M340.2,312.9c0,2.1-1.4,3.5-3,3.5s-1.7-.5-2.1-1.3v3.5h-1.2v-9h1.2v1.3c.4-.8,1.1-1.5,2.3-1.5,1.7,0,2.8,1.5,2.8,3.4ZM339,313c0-1.4-.8-2.3-2-2.3s-2,1-2,2.4.7,2.3,1.9,2.3,2-1,2-2.4Z"
        />
        <path
          d="M350.6,312v4.2h-1.2v-4.1c0-1.1-.4-1.6-1.2-1.6s-1.4.6-1.4,1.4v4.2h-1.2v-4.2c0-.9-.5-1.4-1.3-1.4s-1.4.7-1.4,1.7v4h-1.2v-6.5h1.2v1.1c.4-.8,1-1.3,1.8-1.3s1.5.5,1.8,1.2c.4-.8,1-1.2,1.9-1.2,1.3,0,2.1.9,2.1,2.4Z"
        />
        <path
          d="M358.1,313.2h-4.7c.1,1.4,1,2.1,2.4,2.1s1.6-.3,2.1-.7v1.1c-.5.4-1.3.7-2.2.7-2.1,0-3.5-1.4-3.5-3.5s1.1-3.4,3.2-3.4,2.8,1,2.8,2.8v.9ZM353.4,312.3h3.5c0-1.1-.7-1.7-1.7-1.7s-1.7.7-1.9,1.7Z"
        />
        <path
          d="M365.3,312.2v4.1h-1.2v-3.8c0-1.3-.4-1.8-1.5-1.8s-1.8.8-1.8,2.1v3.5h-1.2v-6.5h1.2v1.1c.4-.8,1.1-1.3,2.2-1.3s2.3,1,2.3,2.6Z"
        />
        <path
          d="M370.9,310.7h-1.8v5.5h-1.2v-5.5h-1.6v-1h1.6v-1.6l1.2-.4v2h1.8v1Z"
        />
        <path
          d="M245.3,326.7h-1.8v5.5h-1.2v-5.5h-1.6v-1h1.6v-1.6l1.2-.4v2h1.8v1Z"
        />
        <path
          d="M252.1,328.2v4.1h-1.2v-3.8c0-1.3-.4-1.8-1.5-1.8s-1.8.8-1.8,2.1v3.5h-1.2v-9.4h1.2v3.9c.4-.8,1.1-1.2,2.2-1.2s2.3,1,2.3,2.6Z"
        />
        <path
          d="M257.7,325.9v1.1c-.3-.2-.7-.3-1-.3-.8,0-1.4.7-1.4,2v3.5h-1.2v-6.5h1.2v1.3c.3-.9.9-1.4,1.6-1.4s.6,0,.9.3Z"
        />
        <path
          d="M258.3,329c0-1.9,1.2-3.4,3.2-3.4s3.2,1.5,3.2,3.4-1.2,3.4-3.2,3.4-3.2-1.5-3.2-3.4ZM263.4,329c0-1.4-.7-2.4-2-2.4s-1.9,1-1.9,2.4.7,2.4,1.9,2.4,2-1,2-2.4Z"
        />
        <path
          d="M271.7,325.7v6.5h-1.2v-1.2c-.4.9-1.1,1.4-2,1.4-1.4,0-2.3-.9-2.3-2.5v-4.1h1.2v3.8c0,1.2.5,1.8,1.5,1.8s1.7-.8,1.7-2.3v-3.4h1.2Z"
        />
        <path
          d="M279.5,325.7v5.9c0,2-1.3,3.2-3.3,3.2s-1.7-.2-2.3-.8v-1.2c.6.6,1.4.9,2.2.9,1.6,0,2.2-1,2.2-2.4v-.8c-.4,1-1.1,1.5-2.2,1.5-1.8,0-2.8-1.3-2.8-3.2s1.2-3.3,3-3.3,1.6.4,2,1.4v-1.2h1.2ZM278.3,328.8c0-1.3-.8-2.2-1.9-2.2s-1.9.9-1.9,2.2.7,2.1,1.8,2.1,1.9-.9,1.9-2.2Z"
        />
        <path
          d="M287.1,328.2v4.1h-1.2v-3.8c0-1.3-.4-1.8-1.5-1.8s-1.8.8-1.8,2.1v3.5h-1.2v-9.4h1.2v3.9c.4-.8,1.1-1.2,2.2-1.2s2.3,1,2.3,2.6Z"
        />
        <path
          d="M292,331.6v-1.1c.6.5,1.4.9,2.3.9s1.3-.3,1.3-1-.2-.7-.8-.9l-1.2-.4c-1.1-.3-1.5-1-1.5-1.8s.9-1.8,2.4-1.8,1.5.3,2.1.6v1.2c-.6-.5-1.3-.7-2.1-.7s-1.2.3-1.2.8.3.7.8.8l1.2.3c1.2.3,1.6,1,1.6,1.9s-1,2.1-2.4,2.1-1.7-.2-2.4-.8Z"
        />
        <path
          d="M304.6,328.9c0,2.1-1.4,3.5-3,3.5s-1.7-.5-2.1-1.3v3.5h-1.2v-9h1.2v1.3c.4-.8,1.1-1.5,2.3-1.5,1.7,0,2.8,1.5,2.8,3.4ZM303.4,329c0-1.4-.8-2.3-2-2.3s-2,1-2,2.4.7,2.3,1.9,2.3,2-1,2-2.4Z"
        />
        <path
          d="M305.7,329c0-1.9,1.2-3.4,3.2-3.4s3.2,1.5,3.2,3.4-1.2,3.4-3.2,3.4-3.2-1.5-3.2-3.4ZM310.8,329c0-1.4-.7-2.4-2-2.4s-1.9,1-1.9,2.4.7,2.4,1.9,2.4,2-1,2-2.4Z"
        />
        <path
          d="M317.2,325.9v1.1c-.3-.2-.7-.3-1-.3-.8,0-1.4.7-1.4,2v3.5h-1.2v-6.5h1.2v1.3c.3-.9.9-1.4,1.6-1.4s.6,0,.9.3Z"
        />
        <path
          d="M322.2,326.7h-1.8v5.5h-1.2v-5.5h-1.6v-1h1.6v-1.6l1.2-.4v2h1.8v1Z"
        />
        <path
          d="M331.3,328.3v4h-1.2v-.9c-.3.7-1,1.1-1.8,1.1-1.3,0-2.3-.9-2.3-2.1s1-2.1,2.4-2.1,1.4.4,1.7.8v-.6c0-1.1-.7-1.8-1.7-1.8s-1.5.3-2,.9v-1.2c.5-.4,1.2-.7,2.2-.7,1.7,0,2.8,1,2.8,2.7ZM330.2,330.2c0-.7-.5-1.2-1.4-1.2s-1.4.5-1.4,1.2.5,1.2,1.4,1.2,1.5-.5,1.5-1.2Z"
        />
        <path
          d="M338.9,328.2v4.1h-1.2v-3.8c0-1.3-.4-1.8-1.5-1.8s-1.8.8-1.8,2.1v3.5h-1.2v-6.5h1.2v1.1c.4-.8,1.1-1.3,2.2-1.3s2.3,1,2.3,2.6Z"
        />
        <path
          d="M346.7,322.9v9.4h-1.2v-1.3c-.4.8-1,1.5-2.2,1.5s-2.9-1.4-2.9-3.4,1.3-3.5,3-3.5,1.7.4,2.1,1.3v-4h1.2ZM345.5,328.9c0-1.4-.7-2.3-2-2.3s-2,1-2,2.4.8,2.3,1.9,2.3,2-1,2-2.4Z"
        />
        <path
          d="M253.1,344.9c0,2.1-1.4,3.5-3,3.5s-1.7-.5-2.1-1.3v3.5h-1.2v-9h1.2v1.3c.4-.8,1.1-1.5,2.3-1.5,1.7,0,2.8,1.5,2.8,3.4ZM251.9,345c0-1.4-.8-2.3-2-2.3s-2,1-2,2.4.7,2.3,1.9,2.3,2-1,2-2.4Z"
        />
        <path
          d="M260.3,344.2v4.1h-1.2v-3.8c0-1.3-.4-1.8-1.5-1.8s-1.8.8-1.8,2.1v3.5h-1.2v-9.4h1.2v3.9c.4-.8,1.1-1.2,2.2-1.2s2.3,1,2.3,2.6Z"
        />
        <path
          d="M267.6,341.7l-4.1,9h-1.3l1.5-3.1-2.5-5.8h1.3l1.8,4.5,2-4.5h1.3Z"
        />
        <path
          d="M268.2,347.6v-1.1c.6.5,1.4.9,2.3.9s1.3-.3,1.3-1-.2-.7-.8-.9l-1.2-.4c-1.1-.3-1.5-1-1.5-1.8s.9-1.8,2.4-1.8,1.5.3,2.1.6v1.2c-.6-.5-1.3-.7-2.1-.7s-1.2.3-1.2.8.3.7.8.8l1.2.3c1.2.3,1.6,1,1.6,1.9s-1,2.1-2.4,2.1-1.7-.2-2.4-.8Z"
        />
        <path
          d="M274.3,339.8c0-.4.4-.8.8-.8s.8.3.8.8-.3.8-.8.8-.8-.4-.8-.8ZM274.5,341.7h1.2v6.5h-1.2v-6.5Z"
        />
        <path
          d="M277.3,345c0-2,1.4-3.4,3.4-3.4s1.6.2,2,.5v1.3c-.6-.5-1.2-.7-2-.7-1.4,0-2.2,1-2.2,2.3s.8,2.4,2.4,2.4,1.4-.3,1.9-.7v1.2c-.6.4-1.3.6-2.1.6-2,0-3.4-1.5-3.4-3.5Z"
        />
        <path
          d="M289.2,344.3v4h-1.2v-.9c-.3.7-1,1.1-1.8,1.1-1.3,0-2.3-.9-2.3-2.1s1-2.1,2.4-2.1,1.4.4,1.7.8v-.6c0-1.1-.7-1.8-1.7-1.8s-1.5.3-2,.9v-1.2c.5-.4,1.2-.7,2.2-.7,1.7,0,2.8,1,2.8,2.7ZM288,346.2c0-.7-.5-1.2-1.4-1.2s-1.4.5-1.4,1.2.5,1.2,1.4,1.2,1.5-.5,1.5-1.2Z"
        />
        <path d="M291.1,338.9h1.2v9.4h-1.2v-9.4Z" />
        <path
          d="M302.6,344.3v4h-1.2v-.9c-.3.7-1,1.1-1.8,1.1-1.3,0-2.3-.9-2.3-2.1s1-2.1,2.4-2.1,1.4.4,1.7.8v-.6c0-1.1-.7-1.8-1.7-1.8s-1.5.3-2,.9v-1.2c.5-.4,1.2-.7,2.2-.7,1.7,0,2.8,1,2.8,2.7ZM301.4,346.2c0-.7-.5-1.2-1.4-1.2s-1.4.5-1.4,1.2.5,1.2,1.4,1.2,1.5-.5,1.5-1.2Z"
        />
        <path
          d="M304.1,345c0-2,1.4-3.4,3.4-3.4s1.6.2,2,.5v1.3c-.6-.5-1.2-.7-2-.7-1.4,0-2.2,1-2.2,2.3s.8,2.4,2.4,2.4,1.4-.3,1.9-.7v1.2c-.6.4-1.3.6-2.1.6-2,0-3.4-1.5-3.4-3.5Z"
        />
        <path
          d="M314.9,342.7h-1.8v5.5h-1.2v-5.5h-1.6v-1h1.6v-1.6l1.2-.4v2h1.8v1Z"
        />
        <path
          d="M315.9,339.8c0-.4.4-.8.8-.8s.8.3.8.8-.3.8-.8.8-.8-.4-.8-.8ZM316.1,341.7h1.2v6.5h-1.2v-6.5Z"
        />
        <path d="M324.8,341.7l-2.5,6.5h-1.1l-2.5-6.5h1.3l1.8,5,1.8-5h1.2Z" />
        <path
          d="M325.9,339.8c0-.4.4-.8.8-.8s.8.3.8.8-.3.8-.8.8-.8-.4-.8-.8ZM326.1,341.7h1.2v6.5h-1.2v-6.5Z"
        />
        <path
          d="M333.1,342.7h-1.8v5.5h-1.2v-5.5h-1.6v-1h1.6v-1.6l1.2-.4v2h1.8v1Z"
        />
        <path
          d="M339.9,341.7l-4.1,9h-1.3l1.5-3.1-2.5-5.8h1.3l1.8,4.5,2-4.5h1.3Z"
        />
        <path d="M340,347.5c0-.5.4-.9.9-.9s.9.4.9.9-.4.9-.9.9-.9-.4-.9-.9Z" />
      </g>
      <g :class="[displayPicto(Education_Career_Readiness)]">
        <path
          d="M271.9,243.1l-2.4,9.1h-1.6l-2-7.9-2,7.9h-1.6l-2.3-9.1h1.4l1.8,7.7,2-7.7h1.7l2,7.7,1.9-7.7h1.3Z"
        />
        <path
          d="M278.4,249.2h-4.7c.1,1.4,1,2.1,2.4,2.1s1.6-.3,2.1-.7v1.1c-.5.4-1.3.7-2.2.7-2.1,0-3.5-1.4-3.5-3.5s1.1-3.4,3.2-3.4,2.8,1,2.8,2.8v.9ZM273.7,248.3h3.5c0-1.1-.7-1.7-1.7-1.7s-1.7.7-1.9,1.7Z"
        />
        <path
          d="M283,251.6v-1.1c.6.5,1.4.9,2.3.9s1.3-.3,1.3-1-.2-.7-.8-.9l-1.2-.4c-1.1-.3-1.5-1-1.5-1.8s.9-1.8,2.4-1.8,1.5.3,2.1.6v1.2c-.6-.5-1.3-.7-2.1-.7s-1.2.3-1.2.8.3.7.8.8l1.2.3c1.2.3,1.6,1,1.6,1.9s-1,2.1-2.4,2.1-1.7-.2-2.4-.8Z"
        />
        <path
          d="M294.7,245.7v6.5h-1.2v-1.2c-.4.9-1.1,1.4-2,1.4-1.4,0-2.3-.9-2.3-2.5v-4.1h1.2v3.8c0,1.2.5,1.8,1.5,1.8s1.7-.8,1.7-2.3v-3.4h1.2Z"
        />
        <path
          d="M303,248.9c0,2.1-1.4,3.5-3,3.5s-1.7-.5-2.1-1.3v3.5h-1.2v-9h1.2v1.3c.4-.8,1.1-1.5,2.3-1.5,1.7,0,2.8,1.5,2.8,3.4ZM301.8,249c0-1.4-.8-2.3-2-2.3s-2,1-2,2.4.7,2.3,1.9,2.3,2-1,2-2.4Z"
        />
        <path
          d="M310.9,248.9c0,2.1-1.4,3.5-3,3.5s-1.7-.5-2.1-1.3v3.5h-1.2v-9h1.2v1.3c.4-.8,1.1-1.5,2.3-1.5,1.7,0,2.8,1.5,2.8,3.4ZM309.7,249c0-1.4-.8-2.3-2-2.3s-2,1-2,2.4.7,2.3,1.9,2.3,2-1,2-2.4Z"
        />
        <path
          d="M312,249c0-2,1.2-3.4,3.2-3.4s3.2,1.5,3.2,3.4-1.2,3.4-3.2,3.4-3.2-1.5-3.2-3.4ZM317.2,249c0-1.4-.7-2.4-2-2.4s-1.9,1-1.9,2.4.7,2.4,1.9,2.4,2-1,2-2.4Z"
        />
        <path
          d="M323.5,245.9v1.1c-.3-.2-.7-.3-1-.3-.8,0-1.4.7-1.4,2v3.5h-1.2v-6.5h1.2v1.3c.3-.9.9-1.4,1.6-1.4s.6,0,.9.3Z"
        />
        <path
          d="M328.5,246.7h-1.8v5.5h-1.2v-5.5h-1.6v-1h1.6v-1.6l1.2-.4v2h1.8v1Z"
        />
        <path
          d="M218.5,259.8c0-.4.4-.8.8-.8s.8.3.8.8-.3.8-.8.8-.8-.4-.8-.8ZM218.7,261.7h1.2v6.5h-1.2v-6.5Z"
        />
        <path
          d="M227.6,264.2v4.1h-1.2v-3.8c0-1.3-.4-1.8-1.5-1.8s-1.8.8-1.8,2.1v3.5h-1.2v-6.5h1.2v1.1c.4-.8,1.1-1.3,2.2-1.3s2.3,1,2.3,2.6Z"
        />
        <path
          d="M233.2,262.7h-1.8v5.5h-1.2v-5.5h-1.6v-1h1.6v-1.6l1.2-.4v2h1.8v1Z"
        />
        <path
          d="M239.8,265.2h-4.7c.1,1.4,1,2.1,2.4,2.1s1.6-.3,2.1-.7v1.1c-.5.4-1.3.7-2.2.7-2.1,0-3.5-1.4-3.5-3.5s1.1-3.4,3.2-3.4,2.8,1,2.8,2.8v.9ZM235.1,264.3h3.5c0-1.1-.7-1.7-1.7-1.7s-1.7.7-1.9,1.7Z"
        />
        <path
          d="M245,261.9v1.1c-.3-.2-.7-.3-1-.3-.8,0-1.4.7-1.4,2v3.5h-1.2v-6.5h1.2v1.3c.3-.9.9-1.4,1.6-1.4s.6,0,.9.3Z"
        />
        <path d="M251.7,261.7l-2.5,6.5h-1.1l-2.5-6.5h1.3l1.8,5,1.8-5h1.2Z" />
        <path
          d="M258.3,265.2h-4.7c.1,1.4,1,2.1,2.4,2.1s1.6-.3,2.1-.7v1.1c-.5.4-1.3.7-2.2.7-2.1,0-3.5-1.4-3.5-3.5s1.1-3.4,3.2-3.4,2.8,1,2.8,2.8v.9ZM253.6,264.3h3.5c0-1.1-.7-1.7-1.7-1.7s-1.7.7-1.9,1.7Z"
        />
        <path
          d="M265.5,264.2v4.1h-1.2v-3.8c0-1.3-.4-1.8-1.5-1.8s-1.8.8-1.8,2.1v3.5h-1.2v-6.5h1.2v1.1c.4-.8,1.1-1.3,2.2-1.3s2.3,1,2.3,2.6Z"
        />
        <path
          d="M271.1,262.7h-1.8v5.5h-1.2v-5.5h-1.6v-1h1.6v-1.6l1.2-.4v2h1.8v1Z"
        />
        <path
          d="M272.1,259.8c0-.4.4-.8.8-.8s.8.3.8.8-.3.8-.8.8-.8-.4-.8-.8ZM272.3,261.7h1.2v6.5h-1.2v-6.5Z"
        />
        <path
          d="M275.1,265c0-2,1.2-3.4,3.2-3.4s3.2,1.5,3.2,3.4-1.2,3.4-3.2,3.4-3.2-1.5-3.2-3.4ZM280.2,265c0-1.4-.7-2.4-2-2.4s-1.9,1-1.9,2.4.7,2.4,1.9,2.4,2-1,2-2.4Z"
        />
        <path
          d="M288.6,264.2v4.1h-1.2v-3.8c0-1.3-.4-1.8-1.5-1.8s-1.8.8-1.8,2.1v3.5h-1.2v-6.5h1.2v1.1c.4-.8,1.1-1.3,2.2-1.3s2.3,1,2.3,2.6Z"
        />
        <path
          d="M290.2,267.6v-1.1c.6.5,1.4.9,2.3.9s1.3-.3,1.3-1-.2-.7-.8-.9l-1.2-.4c-1.1-.3-1.5-1-1.5-1.8s.9-1.8,2.4-1.8,1.5.3,2.1.6v1.2c-.6-.5-1.3-.7-2.1-.7s-1.2.3-1.2.8.3.7.8.8l1.2.3c1.2.3,1.6,1,1.6,1.9s-1,2.1-2.4,2.1-1.7-.2-2.4-.8Z"
        />
        <path
          d="M303.3,262.7h-1.8v5.5h-1.2v-5.5h-1.6v-1h1.6v-1.6l1.2-.4v2h1.8v1Z"
        />
        <path
          d="M310.1,264.2v4.1h-1.2v-3.8c0-1.3-.4-1.8-1.5-1.8s-1.8.8-1.8,2.1v3.5h-1.2v-9.4h1.2v3.9c.4-.8,1.1-1.2,2.2-1.2s2.3,1,2.3,2.6Z"
        />
        <path
          d="M316.9,264.3v4h-1.2v-.9c-.3.7-1,1.1-1.8,1.1-1.3,0-2.3-.9-2.3-2.1s1-2.1,2.4-2.1,1.4.4,1.7.8v-.6c0-1.1-.7-1.8-1.7-1.8s-1.5.3-2,.9v-1.2c.5-.4,1.2-.7,2.2-.7,1.7,0,2.8,1,2.8,2.7ZM315.7,266.2c0-.7-.5-1.2-1.4-1.2s-1.4.5-1.4,1.2.5,1.2,1.4,1.2,1.5-.5,1.5-1.2Z"
        />
        <path
          d="M322.5,262.7h-1.8v5.5h-1.2v-5.5h-1.6v-1h1.6v-1.6l1.2-.4v2h1.8v1Z"
        />
        <path
          d="M333,264.9c0,2.1-1.4,3.5-3,3.5s-1.7-.5-2.1-1.3v3.5h-1.2v-9h1.2v1.3c.4-.8,1.1-1.5,2.3-1.5,1.7,0,2.8,1.5,2.8,3.4ZM331.8,265c0-1.4-.8-2.3-2-2.3s-2,1-2,2.4.7,2.3,1.9,2.3,2-1,2-2.4Z"
        />
        <path
          d="M338.2,261.9v1.1c-.3-.2-.7-.3-1-.3-.8,0-1.4.7-1.4,2v3.5h-1.2v-6.5h1.2v1.3c.3-.9.9-1.4,1.6-1.4s.6,0,.9.3Z"
        />
        <path
          d="M338.8,265c0-2,1.2-3.4,3.2-3.4s3.2,1.5,3.2,3.4-1.2,3.4-3.2,3.4-3.2-1.5-3.2-3.4ZM343.9,265c0-1.4-.7-2.4-2-2.4s-1.9,1-1.9,2.4.7,2.4,1.9,2.4,2-1,2-2.4Z"
        />
        <path d="M352,261.7l-2.5,6.5h-1.1l-2.5-6.5h1.3l1.8,5,1.8-5h1.2Z" />
        <path
          d="M353.1,259.8c0-.4.4-.8.8-.8s.8.3.8.8-.3.8-.8.8-.8-.4-.8-.8ZM353.3,261.7h1.2v6.5h-1.2v-6.5Z"
        />
        <path
          d="M362.4,258.9v9.4h-1.2v-1.3c-.4.8-1,1.5-2.2,1.5s-2.9-1.4-2.9-3.4,1.3-3.5,3-3.5,1.7.4,2.1,1.3v-4h1.2ZM361.2,264.9c0-1.4-.7-2.3-2-2.3s-2,1-2,2.4.8,2.3,1.9,2.3,2-1,2-2.4Z"
        />
        <path
          d="M369.9,265.2h-4.7c.1,1.4,1,2.1,2.4,2.1s1.6-.3,2.1-.7v1.1c-.5.4-1.3.7-2.2.7-2.1,0-3.5-1.4-3.5-3.5s1.1-3.4,3.2-3.4,2.8,1,2.8,2.8v.9ZM365.3,264.3h3.5c0-1.1-.7-1.7-1.7-1.7s-1.7.7-1.9,1.7Z"
        />
        <path
          d="M215.9,281c0-2,1.4-3.4,3.4-3.4s1.6.2,2,.5v1.3c-.6-.5-1.2-.7-2-.7-1.4,0-2.2,1-2.2,2.3s.8,2.4,2.4,2.4,1.4-.3,1.9-.7v1.2c-.6.4-1.3.6-2.1.6-2,0-3.4-1.5-3.4-3.5Z"
        />
        <path
          d="M228.6,280.2v4.1h-1.2v-3.8c0-1.3-.4-1.8-1.5-1.8s-1.8.8-1.8,2.1v3.5h-1.2v-9.4h1.2v3.9c.4-.8,1.1-1.2,2.2-1.2s2.3,1,2.3,2.6Z"
        />
        <path
          d="M230.3,275.8c0-.4.4-.8.8-.8s.8.3.8.8-.3.8-.8.8-.8-.4-.8-.8ZM230.5,277.7h1.2v6.5h-1.2v-6.5Z"
        />
        <path d="M233.8,274.9h1.2v9.4h-1.2v-9.4Z" />
        <path
          d="M242.9,274.9v9.4h-1.2v-1.3c-.4.8-1,1.5-2.2,1.5s-2.9-1.4-2.9-3.4,1.3-3.5,3-3.5,1.7.4,2.1,1.3v-4h1.2ZM241.7,280.9c0-1.4-.7-2.3-2-2.3s-2,1-2,2.4.8,2.3,1.9,2.3,2-1,2-2.4Z"
        />
        <path
          d="M248.5,277.9v1.1c-.3-.2-.7-.3-1-.3-.8,0-1.4.7-1.4,2v3.5h-1.2v-6.5h1.2v1.3c.3-.9.9-1.4,1.6-1.4s.6,0,.9.3Z"
        />
        <path
          d="M255.1,281.2h-4.7c.1,1.4,1,2.1,2.4,2.1s1.6-.3,2.1-.7v1.1c-.5.4-1.3.7-2.2.7-2.1,0-3.5-1.4-3.5-3.5s1.1-3.4,3.2-3.4,2.8,1,2.8,2.8v.9ZM250.5,280.3h3.5c0-1.1-.7-1.7-1.7-1.7s-1.7.7-1.9,1.7Z"
        />
        <path
          d="M262.3,280.2v4.1h-1.2v-3.8c0-1.3-.4-1.8-1.5-1.8s-1.8.8-1.8,2.1v3.5h-1.2v-6.5h1.2v1.1c.4-.8,1.1-1.3,2.2-1.3s2.3,1,2.3,2.6Z"
        />
        <path
          d="M272.5,280.3v4h-1.2v-.9c-.3.7-1,1.1-1.8,1.1-1.3,0-2.3-.9-2.3-2.1s1-2.1,2.4-2.1,1.4.4,1.7.8v-.6c0-1.1-.7-1.8-1.7-1.8s-1.5.3-2,.9v-1.2c.5-.4,1.2-.7,2.2-.7,1.7,0,2.8,1,2.8,2.7ZM271.3,282.2c0-.7-.5-1.2-1.4-1.2s-1.4.5-1.4,1.2.5,1.2,1.4,1.2,1.5-.5,1.5-1.2Z"
        />
        <path
          d="M280.1,280.2v4.1h-1.2v-3.8c0-1.3-.4-1.8-1.5-1.8s-1.8.8-1.8,2.1v3.5h-1.2v-6.5h1.2v1.1c.4-.8,1.1-1.3,2.2-1.3s2.3,1,2.3,2.6Z"
        />
        <path
          d="M287.8,274.9v9.4h-1.2v-1.3c-.4.8-1,1.5-2.2,1.5s-2.9-1.4-2.9-3.4,1.3-3.5,3-3.5,1.7.4,2.1,1.3v-4h1.2ZM286.7,280.9c0-1.4-.7-2.3-2-2.3s-2,1-2,2.4.8,2.3,1.9,2.3,2-1,2-2.4Z"
        />
        <path
          d="M298.5,277.7l-4.1,9h-1.3l1.5-3.1-2.5-5.8h1.3l1.8,4.5,2-4.5h1.3Z"
        />
        <path
          d="M299.1,281c0-2,1.2-3.4,3.2-3.4s3.2,1.5,3.2,3.4-1.2,3.4-3.2,3.4-3.2-1.5-3.2-3.4ZM304.2,281c0-1.4-.7-2.4-2-2.4s-1.9,1-1.9,2.4.7,2.4,1.9,2.4,2-1,2-2.4Z"
        />
        <path
          d="M312.5,277.7v6.5h-1.2v-1.2c-.4.9-1.1,1.4-2,1.4-1.4,0-2.3-.9-2.3-2.5v-4.1h1.2v3.8c0,1.2.5,1.8,1.5,1.8s1.7-.8,1.7-2.3v-3.4h1.2Z"
        />
        <path
          d="M320.1,280.2v4.1h-1.2v-3.8c0-1.3-.4-1.8-1.5-1.8s-1.8.8-1.8,2.1v3.5h-1.2v-6.5h1.2v1.1c.4-.8,1.1-1.3,2.2-1.3s2.3,1,2.3,2.6Z"
        />
        <path
          d="M327.8,277.7v5.9c0,2-1.3,3.2-3.3,3.2s-1.7-.2-2.3-.8v-1.2c.6.6,1.4.9,2.2.9,1.6,0,2.2-1,2.2-2.4v-.8c-.4,1-1.1,1.5-2.2,1.5-1.8,0-2.8-1.3-2.8-3.2s1.2-3.3,3-3.3,1.6.4,2,1.4v-1.2h1.2ZM326.6,280.8c0-1.3-.8-2.2-1.9-2.2s-1.9.9-1.9,2.2.7,2.1,1.8,2.1,1.9-.9,1.9-2.2Z"
        />
        <path
          d="M339.5,280.9c0,2.1-1.4,3.5-3,3.5s-1.7-.5-2.1-1.3v3.5h-1.2v-9h1.2v1.3c.4-.8,1.1-1.5,2.3-1.5,1.7,0,2.8,1.5,2.8,3.4ZM338.2,281c0-1.4-.8-2.3-2-2.3s-2,1-2,2.4.7,2.3,1.9,2.3,2-1,2-2.4Z"
        />
        <path
          d="M346.5,281.2h-4.7c.1,1.4,1,2.1,2.4,2.1s1.6-.3,2.1-.7v1.1c-.5.4-1.3.7-2.2.7-2.1,0-3.5-1.4-3.5-3.5s1.1-3.4,3.2-3.4,2.8,1,2.8,2.8v.9ZM341.9,280.3h3.5c0-1.1-.7-1.7-1.7-1.7s-1.7.7-1.9,1.7Z"
        />
        <path
          d="M347.7,281c0-2,1.2-3.4,3.2-3.4s3.2,1.5,3.2,3.4-1.2,3.4-3.2,3.4-3.2-1.5-3.2-3.4ZM352.8,281c0-1.4-.7-2.4-2-2.4s-1.9,1-1.9,2.4.7,2.4,1.9,2.4,2-1,2-2.4Z"
        />
        <path
          d="M361.9,280.9c0,2.1-1.4,3.5-3,3.5s-1.7-.5-2.1-1.3v3.5h-1.2v-9h1.2v1.3c.4-.8,1.1-1.5,2.3-1.5,1.7,0,2.8,1.5,2.8,3.4ZM360.7,281c0-1.4-.8-2.3-2-2.3s-2,1-2,2.4.7,2.3,1.9,2.3,2-1,2-2.4Z"
        />
        <path d="M363.5,274.9h1.2v9.4h-1.2v-9.4Z" />
        <path
          d="M372.3,281.2h-4.7c.1,1.4,1,2.1,2.4,2.1s1.6-.3,2.1-.7v1.1c-.5.4-1.3.7-2.2.7-2.1,0-3.5-1.4-3.5-3.5s1.1-3.4,3.2-3.4,2.8,1,2.8,2.8v.9ZM367.6,280.3h3.5c0-1.1-.7-1.7-1.7-1.7s-1.7.7-1.9,1.7Z"
        />
        <path
          d="M226.8,293.7l-2.1,6.5h-1.1l-1.6-5.2-1.7,5.2h-1.1l-2-6.5h1.3l1.3,4.8,1.5-4.8h1.3l1.5,4.8,1.4-4.8h1.2Z"
        />
        <path
          d="M227.9,291.8c0-.4.4-.8.8-.8s.8.3.8.8-.3.8-.8.8-.8-.4-.8-.8ZM228.1,293.7h1.2v6.5h-1.2v-6.5Z"
        />
        <path
          d="M235.1,294.7h-1.8v5.5h-1.2v-5.5h-1.6v-1h1.6v-1.6l1.2-.4v2h1.8v1Z"
        />
        <path
          d="M241.9,296.2v4.1h-1.2v-3.8c0-1.3-.4-1.8-1.5-1.8s-1.8.8-1.8,2.1v3.5h-1.2v-9.4h1.2v3.9c.4-.8,1.1-1.2,2.2-1.2s2.3,1,2.3,2.6Z"
        />
        <path d="M247.3,290.9h1.2v9.4h-1.2v-9.4Z" />
        <path
          d="M250.3,291.8c0-.4.4-.8.8-.8s.8.3.8.8-.3.8-.8.8-.8-.4-.8-.8ZM250.5,293.7h1.2v6.5h-1.2v-6.5Z"
        />
        <path
          d="M255.4,292.9v.9h2v1h-2v5.5h-1.2v-5.5h-1.1v-1h1.1v-.8c0-1.4.8-2.2,2.1-2.2s1,.1,1.3.3v1c-.3-.2-.7-.3-1.1-.3-.7,0-1,.4-1,1.1Z"
        />
        <path
          d="M263.9,297.2h-4.7c.1,1.4,1,2.1,2.4,2.1s1.6-.3,2.1-.7v1.1c-.5.4-1.3.7-2.2.7-2.1,0-3.5-1.4-3.5-3.5s1.1-3.4,3.2-3.4,2.8,1,2.8,2.8v.9ZM259.2,296.3h3.5c0-1.1-.7-1.7-1.7-1.7s-1.7.7-1.9,1.7Z"
        />
        <path
          d="M268.5,299.6v-1.1c.6.5,1.4.9,2.3.9s1.3-.3,1.3-1-.2-.7-.8-.9l-1.2-.4c-1.1-.3-1.5-1-1.5-1.8s.9-1.8,2.4-1.8,1.5.3,2.1.6v1.2c-.6-.5-1.3-.7-2.1-.7s-1.2.3-1.2.8.3.7.8.8l1.2.3c1.2.3,1.6,1,1.6,1.9s-1,2.1-2.4,2.1-1.7-.2-2.4-.8Z"
        />
        <path
          d="M278.7,300.2l-2.8-3.2v3.2h-1.2v-9.4h1.2v5.5l2.5-2.7h1.6l-3,2.9,3.2,3.6h-1.6Z"
        />
        <path
          d="M281.1,291.8c0-.4.4-.8.8-.8s.8.3.8.8-.3.8-.8.8-.8-.4-.8-.8ZM281.3,293.7h1.2v6.5h-1.2v-6.5Z"
        />
        <path d="M284.6,290.9h1.2v9.4h-1.2v-9.4Z" />
        <path d="M287.9,290.9h1.2v9.4h-1.2v-9.4Z" />
        <path
          d="M290.7,299.6v-1.1c.6.5,1.4.9,2.3.9s1.3-.3,1.3-1-.2-.7-.8-.9l-1.2-.4c-1.1-.3-1.5-1-1.5-1.8s.9-1.8,2.4-1.8,1.5.3,2.1.6v1.2c-.6-.5-1.3-.7-2.1-.7s-1.2.3-1.2.8.3.7.8.8l1.2.3c1.2.3,1.6,1,1.6,1.9s-1,2.1-2.4,2.1-1.7-.2-2.4-.8Z"
        />
        <path
          d="M305.3,296.3v4h-1.2v-.9c-.3.7-1,1.1-1.8,1.1-1.3,0-2.3-.9-2.3-2.1s1-2.1,2.4-2.1,1.4.4,1.7.8v-.6c0-1.1-.7-1.8-1.7-1.8s-1.5.3-2,.9v-1.2c.5-.4,1.2-.7,2.2-.7,1.7,0,2.8,1,2.8,2.7ZM304.1,298.2c0-.7-.5-1.2-1.4-1.2s-1.4.5-1.4,1.2.5,1.2,1.4,1.2,1.5-.5,1.5-1.2Z"
        />
        <path
          d="M312.8,296.2v4.1h-1.2v-3.8c0-1.3-.4-1.8-1.5-1.8s-1.8.8-1.8,2.1v3.5h-1.2v-6.5h1.2v1.1c.4-.8,1.1-1.3,2.2-1.3s2.3,1,2.3,2.6Z"
        />
        <path
          d="M320.6,290.9v9.4h-1.2v-1.3c-.4.8-1,1.5-2.2,1.5s-2.9-1.4-2.9-3.4,1.3-3.5,3-3.5,1.7.4,2.1,1.3v-4h1.2ZM319.4,296.9c0-1.4-.7-2.3-2-2.3s-2,1-2,2.4.8,2.3,1.9,2.3,2-1,2-2.4Z"
        />
        <path
          d="M325.6,299.6v-1.1c.6.5,1.4.9,2.3.9s1.3-.3,1.3-1-.2-.7-.8-.9l-1.2-.4c-1.1-.3-1.5-1-1.5-1.8s.9-1.8,2.4-1.8,1.5.3,2.1.6v1.2c-.6-.5-1.3-.7-2.1-.7s-1.2.3-1.2.8.3.7.8.8l1.2.3c1.2.3,1.6,1,1.6,1.9s-1,2.1-2.4,2.1-1.7-.2-2.4-.8Z"
        />
        <path
          d="M337.3,293.7v6.5h-1.2v-1.2c-.4.9-1.1,1.4-2,1.4-1.4,0-2.3-.9-2.3-2.5v-4.1h1.2v3.8c0,1.2.5,1.8,1.5,1.8s1.7-.8,1.7-2.3v-3.4h1.2Z"
        />
        <path
          d="M345.6,296.9c0,2.1-1.4,3.5-3,3.5s-1.7-.5-2.1-1.3v3.5h-1.2v-9h1.2v1.3c.4-.8,1.1-1.5,2.3-1.5,1.7,0,2.8,1.5,2.8,3.4ZM344.4,297c0-1.4-.8-2.3-2-2.3s-2,1-2,2.4.7,2.3,1.9,2.3,2-1,2-2.4Z"
        />
        <path
          d="M353.5,296.9c0,2.1-1.4,3.5-3,3.5s-1.7-.5-2.1-1.3v3.5h-1.2v-9h1.2v1.3c.4-.8,1.1-1.5,2.3-1.5,1.7,0,2.8,1.5,2.8,3.4ZM352.3,297c0-1.4-.8-2.3-2-2.3s-2,1-2,2.4.7,2.3,1.9,2.3,2-1,2-2.4Z"
        />
        <path
          d="M354.6,297c0-2,1.2-3.4,3.2-3.4s3.2,1.5,3.2,3.4-1.2,3.4-3.2,3.4-3.2-1.5-3.2-3.4ZM359.8,297c0-1.4-.7-2.4-2-2.4s-1.9,1-1.9,2.4.7,2.4,1.9,2.4,2-1,2-2.4Z"
        />
        <path
          d="M366.1,293.9v1.1c-.3-.2-.7-.3-1-.3-.8,0-1.4.7-1.4,2v3.5h-1.2v-6.5h1.2v1.3c.3-.9.9-1.4,1.6-1.4s.6,0,.9.3Z"
        />
        <path
          d="M371.1,294.7h-1.8v5.5h-1.2v-5.5h-1.6v-1h1.6v-1.6l1.2-.4v2h1.8v1Z"
        />
        <path
          d="M225.7,310.7h-1.8v5.5h-1.2v-5.5h-1.6v-1h1.6v-1.6l1.2-.4v2h1.8v1Z"
        />
        <path
          d="M226.3,313c0-1.9,1.2-3.4,3.2-3.4s3.2,1.5,3.2,3.4-1.2,3.4-3.2,3.4-3.2-1.5-3.2-3.4ZM231.4,313c0-1.4-.7-2.4-2-2.4s-1.9,1-1.9,2.4.7,2.4,1.9,2.4,2-1,2-2.4Z"
        />
        <path
          d="M241,310.7h-1.8v5.5h-1.2v-5.5h-1.6v-1h1.6v-1.6l1.2-.4v2h1.8v1Z"
        />
        <path
          d="M247.8,312.2v4.1h-1.2v-3.8c0-1.3-.4-1.8-1.5-1.8s-1.8.8-1.8,2.1v3.5h-1.2v-9.4h1.2v3.9c.4-.8,1.1-1.2,2.2-1.2s2.3,1,2.3,2.6Z"
        />
        <path
          d="M253.3,309.9v1.1c-.3-.2-.7-.3-1-.3-.8,0-1.4.7-1.4,2v3.5h-1.2v-6.5h1.2v1.3c.3-.9.9-1.4,1.6-1.4s.6,0,.9.3Z"
        />
        <path
          d="M254.4,307.8c0-.4.4-.8.8-.8s.8.3.8.8-.3.8-.8.8-.8-.4-.8-.8ZM254.6,309.7h1.2v6.5h-1.2v-6.5Z"
        />
        <path d="M263.3,309.7l-2.5,6.5h-1.1l-2.5-6.5h1.3l1.8,5,1.8-5h1.2Z" />
        <path
          d="M269.9,313.2h-4.7c.1,1.4,1,2.1,2.4,2.1s1.6-.3,2.1-.7v1.1c-.5.4-1.3.7-2.2.7-2.1,0-3.5-1.4-3.5-3.5s1.1-3.4,3.2-3.4,2.8,1,2.8,2.8v.9ZM265.3,312.3h3.5c0-1.1-.7-1.7-1.7-1.7s-1.7.7-1.9,1.7Z"
        />
        <path
          d="M274.7,307.8c0-.4.4-.8.8-.8s.8.3.8.8-.3.8-.8.8-.8-.4-.8-.8ZM274.9,309.7h1.2v6.5h-1.2v-6.5Z"
        />
        <path
          d="M283.8,312.2v4.1h-1.2v-3.8c0-1.3-.4-1.8-1.5-1.8s-1.8.8-1.8,2.1v3.5h-1.2v-6.5h1.2v1.1c.4-.8,1.1-1.3,2.2-1.3s2.3,1,2.3,2.6Z"
        />
        <path
          d="M293,316.2l-2.8-3.2v3.2h-1.2v-9.4h1.2v5.5l2.5-2.7h1.6l-3,2.9,3.2,3.6h-1.6Z"
        />
        <path
          d="M300.8,313.2h-4.7c.1,1.4,1,2.1,2.4,2.1s1.6-.3,2.1-.7v1.1c-.5.4-1.3.7-2.2.7-2.1,0-3.5-1.4-3.5-3.5s1.1-3.4,3.2-3.4,2.8,1,2.8,2.8v.9ZM296.1,312.3h3.5c0-1.1-.7-1.7-1.7-1.7s-1.7.7-1.9,1.7Z"
        />
        <path
          d="M307.9,309.7l-4.1,9h-1.3l1.5-3.1-2.5-5.8h1.3l1.8,4.5,2-4.5h1.3Z"
        />
        <path
          d="M315.7,310.7h-1.8v5.5h-1.2v-5.5h-1.6v-1h1.6v-1.6l1.2-.4v2h1.8v1Z"
        />
        <path
          d="M320.5,309.9v1.1c-.3-.2-.7-.3-1-.3-.8,0-1.4.7-1.4,2v3.5h-1.2v-6.5h1.2v1.3c.3-.9.9-1.4,1.6-1.4s.6,0,.9.3Z"
        />
        <path
          d="M326.5,312.3v4h-1.2v-.9c-.3.7-1,1.1-1.8,1.1-1.3,0-2.3-.9-2.3-2.1s1-2.1,2.4-2.1,1.4.4,1.7.8v-.6c0-1.1-.7-1.8-1.7-1.8s-1.5.3-2,.9v-1.2c.5-.4,1.2-.7,2.2-.7,1.7,0,2.8,1,2.8,2.7ZM325.3,314.2c0-.7-.5-1.2-1.4-1.2s-1.4.5-1.4,1.2.5,1.2,1.4,1.2,1.5-.5,1.5-1.2Z"
        />
        <path
          d="M334,312.2v4.1h-1.2v-3.8c0-1.3-.4-1.8-1.5-1.8s-1.8.8-1.8,2.1v3.5h-1.2v-6.5h1.2v1.1c.4-.8,1.1-1.3,2.2-1.3s2.3,1,2.3,2.6Z"
        />
        <path
          d="M335.6,315.6v-1.1c.6.5,1.4.9,2.3.9s1.3-.3,1.3-1-.2-.7-.8-.9l-1.2-.4c-1.1-.3-1.5-1-1.5-1.8s.9-1.8,2.4-1.8,1.5.3,2.1.6v1.2c-.6-.5-1.3-.7-2.1-.7s-1.2.3-1.2.8.3.7.8.8l1.2.3c1.2.3,1.6,1,1.6,1.9s-1,2.1-2.4,2.1-1.7-.2-2.4-.8Z"
        />
        <path
          d="M341.7,307.8c0-.4.4-.8.8-.8s.8.3.8.8-.3.8-.8.8-.8-.4-.8-.8ZM341.9,309.7h1.2v6.5h-1.2v-6.5Z"
        />
        <path
          d="M348.9,310.7h-1.8v5.5h-1.2v-5.5h-1.6v-1h1.6v-1.6l1.2-.4v2h1.8v1Z"
        />
        <path
          d="M349.9,307.8c0-.4.4-.8.8-.8s.8.3.8.8-.3.8-.8.8-.8-.4-.8-.8ZM350.1,309.7h1.2v6.5h-1.2v-6.5Z"
        />
        <path
          d="M352.9,313c0-1.9,1.2-3.4,3.2-3.4s3.2,1.5,3.2,3.4-1.2,3.4-3.2,3.4-3.2-1.5-3.2-3.4ZM358,313c0-1.4-.7-2.4-2-2.4s-1.9,1-1.9,2.4.7,2.4,1.9,2.4,2-1,2-2.4Z"
        />
        <path
          d="M366.4,312.2v4.1h-1.2v-3.8c0-1.3-.4-1.8-1.5-1.8s-1.8.8-1.8,2.1v3.5h-1.2v-6.5h1.2v1.1c.4-.8,1.1-1.3,2.2-1.3s2.3,1,2.3,2.6Z"
        />
        <path
          d="M227.2,328v4.2h-1.2v-4.1c0-1.1-.4-1.6-1.2-1.6s-1.4.6-1.4,1.4v4.2h-1.2v-4.2c0-.9-.5-1.4-1.3-1.4s-1.4.7-1.4,1.7v4h-1.2v-6.5h1.2v1.1c.4-.8,1-1.3,1.8-1.3s1.5.5,1.8,1.2c.4-.8,1-1.2,1.9-1.2,1.3,0,2.1.9,2.1,2.4Z"
        />
        <path
          d="M228.7,329c0-1.9,1.2-3.4,3.2-3.4s3.2,1.5,3.2,3.4-1.2,3.4-3.2,3.4-3.2-1.5-3.2-3.4ZM233.8,329c0-1.4-.7-2.4-2-2.4s-1.9,1-1.9,2.4.7,2.4,1.9,2.4,2-1,2-2.4Z"
        />
        <path
          d="M245.5,328v4.2h-1.2v-4.1c0-1.1-.4-1.6-1.2-1.6s-1.4.6-1.4,1.4v4.2h-1.2v-4.2c0-.9-.5-1.4-1.3-1.4s-1.4.7-1.4,1.7v4h-1.2v-6.5h1.2v1.1c.4-.8,1-1.3,1.8-1.3s1.5.5,1.8,1.2c.4-.8,1-1.2,1.9-1.2,1.3,0,2.1.9,2.1,2.4Z"
        />
        <path
          d="M252.9,329.2h-4.7c.1,1.4,1,2.1,2.4,2.1s1.6-.3,2.1-.7v1.1c-.5.4-1.3.7-2.2.7-2.1,0-3.5-1.4-3.5-3.5s1.1-3.4,3.2-3.4,2.8,1,2.8,2.8v.9ZM248.2,328.3h3.5c0-1.1-.7-1.7-1.7-1.7s-1.7.7-1.9,1.7Z"
        />
        <path
          d="M260.1,328.2v4.1h-1.2v-3.8c0-1.3-.4-1.8-1.5-1.8s-1.8.8-1.8,2.1v3.5h-1.2v-6.5h1.2v1.1c.4-.8,1.1-1.3,2.2-1.3s2.3,1,2.3,2.6Z"
        />
        <path
          d="M265.7,326.7h-1.8v5.5h-1.2v-5.5h-1.6v-1h1.6v-1.6l1.2-.4v2h1.8v1Z"
        />
        <path
          d="M266.4,331.6v-1.1c.6.5,1.4.9,2.3.9s1.3-.3,1.3-1-.2-.7-.8-.9l-1.2-.4c-1.1-.3-1.5-1-1.5-1.8s.9-1.8,2.4-1.8,1.5.3,2.1.6v1.2c-.6-.5-1.3-.7-2.1-.7s-1.2.3-1.2.8.3.7.8.8l1.2.3c1.2.3,1.6,1,1.6,1.9s-1,2.1-2.4,2.1-1.7-.2-2.4-.8Z"
        />
        <path
          d="M281,328.3v4h-1.2v-.9c-.3.7-1,1.1-1.8,1.1-1.3,0-2.3-.9-2.3-2.1s1-2.1,2.4-2.1,1.4.4,1.7.8v-.6c0-1.1-.7-1.8-1.7-1.8s-1.5.3-2,.9v-1.2c.5-.4,1.2-.7,2.2-.7,1.7,0,2.8,1,2.8,2.7ZM279.8,330.2c0-.7-.5-1.2-1.4-1.2s-1.4.5-1.4,1.2.5,1.2,1.4,1.2,1.5-.5,1.5-1.2Z"
        />
        <path
          d="M286.5,326.7h-1.8v5.5h-1.2v-5.5h-1.6v-1h1.6v-1.6l1.2-.4v2h1.8v1Z"
        />
        <path
          d="M296.4,328.2v4.1h-1.2v-3.8c0-1.3-.4-1.8-1.5-1.8s-1.8.8-1.8,2.1v3.5h-1.2v-9.4h1.2v3.9c.4-.8,1.1-1.2,2.2-1.2s2.3,1,2.3,2.6Z"
        />
        <path
          d="M297.9,329c0-1.9,1.2-3.4,3.2-3.4s3.2,1.5,3.2,3.4-1.2,3.4-3.2,3.4-3.2-1.5-3.2-3.4ZM303,329c0-1.4-.7-2.4-2-2.4s-1.9,1-1.9,2.4.7,2.4,1.9,2.4,2-1,2-2.4Z"
        />
        <path
          d="M314.6,328v4.2h-1.2v-4.1c0-1.1-.4-1.6-1.2-1.6s-1.4.6-1.4,1.4v4.2h-1.2v-4.2c0-.9-.5-1.4-1.3-1.4s-1.4.7-1.4,1.7v4h-1.2v-6.5h1.2v1.1c.4-.8,1-1.3,1.8-1.3s1.5.5,1.8,1.2c.4-.8,1-1.2,1.9-1.2,1.3,0,2.1.9,2.1,2.4Z"
        />
        <path
          d="M322.1,329.2h-4.7c.1,1.4,1,2.1,2.4,2.1s1.6-.3,2.1-.7v1.1c-.5.4-1.3.7-2.2.7-2.1,0-3.5-1.4-3.5-3.5s1.1-3.4,3.2-3.4,2.8,1,2.8,2.8v.9ZM317.4,328.3h3.5c0-1.1-.7-1.7-1.7-1.7s-1.7.7-1.9,1.7Z"
        />
        <path d="M323.7,330.7h1.5l-1.2,3.5h-.9l.6-3.5Z" />
        <path
          d="M330,331.6v-1.1c.6.5,1.4.9,2.3.9s1.3-.3,1.3-1-.2-.7-.8-.9l-1.2-.4c-1.1-.3-1.5-1-1.5-1.8s.9-1.8,2.4-1.8,1.5.3,2.1.6v1.2c-.6-.5-1.3-.7-2.1-.7s-1.2.3-1.2.8.3.7.8.8l1.2.3c1.2.3,1.6,1,1.6,1.9s-1,2.1-2.4,2.1-1.7-.2-2.4-.8Z"
        />
        <path
          d="M335.8,329c0-2,1.4-3.4,3.4-3.4s1.6.2,2,.5v1.3c-.6-.5-1.2-.7-2-.7-1.4,0-2.2,1-2.2,2.3s.8,2.4,2.4,2.4,1.4-.3,1.9-.7v1.2c-.6.4-1.3.6-2.1.6-2,0-3.4-1.5-3.4-3.5Z"
        />
        <path
          d="M348.4,328.2v4.1h-1.2v-3.8c0-1.3-.4-1.8-1.5-1.8s-1.8.8-1.8,2.1v3.5h-1.2v-9.4h1.2v3.9c.4-.8,1.1-1.2,2.2-1.2s2.3,1,2.3,2.6Z"
        />
        <path
          d="M349.9,329c0-1.9,1.2-3.4,3.2-3.4s3.2,1.5,3.2,3.4-1.2,3.4-3.2,3.4-3.2-1.5-3.2-3.4ZM355,329c0-1.4-.7-2.4-2-2.4s-1.9,1-1.9,2.4.7,2.4,1.9,2.4,2-1,2-2.4Z"
        />
        <path
          d="M357.4,329c0-1.9,1.2-3.4,3.2-3.4s3.2,1.5,3.2,3.4-1.2,3.4-3.2,3.4-3.2-1.5-3.2-3.4ZM362.5,329c0-1.4-.7-2.4-2-2.4s-1.9,1-1.9,2.4.7,2.4,1.9,2.4,2-1,2-2.4Z"
        />
        <path d="M365.3,322.9h1.2v9.4h-1.2v-9.4Z" />
        <path d="M368.6,330.7h1.5l-1.2,3.5h-.9l.6-3.5Z" />
        <path
          d="M271.2,344.3v4h-1.2v-.9c-.3.7-1,1.1-1.8,1.1-1.3,0-2.3-.9-2.3-2.1s1-2.1,2.4-2.1,1.4.4,1.7.8v-.6c0-1.1-.7-1.8-1.7-1.8s-1.5.3-2,.9v-1.2c.5-.4,1.2-.7,2.2-.7,1.7,0,2.8,1,2.8,2.7ZM270,346.2c0-.7-.5-1.2-1.4-1.2s-1.4.5-1.4,1.2.5,1.2,1.4,1.2,1.5-.5,1.5-1.2Z"
        />
        <path
          d="M278.7,344.2v4.1h-1.2v-3.8c0-1.3-.4-1.8-1.5-1.8s-1.8.8-1.8,2.1v3.5h-1.2v-6.5h1.2v1.1c.4-.8,1.1-1.3,2.2-1.3s2.3,1,2.3,2.6Z"
        />
        <path
          d="M286.5,338.9v9.4h-1.2v-1.3c-.4.8-1,1.5-2.2,1.5s-2.9-1.4-2.9-3.4,1.3-3.5,3-3.5,1.7.4,2.1,1.3v-4h1.2ZM285.3,344.9c0-1.4-.7-2.3-2-2.3s-2,1-2,2.4.8,2.3,1.9,2.3,2-1,2-2.4Z"
        />
        <path
          d="M300.8,341.7l-2.1,6.5h-1.1l-1.6-5.2-1.7,5.2h-1.1l-2-6.5h1.3l1.3,4.8,1.5-4.8h1.3l1.5,4.8,1.4-4.8h1.2Z"
        />
        <path
          d="M301.5,345c0-1.9,1.2-3.4,3.2-3.4s3.2,1.5,3.2,3.4-1.2,3.4-3.2,3.4-3.2-1.5-3.2-3.4ZM306.6,345c0-1.4-.7-2.4-2-2.4s-1.9,1-1.9,2.4.7,2.4,1.9,2.4,2-1,2-2.4Z"
        />
        <path
          d="M313,341.9v1.1c-.3-.2-.7-.3-1-.3-.8,0-1.4.7-1.4,2v3.5h-1.2v-6.5h1.2v1.3c.3-.9.9-1.4,1.6-1.4s.6,0,.9.3Z"
        />
        <path
          d="M318.2,348.2l-2.8-3.2v3.2h-1.2v-9.4h1.2v5.5l2.5-2.7h1.6l-3,2.9,3.2,3.6h-1.6Z"
        />
        <path d="M320.5,347.5c0-.5.4-.9.9-.9s.9.4.9.9-.4.9-.9.9-.9-.4-.9-.9Z" />
      </g>
    </svg>
  </section>
</template>

<script>
export default {
  name: 'EmbedGrantChart0',
  data: () => {
    return {
      Land_Nature: false,
      Healthy_Diet: false,
      Education_Career_Readiness: false,
      Sport_Physical_Activity: false
    };
  },
  computed: {
    basePicto() {
      return this.Land_Nature ||
        this.Healthy_Diet ||
        this.Education_Career_Readiness ||
        this.Sport_Physical_Activity
        ? 'opacity-0'
        : 'opacity-100';
    },
    displayPicto() {
      return item => {
        return item ? 'opacity-100' : 'opacity-0';
      };
    },
    textOn() {
      return item => {
        return item ? 'text-on' : '';
      };
    }
  }
};
</script>

<style lang="postcss">
.embed-grant-chart-1 {
  svg {
    .circle {
      pointer-events: visibleFill;
      @apply cursor-pointer;
      &__text {
        @apply pointer-events-none;
      }
      circle {
        transition-property: fill;
        transition-duration: 250ms;
        transition-timing-function: cubic-bezier(0.65, 0, 0.35, 1);
        fill: transparent;
        &:hover {
          fill: #b9bffa;
        }
      }
    }
    .centre {
      fill: transparent;
      transition-property: fill;
      transition-duration: 250ms;
      transition-timing-function: cubic-bezier(0.65, 0, 0.35, 1);
      &.active {
        fill: #b9bffa;
      }
      &-illustration {
        transition-property: opacity;
        transition-duration: 250ms;
        transition-timing-function: cubic-bezier(0.65, 0, 0.35, 1);
      }
      &-text {
        transition-property: opacity;
        transition-duration: 250ms;
        transition-timing-function: cubic-bezier(0.65, 0, 0.35, 1);
      }
    }
    .text-on {
      fill: white;
    }
  }
}

.stroke {
  fill: none;
  stroke: #6171f3;
  stroke-width: 1.7px;
}

.fill {
  fill: #b8beff;
}

.white {
  fill: #fff;
  stroke: #6171f3;
  stroke-width: 1.7px;
}

.inactive {
  opacity: 0;
  cursor: pointer;
}

.no-pointer {
  pointer-events: none;
}

g,
path {
  transition-property: all;
  transition-duration: 250ms;
  transition-timing-function: cubic-bezier(0.65, 0, 0.35, 1);
}
</style>
